const translations = {
    admin: "ადმინი",
    a_z: "ა-ზ სორტირება",
    added: "დამატებულია",
    archive: "არქივი",
    absent: "არ არის",
    start_application: "განაცხადის დაწყება",
    are_you_sure_you_want_to_change_the_status_quo: "დარწმუნებული ხართ, რომ გსურთ არსებული მდგომარეობის შეცვლა?",
    are_you_sure_to_payment_timeout: "დარწმუნებული ხართ, რომ გსურთ განაახლოთ როგორც ვადაგასული?",
    are_you_sure_to_close_payment: "დარწმუნებული ხართ, რომ გსურთ გადახდის დახურვა?",
    absence_success_updated: "სიის მიხედვით შეგიძლიათ იხილოთ წარმატებული ან წარუმატებელი სტუდენტები",
    achievement_ranking_control: "წარმატების რეიტინგის კონტროლი",
    attachment_cut_form: "კავშირის გაწყვეტის ფორმა",
    attachment_cut_form_pdf: "კავშირის-გაწყვეტის-ფორმა",
    absence_report: "ჰაზრობის ანგარიში",
    abroad_application: "საზღვარგარეთ განაცხადი",
    abroad: "საზღვარგარეთ",
    available_chairs: "თავისუფალი სკამები",
    create_on_onexa:"შექმნა onexa-ზე",
    academic_unit_office: "აკადემიური ერთეულის ოფისი",
    academic_year: "სასწავლო წელი",
    academic_season_term_applied: "განაცხადებული აკადემიური სეზონი-სემესტრი",
    acceptance_data: "მიღების მონაცემები",
    acceptance_date: "მიღების თარიღი",
    accepttance_status: "მიღების სტატუსი",
    accepttance_not_accepted: "არ იქნა მიღებული",
    allergy_information:"ინფორმაცია ალერგიის შესახებ",
    accepted: "მიღებულია",
    academic_advisor_approval_date: "აკადემიური მრჩევლის დამტკიცების თარიღი",
    academic_advisor_approval: "აკადემიური მრჩევლის დამტკიცება",
    account_code: "ანგარიშის კოდი",
    account_holder: "ანგარიშის მფლობელი",
    account_information: "ანგარიშის ინფორმაცია",
    account_number: "ანგარიშის ნომერი",
    action: "ქმედება",
    active: "აქტიური",
    active_semester: "აქტიური სემესტრი",
    activate_graduate_email: "დამამთავრებელი ელფოსტის აქტივაცია",
    achievement_ranking_of_intermediate_class: "შუალედური კლასის წარმატების რეიტინგი",
    adaptation_request: "შესაბამისობის მოთხოვნები",
    approve_1: "დამტკიცება",
    attendance_detail: "დასწრების დეტალი",
    attendance_entry: "დასწრების ჩანაწერი",
    attendance_requirement: "დასწრების ვალდებულება",
    attendees_for_refreshments: "სასმელების მონაწილეთა რაოდენობა",
    attended_the_exam: "გამოცდას დაესწრო",
    available_roles: "ხელმისაწვდომი როლები",
    available: "ხელმისაწვდომია",
    add: "დამატება",
    add_all_student_without_payment_approval: "გადახდის დამტკიცების გარეშე სტუდენტების გადატანა",
    add_bank_credit: "საბანკო კრედიტის დამატება",
    add_course: "კურსის დამატება",
    add_course_transfer: "კურსის გადატანის დამატება",
    add_discount: "ფასდაკლების დამატება",
    add_education_credit: "საგანმანათლებლო სესხის დამატება",
    add_exam_score: "გამოცდის ქულის დამატება",
    add_module: "მოდულის დამატება",
    add_new_course: "ახალი კურსის დამატება",
    add_offset: "დარიცხვის დამატება",
    add_offset_payment: "დარიცხვის გადარიცხვა",
    add_option: "ოპციის დამატება",




    add_payment: "გადახდის დამატება",
    add_payment_plan: "გადახდის გეგმის შექმნა",
    add_pdf: "Pdf დამატება",
    add_preference: "პრივილეგიის დამატება",
    add_preference1: "პრივილეგიის დამატება",
    add_refund: "დაბრუნების დამატება",
    add_scholarship: "სტიპენდიის დამატება",
    add_slot: "სლოტის დამატება",
    announcement_entry: "განცხადების შეტანა",
    f: "შიგთავსის დამატება",
    add_student_number: "სტუდენტის ნომრის დამატება",
    added_by: "დამატებული პირის მიერ",
    added_course_transfer: "შესაბამისობის ოპერაციები",
    added_date: "დამატების თარიღი",
    additional_lecturer: "დამატებითი სასწავლო პერსონალი",
    additional_lecturers: "დამატებითი სასწავლო პერსონალი",
    address: "მისამართი",
    address_2: "სრული მისამართი",
    address_en: "მისამართი (EN)",
    address_information: "მისამართის ინფორმაცია",
    address_update: "მისამართის განახლება",
    advance_payment: "წინასწარი გადახდა",
    advance_amount: "ავანსის თანხა",
    advisor: "კონსულტანტი",
    advisor_approved: "{advisor} დამტკიცება",
    advisor_: "კონსულტანტი",
    advisor_id: "კონსულტანტის ID",
    advisor_name: "კონსულტანტის სახელი",
    advisor_of_project: "პროექტის კონსულტანტი",
    advisor_of_thesis: "დისერტაციის კონსულტანტი",
    advisor_surname: "კონსულტანტის გვარი",
    advisored_of_students: "სტუდენტები, რომელთა მრჩეველიც ვარ",
    affiliated_curriculum: "შესაბამისი სასწავლო გეგმა",
    already_available: "უკვე ხელმისაწვდომია",
    align: "Align",
    all: "ყველა",
    all_exam_scores: "ყველა გამოცდის ქულა",
    all_students: "ყველა სტუდენტი",
    allow_classroom_overlap: "კლასის გადაკვეთის ნებართვა",
    allow_instructor_overlap: "ინსტრუქტორის გადაკვეთის ნებართვა",
    alumni: "კურსდამთავრებული",
    alumni_information_form: "კურსდამთავრებულის ინფორმაციის ფორმა",
    alumni_information_form_pdf: "კურსდამთავრებულის-ინფორმაციის-ფორმა",
    alumni_card_status: "კურსდამთავრებულის ბარათის სტატუსი",
    allow: "ნებართვა",
    allow_epayment: "გაქვთ ნებართვა ელექტრონულ გადახდაზე?",
    allow_vinov: "გაქვთ Vinov-ის ნებართვა?",
    amount: "თანხა",
    amount1: "თანხა 1",
    amount2: "თანხა 2",
    amount3: "თანხა 3",
    amount4: "თანხა 4",
    acceptance_letter_id: "მიღების წერილის Id",
    amount_paid: "გადახდილი თანხა",
    amount_tl: "თანხა (TL)",
    amount_to_be_paid: "გადასახდელი თანხა",
    and: "და",




    announcement: "განცხადებები",
    api_config: "API კონფიგურაცია",
    application_conditions: "განაცხადის პირობები",
    application_completion_status: "დასრულების სტატუსი",
    application_date: "განაცხადის თარიღი",
    application_date_hour: "განაცხადის თარიღი და დრო",
    application_follow_link: "განაცხადის თვალყურის ლინკი",
    application_information: "განაცხადის ინფორმაცია",
    application_new: "ახალი განაცხადი",
    application_period: "სემესტრები, რომელთა გაყინვაც მოითხოვა",
    application_rules: "განაცხადის წესები",
    application_status: "განაცხადის სტატუსი",
    application_status_reset_are_you_sure: "დარწმუნებული ხართ, რომ გსურთ განაცხადის სტატუსის განულება?",
    application_status_update: "განაცხადის სტატუსის განახლება",
    application_delete: "განაცხადის წაშლა",
    application_approve: "განაცხადის დამტკიცება",
    application_approval_process_successful: "განაცხადის დამტკიცების პროცესი წარმატებულია",
    application_reject: "განაცხადის უარყოფა",
    application_send: "განაცხადის გაგზავნა",
    application_send_waiting: "განაცხადის გაგზავნა გელოდებათ",
    application_success: "თქვენი განაცხადი დასრულდა",
    application_success_info: "თქვენი განაცხადი დასრულდა. თქვენი Pin კოდი: $$$$. განაცხადის თვალყურისდევნებისთვის, გთხოვთ გამოიყენოთ Pin კოდი ქვემოთ მოცემულ „განაცხადის თვალყურის ლინკზე“",
    application_summary: "განაცხადის შეჯამება",
    application_system: "განაცხადის სისტემა",
    application_type: "განაცხადის ტიპი",
    application_types: "განაცხადის ტიპები",
    application_update_success: "თქვენი განაცხადი წარმატებით განახლდა",
    application_withdraw_display: "განაცხადის გაუქმების ეკრანი",
    applications: "განაცხადები",
    application: "განაცხადი",
    application_result: {
        placed: "განთავსდა",
        other_preference_placed: "სხვა პრეფერენციაში განთავსდა",
        not_placed: "არ განთავსდა",
        registered: "რეგისტრაცია დასრულდა"
    },
    application_status_reset: "განაცხადის განულება",
    applied_faculty: "განაცხადებული ფაკულტეტი",
    applied_program: "განაცხადებული პროგრამა",
    apply: "განაცხადე",
    apply_cash_discount: "ნაღდი ფასდაკლების გამოყენება",
    apply_scholarship: "სტიპენდიის გამოყენება",
    approval_phase: "დამტკიცების ფაზა",
    approval_procedures: "დამტკიცების პროცედურები",
    approval_registration_succes_msg: "ონლაინ რეგისტრაცია წარმატებით დასრულდა",
    approval_status: "დამტკიცების სტატუსი",
    approve: "დამტკიცება",
    approve1: "დამტკიცება",
    approve_or_reject_confirm: "გსურთ ოპერაციის დამტკიცება?",
    approve_step: "დამტკიცების ეტაპი",
    approve_step_error: "უნდა შეიყვანოთ დამტკიცების ეტაპი",
    approval_template: "დამტკიცების ეტაპის შაბლონი",
    approved: "დამტკიცებულია",
    approved_by: "დამტკიცებული პირის მიერ",
    approved_date: "დამტკიცების თარიღი",
    approved_go: "გაგზავნა დამტკიცებისთვის",
    approvers: "დამმტკიცებლები",
    approver: "დამმტკიცებელი",
    apply_to: "გამოყენება",
    are_you_sure_to_apply: "დარწმუნებული ხართ, რომ გსურთ განაცხადის პროცესის დაწყება?",
    are_you_sure_to_cancel: "დარწმუნებული ხართ, რომ გსურთ გაუქმება?",
    are_you_sure_to_rollback_cancel: "დარწმუნებული ხართ, რომ გსურთ გაუქმების დაბრუნება?",
    are_you_sure_to_exam_score_calculate: "დარწმუნებული ხართ, რომ გსურთ გამოცდის ქულის გამოთვლა?",
    are_you_sure_to_set_active: "დარწმუნებული ხართ, რომ გსურთ განაახლოთ როგორც აქტიური ეტაპი?",
    are_you_sure_to_status_approved: "გსურთ სტატუსის დამტკიცება?",
    are_you_sure_to_restore_preference: "დარწმუნებული ხართ, რომ გსურთ პრეფერენციის განულება?",
    are_you_sure_to_create_a_new_proforma_invoice: "დარწმუნებული ხართ, რომ გსურთ ახალი პროფორმა ინვოისის შექმნა?",
    are_you_sure_to_copy: "დარწმუნებული ხართ, რომ გსურთ კოპირება?",
    are_you_sure_to_delete: "დარწმუნებული ხართ, რომ გსურთ წაშლა?",
    are_you_sure_to_approve: "დარწმუნებული ხართ, რომ გსურთ დამტკიცება?",
    are_you_sure_to_reject: "დარწმუნებული ხართ, რომ გსურთ უარყოფა?",
    are_you_sure_to_give_exceptional_payment_approval: "დარწმუნებული ხართ, რომ გსურთ განსაკუთრებული გადახდის ნებართვის მიცემა?",
    are_you_sure_to_move: "დარწმუნებული ხართ, რომ გსურთ გადაადგილება?",
    are_you_sure_to_remove_exceptional_payment_approval: "დარწმუნებული ხართ, რომ გსურთ განსაკუთრებული გადახდის ნებართვის მოხსნა?",
    are_you_sure_to_send: "დარწმუნებული ხართ, რომ გსურთ გაგზავნა?",
    are_you_sure_to_withdraw: "დარწმუნებული ხართ, რომ გსურთ კურსის უკან გამოთხოვა?",
    are_you_sure_to_cancel_loa_discount_rate: "დარწმუნებული ხართ, რომ გსურთ რეგისტრაციის გაყინვის ფასდაკლების გაუქმება?",
    are_you_sure_want_save: "დარწმუნებული ხართ, რომ გსურთ შენახვა?",
    are_you_sure_you_want_to_take_the_x_course: "დარწმუნებული ხართ, რომ გსურთ '{course_code}'-'{course_name}' კურსის აღება?",
    are_you_sure_you_want_to_update_the_approval_status: "დარწმუნებული ხართ, რომ გსურთ დამტკიცების სტატუსის განახლება?",
    are_you_sure_you_want_to_complete_course_transfer: "დარწმუნებული ხართ, რომ გსურთ ინტიბაკის ოპერაციის დასრულება?",
    are_you_sure_want_course_language: "დარწმუნებული ხართ, რომ გსურთ კურსის ენა {0}-ზე?",
    are_you_sure_to_take_on_this_application: "დარწმუნებული ხართ, რომ გსურთ განაცხადის ხელში აღება?",
    are_you_sure_to_release_this_application: "დარწმუნებული ხართ, რომ გსურთ განაცხადის გათავისუფლება?",
    are_you_sure_to_ticket_approved: "განაცხადს ამტკიცებთ?",
    asal: "ASAL მოთხოვნების სია",
    asal_delay_reasons: "მოთხოვნის მიზეზი",
    asal_maximum_time_reasons: "მაქსიმალური დროის გაზრდის ფაქტორი",
    asal_type: "მოთხოვნის ტიპი",
    asal_information: "ASAL ძიება",
    asynchronous: "ასინქრონული",
    add_content: "შიგთავსის დამატება",
    at_which_unit: "რომელ ერთეულში",
    attendance_date: "დასწრების თარიღი",
    attendance_create: "დასწრების დამატება",
    attendance_status: "დასწრების სტატუსი",
    attendance_update: "დასწრების განახლება",
    attendance_hours: "დასწრების ინფორმაცია",
    attendance_list: "დასწრების სია",
    attendees: "მონაწილეები",
    attention: "გაფრთხილება",
    attention_for_thesis_and_project: "კურსის არჩევის პერიოდში უნდა აიღოთ თეზისი 1-სემინარი/პროექტი/კვალიფიკაციის კურსი.",
    authorizations: "უფლებები",
    autumn: "შემოდგომა",
    available_hours: "ხელმისაწვდომი საათები",
    average_price_report:"ანგარიში საშუალო ხელფასის შესახებ",
    average_system_100: "100-ქულიანი სისტემა",
    average_system_4: "4-ქულიანი სისტემა",
    add_description: "აღწერის დამატება",
    are_you_sure_to_start_process: "დარწმუნებული ხართ, რომ გსურთ პროცესის დაწყება?",
    are_you_sure_make_application: "დარწმუნებული ხართ, რომ გსურთ განაცხადის გაგზავნა?",
    auto_course_registration: "კურსის ავტომატური რეგისტრაცია",
    auto_repeat_course_registration: "კურსის ავტომატური გამეორების რეგისტრაცია",
    auto_irregular_course_registration: "კურსის ავტომატური არარეგულარული რეგისტრაცია",
    answerable: "პასუხის სტატუსი",
    answer_force: "უპასუხე",
    answer: "პასუხი",



    active_semester_no: "აქტიური სემესტრის ნომერი",
    assign_doesnt_have_payment_approval: "განაახლე ისინი, ვინც რეგისტრაცია არ გაიტანა",
    assign_doesnt_have_course_registration: "განაახლე ისინი, ვინც კურსზე არ დარეგისტრირდა",
    attended: "მოხვდა",
    approve_sms: "SMS დადასტურება",
    approve_email: "ელ-ფოსტის დადასტურება",
    approve_call: "ზარის დადასტურება",
    action_title: "ქმედება",
    application_images: "განაცხადის სურათები",
    application_message: "თქვენი განაცხადი მიღებულია. თუ შეფასების კრიტერიუმების ფარგლებში უარყოფილი იქნება, ინფორმაცია ელფოსტით გამოგიგზავნებათ. დამტკიცების შემთხვევაში, ბილეთი ერთ კვირაში ელფოსტით გადმოგიგზავნებათ.",
    alternative_tel: "ალტერნატიული ტელეფონი",
    application_successfully_sent: "თქვენი განაცხადი წარმატებით გაიგზავნა.",
    add_info_manuel: "მინდა დავამატო სიის გარეთ არსებული საგანმანათლებლო ინფორმაცია",
    add_exam_info_manuel: "მინდა დავამატო სიის გარეთ არსებული გამოცდის ინფორმაცია",
    admission_requirements: "მიღების პირობები",
    access_to_further_studies: "შემდეგ საფეხურზე გადასვლა",
    academic_advisor: "აკადემიური მრჩეველი",
    add_note: "შენიშვნის დამატება",
    academic: "აკადემიური",
    are_you_sure_online_registration: "დარწმუნებული ხართ, რომ გსურთ თქვენი მიღებული პროგრამის საბოლოო რეგისტრაციის შესრულება?",
    attended_university: "სტუდირებული უნივერსიტეტი",
    academic_information: "აკადემიური ინფორმაცია",
    associate_professor_field: "დოცენტის სფერო",
    activity_count: "აქტივობების რაოდენობა",
    add_date: "თარიღის დამატება",
    add_new: "ახლის დამატება",
    application_group: "განაცხადის ჯგუფი",
    authorized_approvers: "დამმტკიცებლები",

    back: "უკან",
    bahcesehir_university: "ბაჰჩეშეჰირის უნივერსიტეტი",
    bahcesehir_accommodation_and_tourism: "Bahçeşehir განთავსება და ტურიზმის ინვესტიციები A.Ş.",
    balance: "ბალანსი",
    back_side:"უკანა მხარე",
    balance_overflow: "თქვენ შეიყვანეთ ბალანსზე მეტი თანხა",
    balance_report: "ბალანსის ანგარიში",
    bank: "ბანკი",
    banks: "ბანკები",
    bank_additional_installment: "ბანკის დამატებითი განვადება",
    bank_credit: "KHM",
    before_turkish_certificate: "თურქული ენის სერტიფიკატი",
    bank_credit_cash: "KHM ნაღდი",
    bank_id: "ბანკის კოდი",
    bank_name: "ბანკის სახელი",
    bulk_certificate_submission: "სერტიფიკატების მასობრივი გაგზავნა",
    bulk_student_transfer: "სტუდენტების მასობრივი გადატანა",
    bulk_student_slot_update: "სტუდენტების სლოტის მასობრივი განახლება",
    bulk_registration_document_download:"მასობრივი რეგისტრაციის დოკუმენტის ჩამოტვირთვა",
    bulk_yoksis_freeze_registration_data_transfer: "YÖKSİS რეგისტრაციის გაყინვის მონაცემების მასობრივი გადატანა",
    bank_receipts: "დეკონტები",
    bank_receipt: "დეკონტი",
    batch_gno_calculation: "GNO-ს მასობრივი გამოთვლა",
    batch_update_due_date: "საგადახდო თარიღის მასობრივი განახლება",
    batch_course_term_information_update: "კურსის სემესტრის ინფორმაციის მასობრივი განახლება",
    bau_grade_conversion: "BAU ქულის გადაყვანა",
    bau_grades: "BAU ქულები",
    bulk_section_update:"ნაყარი განყოფილების განახლება",

    bau_language_exam_info: "(BAU ინგლისური ენის საკმარისობის გამოცდა დოქტორის პროგრამების განაცხადებში არ მიიღება.)",
    bau_language_exam_question: "შეძლებთ თუ არა BAU ინგლისური ენის საკმარისობის გამოცდაში ჩაბარებას?",
    bau_student: "BAU სტუდენტი",
    bau_student_application: "BAU სტუდენტის განაცხადი",
    before_leave_of_absence: "ადრე გქონდათ თუ არა რეგისტრაციის გაყინვა?",
    birthdate: "დაბადების თარიღი",
    birth_date: "დაბადების თარიღი (YYYY-mm-dd)",
    birthplace: "დაბადების ადგილი",
    board_decision: "საბჭოს გადაწყვეტილება",
    board_decisions: "საბჭოს გადაწყვეტილებები",
    board_members: "საბჭოს წევრები",
    board_types: "რიგის ტიპი",
    bonus_course_credit_limit: "ბონუს კურსის კრედიტის ლიმიტი",
    branch_name: "ფილიალის სახელი",
    branch_type: "ფილიალის ტიპი",
    browse: "დათვალიერება",
    blood_group:"სისხლის ჯგუფი",
    building: "შენობა",
    building_id: "შენობის კოდი",
    bulk_delete:"მასობრივი წაშლა",
    bulk_document_creation: "დოკუმენტების მასობრივი შექმნა",
    bulk_graduation: "დიპლომის მასობრივი პროცედურები",
    buy: "შეძენა",
    batch_score_entry: "ქულების მასობრივი შეყვანის ეკრანი",
    batch_score_entry_note: "ქულების მასობრივი შეყვანა",
    batch_score_entry_info: "ქულების მასობრივი შეყვანის ეკრანი შეინახება. გსურთ პროცესის დამტკიცება?",
    birthdate_from: "დაბადების თარიღი (საწყისი)",
    birthdate_to: "დაბადების თარიღი (ბოლო)",
    branch: "დარგი",
    bulk_translation: "მასობრივი თარგმანი",
    bulk_quota_assignment: "მასობრივი კვოტის მინიჭება",
    bulk_contact_information_update: "საკონტაქტო ინფორმაციის მასობრივი განახლება",
    science_field: "მეცნიერების სფერო",
    budget: "ბიუჯეტი",
    budget_items: "ბიუჯეტის მუხლები",
    blue_card_expiry_date:"ლურჯი ბარათის მოქმედების ვადა",
    blue_card_issue_date:"ლურჯი ბარათის გაცემის თარიღი",
    bulk_file_download_btn: "T.ფაილი.ჩამო",
    before_placed: "ადრე თუ ოდესმე მოეწყეთ უმაღლეს საგანმანათლებლო პროგრამაში?",

    calculate: "გამოთვლა",
    calculated_cgpa: "გამოთვლილი GNO",
    calculated_gpa: "გამოთვლილი DNO",
    calculate_refund: "დაბრუნების გამოთვლა",
    calculate_number_of_semesters: "სემესტრების რაოდენობის გამოთვლა",
    no_students_enrolled_in_the_course: "კურსზე დარეგისტრირებული სტუდენტი ვერ მოიძებნა!",
    campus: "კომპუსი",
    campus_address: "კომპუსის მისამართი",
    campus_id: "კომპუსის კოდი",
    campus_name: "კომპუსის სახელი",
    can_approvers: "დამმტკიცებლები",
    cars: "მანქანა",
    car_brands: "მანქანის ბრენდები",
    car_brand: "მანქანის ბრენდი",
    car_models: "მანქანის მოდელები",
    car_model: "მანქანის მოდელი",
    can_be_repeated: "შესაძლებელია განმეორება?",
    can_take_same_semester: "შეუძლია იგივე სემესტრში აღება",
    can_not_empty_classrooms: "კლასების სია ცარიელი ვერ გაიგზავნება.",
    cancel: "გაუქმება",
    cancel_application: "განაცხადიდან უარის თქმა",
    cancel_to_move: "გადატანის გაუქმება!",
    cancellation: "გაუქმება",
    cancellation_amount: "გაუქმების თანხა",
    course_outcomes: "კურსის შედეგები",
    course_registration_rule: "კურსზე რეგისტრაციის წესი",
    cancelled: "გაუქმებულია",
    cancelled_payment_report: "გაუქმებული ჩეკის / ვალის ანგარიშგება",
    cannot_overflow_balance: "შეიძლება მხოლოდ ვალის ოდენობის გადახდა",
    capacity: "ტევადობა",
    card_holder_address: "ბარათის მფლობელის მისამართი",
    card_holder_name: "ბარათის მფლობელი",
    card_holder_phone: "ბარათის მფლობელის ტელეფონი",
    card_name: "ბარათის სახელი",
    card_name_en: "ბარათის სახელი (EN)",
    card_no: "ბარათის ნომერი",
    card_number: "ბარათის ნომერი",
    card_owner: "ბარათის მფლობელი",
    card_status: "ბარათის სტატუსი",
    card_type: "ბარათის ტიპი",
    cash: "ნაღდი",
    cash_price: "ნაღდი ფასი",
    cash_collection_report: "ნაღდი ბიუჯეტის ანგარიში",
    cash_discount_rate: "ნაღდი ფასდაკლების პროცენტი",
    cash_discount_rate_certificate: "ნაღდი ფასდაკლების სერტიფიკატი",
    cash_in_advance: "ნაღდი",
    cash_or_installed: "ნაღდი/განვადებით",
    cash_payment: "ნაღდი",
    cash_payment_type: "ნაღდი გადახდის ტიპი",
    car_reservations: "მანქანის დაჯავშნები",
    category: "კატეგორია",
    cert_type: "დოკუმენტის ტიპი",
    course_program_outcomes: "კურსის პროგრამის შედეგები",
    certified: "სერტიფიცირებული",
    noncertified: "უსერტიფიკატო",
    course_assessment: "კურსის შეფასება",
    course_activity: "კურსის აქტივობა",
    certificate: "სერტიფიკატი",
    certificate_application: "სერტიფიკატის განაცხადი",
    certificate_center: "სერტიფიკატების ცენტრი",
    certificate_centers: "სერტიფიკატების ცენტრები",
    certificate_centers_certificate: "სერტიფიკატების ცენტრების სერტიფიკატები",
    certificate_id: "სერტიფიკატის სახელი",
    certificate_center_id: "სერტიფიკატის ცენტრის Id",
    course_agreement: "კურსის შეთანხმება",
    course_transfer_total_ects_credit:"ადაპტირებული კურსის დარიცხვების ჯამი",
    certificates_id: "სერტიფიკატის Id",
    certificate_information: "სერტიფიკატის ინფორმაცია",
    certificate_name: "სერტიფიკატის სახელი",
    certificate_name_en: "სერტიფიკატის სახელი En",
    certificate_show: "სერტიფიკატის ჩვენება",
    certificate_person: "სერტიფიკატის პირი",
    certificate_persons: "მონაწილე",
    certificates_name: "სახელი",
    certificate_payments_report: "სერტიფიკატის გადახდის ანგარიში",



    cgpa: "GNO",

    change: "შეცვლა",
    change_your_password: "შეცვალე შენი პაროლი",
    change_price: "ფასის შეცვლა",
    change_section: "სექციის შეცვლა",
    search_section: "სექციის ძიება",
    change_student_group_radio: "სტუდენტთა ჯგუფის შეცვლა",
    change_user: "მომხმარებლის შეცვლა",
    changes_will_be_saved: "ცვლილებები შეინახება. ამტკიცებთ?",
    check: "ჩეკი",
    course_topics: "კურსის თემები",
    check_drawer: "გადამხდელი",
    credit_limit_control_report: "საკრედიტო ლიმიტის კონტროლის ანგარიში",
    check_it: "დაადასტურე",
    check_it_title: "დადასტურება",
    check_no: "ჩეკის ნომერი",
    check_payment_approval: "გადახდის დამტკიცების შემოწმება",
    choose_student_type_confirm_text: "ახალი რეგისტრაციის არჩევა:",
    choose: "აირჩიე",
    chose_your_double_major: "აირჩიე შენი ორმაგი სპეციალობა",
    cities: "ქალაქები",
    city: "ქალაქი",
    city_id: "ქალაქი",
    citizenship_registration_date:"მოქალაქეობის რეგისტრაციის თარიღი",
    city_name: "ქალაქის მოსახლეობა",
    clarification_text: "განმარტების ტექსტი",
    classroom_spaces:"სასწავლო სივრცეები",
    class: "კლასი",
    classrate: "კლასის პროცენტული მაჩვენებელი",
    class_average: "კლასის საშუალო ქულა",
    class_applied: "განაცხადებული კლასი",
    class_settings: "კლასის პარამეტრები",
    class_x: "%{class}. კლასი",
    classroom: "სასწავლო ოთახი",
    classroom_list: "სასწავლო ოთახების სია",
    classroom_: "სასწავლო ოთახი",
    classroom_id: "სასწავლო ოთახის ID",
    classroom_name: "სასწავლო ოთახის სახელი",
    classroom_programs: "სასწავლო ოთახის პროგრამა",
    classroom_types: "სასწავლო ოთახის ტიპი",
    classrooms: "სასწავლო ოთახები",
    classroom_not_selected: "სასწავლო ოთახი არჩეული არაა",
    clear: "გასუფთავება",
    click_to_choose: "აირჩიეთ დააჭირეთ.",
    close: "დახურვა",
    closing_date: "დახურვის თარიღი",
    close_edit_at: "ოპერაციის დახურვის თარიღი",
    close_lessons_only: "მხოლოდ გაკვეთილების დახურვა",
    club: "კლუბი",
    club_votes: "კლუბის ხმის მიცემები",
    code: "კოდი",
    coefficient: "BAU ქულის კოეფიციენტი",
    course_application_evaluation: "კურსის განაცხადის შეფასება",
    collection: "ინკასო",
    collection_bank: "ინკასოს ბანკი",
    collection_report: "ბრუნვის და ინკასოს ანგარიში",
    create_new_examination:"ახალი გამოცდის შექმნა",
    collection_screen: "ინკასოს ეკრანი",
    collective_consultant_appointment: "კონსულტანტის მასობრივი დანიშვნა",
    collection_and_numbers_report: "დღიური რეგისტრაციის სტატისტიკა",
    collective_student_thesis_topic_determination: "სტუდენტთა დისერტაციის თემების მასობრივი განსაზღვრა",
    complete_your_payment: "დაასრულე გადახდა",
    complate_your_purchase: "დაასრულე შესყიდვა",
    clicking: "დააჭირეთ",
    columns: "სვეტები",
    do_copy: "კოპირება",
    copy_l_ol_scholarships: "ბაკალავრიატი / ასოცირებული სტიპენდიების კოპირება",
    copy_graduate_scholarships: "მაღალი საფეხურის სტიპენდიების კოპირება",
    password_contains_eight_characters_message: "თქვენი პაროლი უნდა შედგებოდეს მინიმუმ 8 სიმბოლოსგან.",
    password_contains_number_message: "თქვენს პაროლში უნდა იყოს მინიმუმ 1 რიცხვი.",
    password_contains_uppercase_message: "თქვენს პაროლში უნდა იყოს მინიმუმ 1 დიდი ასო.",
    password_contains_lowercase_message: "თქვენს პაროლში უნდა იყოს მინიმუმ 1 პატარა ასო.",
    password_contains_special_character_message: "თქვენს პაროლში უნდა იყოს მინიმუმ 1 სპეციალური სიმბოლო (!@#$%&*...).",
    password_send_success: "თქვენი პაროლი წარმატებით გაიგზავნა.",
    password_equals_message: "შეყვანილი პაროლები უნდა ემთხვეოდეს.",
    comment: "კომენტარი",
    comment_questions: "კომენტარის კითხვები",
    comment_answers: "კომენტარის პასუხები",
    communication_address: "კომუნიკაციის მისამართი",
    communication_address_2: "კომუნიკაციის მისამართი 2",
    communication_city: "კომუნიკაციის ქალაქი",
    communication_district: "კომუნიკაციის რაიონი",
    compass_dates: "კომპასის თარიღები",
    company_address: "კომპანიის მისამართი",
    company_name: "კომპანიის სახელი",
    company_name_en: "კომპანიის სახელი (ინგლისურად)",
    company_phone: "კომპანიის ტელეფონი",
    complaint_petition: "საჩივრის განცხადება",
    complete_registration: "დაასრულე რეგისტრაცია",
    completed_akts_credit: "დასრულებული AKTS კრედიტი",
    completed_credit: "დასრულებული კრედიტი",
    class_property: "კლასის თვისება",
    completed_dep_course_count: "დასრულებული DEP კურსი",
    completed_dep_credit: "დასრულებული DEP კრედიტი",
    completed_dep_ects_credit: "დასრულებული DEP AKTS",
    completed_gep_course_count: "დასრულებული GEP კურსი",
    completed_gep_credit: "დასრულებული GEP კრედიტი",
    completed_gep_ects_credit: "დასრულებული GEP AKTS",
    completed_non_dep_course_count: "დასრულებული NOND კურსი",
    completed_non_dep_credit: "დასრულებული NOND კრედიტი",
    completed_non_dep_ects_credit: "დასრულებული NOND AKTS",
    completed_required_course_count: "დასრულებული სავალდებულო კურსი",
    completed_required_credit: "დასრულებული სავალდებულო კურსის კრედიტი",
    completed_required_ects_credit: "დასრულებული სავალდებულო კურსის AKTS",
    completed_slots: "დასრულებული სლოტი",
    complimentary: "სასმელი",
    confirm: "დამტკიცება",
    confirmation: "დადასტურება",
    course_activities: "კურსის აქტივობები",
    disabled_paths: "დასამალი გვერდები",
    conflict_informations: "კონფლიქტის ინფორმაცია",
    constants: "სტაბილურები",
    contact: "კონტაქტი",
    contact_address_information: "კომუნიკაციის მისამართის ინფორმაცია",
    contact_information: "კონტაქტის ინფორმაცია",
    contact_information_reports: "კონტაქტის ინფორმაციის ანგარიში",
    contact_number: "კონტაქტის ნომერი",
    contact_support: "კონტაქტის მხარდაჭერა",
    content: "შიგთავსი",
    contents: "სერტიფიკატის შიგთავსი",
    continue: "გაგრძელება",
    close_popup_info: "ქვემოთ მოცემული დახურვის ღილაკით შეგიძლიათ დახუროთ ფანჯარა.",

    contract_type: "შრომის ტიპი",
    coop_certificate: "Coop სერტიფიკატი",
    coop_courses: "Coop კურსები",
    coopstudentcertificate: "Coop სერტიფიკატის სტუდენტის დამატება",
    coop_and_public_scholarship: "Coop და საჯარო სტიპენდია",
    coop_scholarship: "Coop სტიპენდია",
    course_selection_credit_limit: "კურსის შერჩევის საკრედიტო ლიმიტი",
    coop_scholarship_student_report: "Coop სტიპენდიით სტუდენტების ანგარიში",
    count: "რაოდენობა",
    count_number: "რიგის ნომერი",
    countries: "ქვეყნები",
    country: "ქვეყანა",
    country_code: "ქვეყნის კოდი",
    country_id: "ქვეყანა",
    course: "კურსი",
    course_assigner: "კურსის დანიშვნის პირი",
    course_agreement_form_selected_course_message: "თქვენ აპირებთ კურსის არჩევას, ადასტურებთ?",
    course_registration_date: "კურსის რეგისტრაციის თარიღი",
    course_name_en: "კურსის სახელი EN",
    certificate_upload: "გთხოვთ ატვირთოთ მიღებული სერტიფიკატი ქვემოთ მოცემულ ველში.",
    course_import_text: "კოდი, სახელი, სახელი ინგლისურად, სახელი თურქულად, კრედიტი, პრაქტიკული კრედიტი, თეორიული კრედიტი, ლაბორატორიული კრედიტი, AKTS კრედიტი, ტიპი, ენა, ფაკულტეტის კოდი, დეპარტამენტის კოდი, პროგრამის კოდი, აქტიური სტატუსი, ქულის მასშტაბი",
    course_merge_section: "კურსის გაერთიანება",
    course_code: "კურსის კოდი",
    course_code1: "კურსის კოდი",
    course_agreement_form: "კურსის შეთანხმების ფორმა",
    course_exam_type: "კურსი/გამოცდის ტიპი",
    course_coordinator: "კურსის კოორდინატორი",
    coordinator_approved: "კოორდინატორის დამტკიცება",
    course_count_to_take: "საგნების რაოდენობა",
    course_detail_title: "კურსის დეტალები",
    course_field_is_required: "საგნების ველი სავალდებულოა.",
    course_id: "კურსის Id",
    course_language: "კურსის ენა",
    course_name: "კურსის სახელი",
    course_pool_err: "კურსი უკვე აუზშია.",
    course_price: "კურსის ფასი",
    course_registration: "კურსის რეგისტრაცია",
    course_registration_reservation: "კურსის რეზერვაცია",
    course_registration_semester: "კურსის შერჩევის სემესტრი",
    course_registration_type: "კურსის რეგისტრაციის ტიპი",
    course_schedule: "კურსის განრიგი",
    course_schedule_format: "კურსის კოდი, სექცია, მომხმარებლის ID, სასწავლო ოთახი, დღე, დაწყების დრო, დასრულების დრო",
    course_schedule_from_draft: "კურსის განრიგის ავტომატური განთავსება კლასებში",
    course_schedule_will_be_created_from_draft: "კურსის განრიგი ავტომატურად განთავსდება კლასებში. დარწმუნებული ხართ?",
    course_status: "კურსის სტატუსი",
    course_transfer: "ინტიბაკი",
    course_transfer_guide: "ინტიბაკის სახელმძღვანელო",
    course_transfer_guide_filename: "Intibak-kilavuzu.pdf",
    course_transfer_evaluation: "ინტიბაკის შეფასება",
    course_transfer_success_text: "თქვენი ინტიბაკის მოთხოვნა წარმატებით მიღებულია.",
    course_transfer_verify_text: "თქვენი ინტიბაკის მოთხოვნა გადაიგზავნება, ადასტურებთ?",
    course_transfers_form: "ინტიბაკის განაცხადის ფორმა",
    course_type: "კურსის ტიპი",
    courseprerequisites: "კურსის წინაპირობები",
    courses: "კურსები",
    courses_you_have_taken_so_for: "თქვენ მიერ აღებული კურსები",
    create: "შექმნა",
    create_classes: "კლასების შექმნა",
    create_certificate: "სერტიფიკატის შექმნა",
    creating_a_thesis_section: "თეზისის სექციის შექმნა",



    create_document: "დოკუმენტის შექმნა",
    create_pilotage_fee: "პილოტაჟის საფასური",
    create_proforma_invoice: "პროფორმა ინვოისის შექმნა",
    create_report: "ანგარიშის შექმნა",
    created_at: "დამატების დრო",
    created_by: "დამამატებელი",
    created_at_start: "შექმნის დროის დასაწყისი",
    created_at_end: "შექმნის დროის დასასრული",
    create_paid_ones: "გადახდილთა განახლება",
    creating_fykk_template: "FYKK შაბლონის შექმნა",
    credit: "კრედიტი",
    credit_card: "საკრედიტო ბარათი",
    credit_card_info: "საკრედიტო ბარათის ინფორმაცია",
    credit_card_name_surname: "ბარათზე არსებული სახელი",
    credit_card_number: "საკრედიტო ბარათის ნომერი",
    credit_limit: "საკრედიტო ლიმიტი",
    credit_price: "კრედიტის ფასი",
    credit_x: "{credit} კრედიტი",
    course_drop_process: "კურსის მოხსნის პროცესი",
    credits_attempted: "მიღებული კრედიტები",
    credits_earned: "დასრულებული კრედიტები",
    criteria_filter: "კრიტერიუმის ფილტრი",
    currency: "ვალუტა",
    currency_rate: "ვალუტის კურსი",
    current_section: "მიმდინარე სექცია",
    current_password: "მიმდინარე პაროლი",
    curriculum: "სასწავლო გეგმა",
    curriculums: "სასწავლო გეგმები",
    customer: "სტუდენტი",
    customer_budgets: "სტუდენტის ბიუჯეტები",
    customer_budget_information: "ბიუჯეტის ინფორმაცია",
    customer_budget_payment: "სტუდენტის ბიუჯეტის გადახდის ინფორმაცია",
    customer_group: "მომხმარებელთა ჯგუფი",
    customer_type: "მომხმარებლის ტიპი",
    cut_rate: "კლების პროცენტი",
    cancel_reason: "უარის მიზეზი",
    calling_situation: "ზარის სტატუსი",
    calling_next_date: "შემდეგი ზარის თარიღი",
    calling_status: "ზარის მდგომარეობა",
    curriculum_credits: "სასწავლო გეგმის კრედიტი",
    curriculum_ects_credit: "სასწავლო გეგმის AKTS",
    completed_ects_credit: "დასრულებული AKTS",
    course_grade_entry_report: "კურსის ქულების შეყვანის ანგარიში",
    course_registration_is_confirmed: "კურსის რეგისტრაცია დადასტურებულია",
    course_registration_is_rejected: "კურსის რეგისტრაცია უარყოფილია",
    course_and_slot_logs: "ქულებისა და სლოტების ოპერაციები",
    calculate_extra_graduate_courses: "დამატებითი კურსები კურსდამთავრებულთათვის",
    create_student_semesters: "სტუდენტის სემესტრების სტატუსების შექმნა",
    create_student: "სტუდენტის შექმნა",
    closed: "დახურული",
    complete: "დასრულება",
    credit_end_date: "კრედიტის დასრულების თარიღი",
    credit_info: "კრედიტის ინფორმაცია",
    cancel_reason_graduation: "უარის მიზეზი და კურსდამთავრება/გადასვლა",
    course_faculty_name: "კურსის ფაკულტეტის სახელი",
    course_department_name: "კურსის დეპარტამენტის სახელი",
    course_program_code: "კურსის პროგრამის კოდი",
    comments: "კომენტარები",
    creditpayments_report: "კრედიტზე დაფუძნებული გადახდების ანგარიში",
    course_update_option_1: "ყველა სტუდენტზე გამოყენება",
    course_update_option_2: "მიმდინარე სტუდენტებზე გამოყენება",
    course_update_option_3: "კურსდამთავრებულ სტუდენტებზე გამოყენება",
    course_update_type: "განახლების მიზანი",
    course_registration_without_payment_report: "გადაუხდელობის მიუხედავად კურსი მქონე სტუდენტების ანგარიში",
    card_created: "ბარათი შექმნილია",
    card_not_created: "ბარათი არ შექმნილა",
    created_card_info: "ამ სტუდენტისთვის {date}-ში პირადობის ბარათი შეიქმნა!",
    creation_date: "შექმნის თარიღი",
    current_city: "საცხოვრებელი ქალაქი",
    current_district: "საცხოვრებელი რაიონი",
    children_available: "შვილები",
    create_password: "პაროლის მინიჭება",
    create_a_vote: "ხმის მიცემის შექმნა",
    contact_confirmations: "კონტაქტის დადასტურებები",
    corporation: "კომპანია",
    corp_department: "დეპარტამენტი",
    cancel_reservation: "რეზერვაციის გაუქმება",
    conservatory: "კონსერვატორია",
    conservatory_app_approve: "განაცხადის პირობები წავიკითხე და ვეთანხმები",
    conservatory_app_approve_multimedia: "ვეთანხმები ჩემი აუდიო/ვიდეო/ფოტოების გამოყენებას ნებართვის ფარგლებში",
    conservatory_contact_info: "სასწრაფო კითხვებისთვის შეგიძლიათ ელფოსტით მისწეროთ: info@cons.bau.edu.tr",
    conservatory_applications: "კონსერვატორიის განაცხადები",
    conservatory_application_exam_types: "კონსერვატორიის განაცხადის გამოცდის ტიპები",
    controller_name: "კონტროლერის სახელი",
    completed: "დასრულებული",
    count_of: "რაოდენობა",
    control_date:"კონტროლის თარიღი",
    classic_music: "კლასიკური მუსიკის ინსტრუმენტული შესრულება",
    credit_card_installment_error: "მითითებულ ბარათზე განვადება შეუძლებელია! მიუხედავად იმისა, რომ არჩეულია განვადება, მოხდება მხოლოდ ერთჯერადი ჩამოჭრა.",
    conservatory_login_info: "ადრე დარეგისტრირებულმა კანდიდატებმა უნდა შევიდნენ UMİS-ში და განაახლონ ინფორმაცია Ek Kontenjan გამოცდის განაცხადისთვის.",
    conservatory_quotas: "კონსერვატორიის კვოტები",
    club_name: "კლუბის სახელი",
    club_type: "კლუბის ტიპი",
    club_president: "კლუბის პრეზიდენტი",
    control_building:"კონტროლის შენობა",
    members: "წევრები",
    member: "წევრი",
    clup: "კლუბი",
    coming_from_university: "რომელი უნივერსიტეტიდან მოვიდა",
    cannot_find_grade_conversion: "ქულის მასშტაბი ვერ მოიძებნა",
    course_coordinator_assignment: "კურსის კოორდინატორის დანიშვნა",
    course_detail: "კურსის დეტალი",
    commission_rate:"საკომისიოს განაკვეთი",
    course_code_option: "კურსი",
    course_loads: "კურსის დატვირთვები",
    composition_arrangement: "კომპოზიცია და არანჟირება",
    conservatory_app_warning: "თქვენი გასაუბრების პროგრამა დაგეგმილი იქნება თქვენი 1-ელი არჩევანის მიხედვით!",
    classical_turkish_music: "კლასიკური თურქული მუსიკა",
    citizenship_exit_date:"მოქალაქეობის უარის თქმის თარიღი",
    cartoon_animation_applications: "მულტფილმისა და ანიმაციის განაცხადები",
    cartoon_animation: "მულტფილმი და ანიმაცია",
    cartoon_animation_app_payment_info: "განაცხადის გადასახადის ინფორმაცია",
    cartoon_animation_application_exam_types: "მულტფილმისა და ანიმაციის განაცხადის გამოცდის ტიპები",
    cartoon_animation_quotas: "მულტფილმისა და ანიმაციის კვოტები",
    club_manager_candidacy: "პრეზიდენტობის კანდიდატურა",
    club_leaving: "კლუბიდან გასვლა",
    club_president_request: "პრეზიდენტობის კანდიდატი",
    club_president_request_cancel: "პრეზიდენტობის კანდიდატურიდან უარის თქმა",
    club_leaving_info: "{club_name} სახელწოდების კლუბიდან გასვლა გსურთ?",
    club_serch: "კლუბის ძიება",
    character_limit_500: "სიმბოლოების ლიმიტი 500-ია.",




    dormitory_application_form: "Unihall განაცხადის ფორმა",
    documents_approved: "დოკუმენტები დამტკიცებულია",
    documents_waiting: "დოკუმენტები ელოდება",
    document_upload: "დოკუმენტის ატვირთვა",
    document_select: "აირჩიეთ დოკუმენტი",
    download_front_and_back:"ჩამოტვირთეთ წინა და უკანა",
    document_request_info_text1:"ძვირფასო სტუდენტო,\n" +
        "\n" +
        "თქვენ შეგიძლიათ წარადგინოთ თქვენი დოკუმენტაციის მოთხოვნები ქვემოთ მოცემული შესაბამისი კრიტერიუმების არჩევით და ღილაკზე „შენახვა“ დაწკაპუნებით.\n" +
        "\n" +
        "როგორც კი თქვენი მოთხოვნა გადაეგზავნება სტუდენტურ საქმეთა ოფისს, მისი სტატუსის თვალყურის დევნას შეძლებთ მენიუდან „ჩემი მოთხოვნები“. მას შემდეგ, რაც თქვენი დოკუმენტის სტატუსი გამოჩნდება როგორც „მზადაა“ (Ready), შეგიძლიათ აიღოთ დოკუმენტის ფიზიკური ასლი სტუდენტურ საქმეთა ოფისიდან.\n" +
        "\n" +
        "თქვენი დოკუმენტი მომზადდება და გადმოგეცემათ უმოკლეს დროში.\n" +
        "\n" +
        "გმადლობთ გაგებისთვის.",
    dashboard: "დაფა",
    data: "მონაცემები",
    daily_attendances_attendance_report: "დღიური დასწრების ანგარიში",
    data_from_system_control: "სისტემის კონტროლიდან მიღებული მონაცემები",
    date_info: "თარიღის ინფორმაცია",
    date: "თარიღი",
    date_between: "თარიღების შუალედი",
    time_between: "დროის შუალედი",
    date_of_birth: "დაბადების თარიღი",
    date_of_receipt: "მიღების თარიღი",
    day: "დღე",
    day3:"3 დღე",
    day_interval: "დღეების შუალედი",
    days: "დღეები",
    day15:"15 დღე",
    day_count: "სამუშაო დღეების რაოდენობა",
    dean: "დეკანი",
    dean_name: "დეკანის სახელი",
    dean_title: "დეკანის წოდება",
    dean_title_en: "დეკანის წოდება (EN)",
    debt: "ვალდებულება",
    decision: "გადაწყვეტილება",
    description: "აღწერა",
    decision_date: "გადაწყვეტილების თარიღი",
    decision_number: "გადაწყვეტილების ნომერი",
    decline: "უარყოფა",
    decline_reason: "უარყოფის მიზეზი",
    declined: "უარყოფილია",
    definitive_registration_information: "საბოლოო რეგისტრაციის ინფორმაცია",
    degree_of_proximity: "მოკავშირეობის ხარისხი",
    delay: "დაგვიანება",
    delay_1: "გადავადება",
    delay_end_date: "გადავადების დასრულების თარიღი",
    delete: "წაშლა",
    delete_all: "ყველას წაშლა",
    default: "ნაგულისხმევი",
    disability_information:"ინფორმაცია ინვალიდობის შესახებ",
    default_role_changed: "ნაგულისხმევი როლი შეიცვალა",
    discharge_report_for_those_who_have_not_enrolled_in_courses: "კურსზე არ დარეგისტრირებული ორმაგი პროგრამის სტუდენტების ურთიერთობის შეწყვეტის ანგარიში",
    delete_student_number: "სტუდენტის ნომრის წაშლა",
    delete_all_students: "ყველა სტუდენტის წაშლა",
    delete_empty_summer_student_semester: "ცარიელი ზაფხულის სემესტრების წაშლა",
    dep_course_count: "დასასრულებელი DEP კურსი",
    dep_course_credit: "დასასრულებელი DEP კრედიტი",
    dep_course_ects_credit: "დასასრულებელი DEP AKTS",
    department: "დეპარტამენტი",
    department_code: "დეპარტამენტის კოდი",
    department_codes: "დეპარტამენტები",
    department_name: "დეპარტამენტის სახელი",
    departments: "დეპარტამენტები",
    detail: "დეტალი",
    details: "დეტალები",
    detailed_monthly_collection_report: "დეტალური ყოველთვიური ინკასოს ანგარიში",
    denied: "უარყოფილია",
    diploma: "დიპლომი",
    diploma_annexes: "დიპლომის დანართები",
    diploma_date: "დიპლომის თარიღი",
    diploma_information: "დიპლომის ინფორმაცია",
    diploma_name: "დიპლომის სახელი",
    diploma_name_en: "დიპლომის სახელი (EN)",
    diploma_number: "დიპლომის ნომერი",
    diploma_number_from_system: "სისტემიდან დიპლომის ნომრის მიღება",
    diploma_point: "დიპლომის ქულა",
    diploma_point_system: "დიპლომის ქულების სისტემა",
    diploma_status: "დიპლომის სტატუსი",
    diploma_supplement: "დიპლომის დანართი",
    diploma_supplement_number: "დიპლომის დანართის ნომერი",
    diploma_supplement_status: "დიპლომის დანართის სტატუსი",
    diploma_title: "დიპლომის წოდება",
    diagnosis:"დიაგნოზი" ,
    diploma_title_en: "დიპლომის წოდება (EN)",
    diploma_supplement_6_1: "დიპლომის დანართი 6.1",
    diploma_supplement_6_1_dates: "დიპლომის დანართი 6.1 თარიღები",
    disability_rate: "შეზღუდულობის მაჩვენებელი",
    disability_type: "შეზღუდულობის ტიპი",
    disciplinary_committee_decision: "დისციპლინური კომიტეტის გადაწყვეტილება",
    discipline_follow: "დისციპლინის კონტროლი",
    discipline_process: "დისციპლინის პროცედურები",
    discipline_registry: "დისციპლინის სარეგისტრაციო საბუთი",
    disciplinary_action: "სტუდენტს აქვს დისციპლინური სასჯელი.",
    discount: "ფასდაკლება",
    discounts: "ფასდაკლებები",
    discount_amount: "ფასდაკლების ოდენობა",
    discount_rate: "ფასდაკლების პროცენტი",
    dispatch_postponement_certificate: "გაგზავნის გადავადების სერტიფიკატი",
    dispatch_postponement_request: "გაგზავნის გადავადების მოთხოვნა",
    display_systems: "სისტემების ჩვენება",
    distance_sales_agreement: "დისტანციური გაყიდვების ხელშეკრულება",
    district: "რაიონი",
    district_code: "რაიონის კოდი",
    district_name: "რაიონის სახელი",
    districts: "რაიონები",
    dgs: "DGS",
    dgs_e: "DGS EK",
    make_application: "განაცხადის გაკეთება",
    do_cancel: "გაუქმება",
    do_cancel_proccess: "პროცესის გაუქმება",
    do_payment: "გადახდა",
    do_withdraw: "უკან გამოთხოვა",
    do_you_have_language_proficiency: "გექნებათ თუ არა მომზადების გათავისუფლების მოთხოვნა?",
    do_you_have_language_proficiency_missing: "გთხოვთ მიუთითოთ მომზადების გათავისუფლების მოთხოვნა",
    do_you_verify_email: "გსურთ ელფოსტის მისამართის განახლება?",
    do_you_verify_mobile_no: "გსურთ მობილურის ნომრის განახლება?",
    do_you_want_to_close_the_form_with_the_selected_interview_result: "გსურთ ფორმის დახურვა არჩეული გასაუბრების შედეგით?",
    do_you_want_to_complete_registration: "დარწმუნებული ხართ, რომ გსურთ საბოლოო რეგისტრაციის გაკეთება?",
    do_you_want_to_print_receipt: "გსურთ ქვითრის დაბეჭდვა?",
    document: "დოკუმენტი",
    document_add: "დოკუმენტის დამატება",
    document_duae_date: "დოკუმენტის მოსატანი თარიღი",
    document_due_date: "დოკუმენტის მოტანის ბოლო თარიღი",
    document_draft: "დოკუმენტის მონახაზი",
    document_edit: "დოკუმენტის რედაქტირება",
    document_is_deleted: "დოკუმენტი წაშლილია.",
    document_number: "დოკუმენტის ნომერი",
    document_request: "დოკუმენტის მოთხოვნა",
    document_request_cancel_statement: "დოკუმენტის მოთხოვნა გაუქმდება! ადასტურებთ?",
    document_request_title: "დოკუმენტის მოთხოვნა",
    document_registrar_behalf: "დოკუმენტის ხელმომწერის წარმომადგენელი",
    document_registrar_title_behalf: "დოკუმენტის ხელმომწერის წარმომადგენლის წოდება",
    document_registrar_title_en_behalf: "დოკუმენტის ხელმომწერის წარმომადგენლის წოდება (EN)",
    document_registrar_behalf_start_date: "წარმომადგენლის დაწყების თარიღი",
    document_registrar_behalf_end_date: "წარმომადგენლის დასრულების თარიღი",
    departmental_elective_ects_credit: "დეპარტამენტის შიდა არჩევითი კრედიტი",
    non_departmental_elective_ects_credit: "დეპარტამენტს გარეთ არჩევითი AKTS",

    document_requests_title: "დოკუმენტის მოთხოვნები",
    document_settings: "დოკუმენტის პარამეტრები",
    document_show: "დოკუმენტის ნახვა",
    document_status: "დოკუმენტის სტატუსი",
    document_title: "დოკუმენტის სათაური",
    document_type: "დოკუმენტის ტიპი",
    document_type_id: "ID",
    document_type_name: "დოკუმენტის სახელი",
    documents: "დოკუმენტები",
    documents_are_required: "ატვირთეთ დოკუმენტი!",
    documents_upload: "დოკუმენტის ატვირთვა",
    documents_upload_pending: "შეგიძლიათ გააგრძელოთ განაცხადი დოკუმენტის ატვირთვით",
    documents_university: "უნივერსიტეტი, რომელსაც დოკუმენტები ეკუთვნის",
    domestic: "შიდა",
    download_back:"ჩამოტვირთეთ უკან",
    download_front:"ჩამოტვირთვა წინა",
    domestic_application: "შიდა განაცხადი",
    double_major_application: "ორმაგი სპეციალობის განაცხადი",
    double_major_dismissal_report: "ორმაგი სპეციალობის ურთიერთობის შეწყვეტის ანგარიში",
    double_major_application_quotas: "ორმაგი სპეციალობის განაცხადის კვოტები",
    double_major_applications: "ორმაგი სპეციალობის განაცხადები",
    double_major_termination_report: "ორმაგი სპეციალობის შეწყვეტის ანგარიში",
    double_major_application_start: "ორმაგი სპეციალობის განაცხადის დაწყება",
    download: "ჩამოტვირთვა",
    download_data: "მონაცემების ჩამოტვირთვა",
    download_ticket: "ბილეთის ჩამოტვირთვა",
    photos: "ფოტო",
    document_images: {
        document_logo: "დოკუმენტის ლოგო",
            favicon: "აპლიკაციის ბრაუზერის ხატულა",
            background: "შესვლის გვერდის სურათი",
            logo: "შესვლის გვერდის ლოგო",
        menu_logo: "მენიუს ლოგო"
        },

    document_no: "E-Devlet ბარკოდის ნომერი",






    download_photos: "ფოტოების ჩამოტვირთვა",
    download_report: "ანგარიშის ჩამოტვირთვა",
    download_result_file: "შედეგის ფაილის ჩამოტვირთვა",
    down_payment_rate: "წინასწარი გადახდის პროცენტი",
    down_payment: "წინასწარი გადახდა",
    download_fail_log: "შეცდომის ჟურნალის ჩამოტვირთვა",
    draft_info: "მონახაზის ინფორმაცია",
    dropped_lesson: "გათიშული გაკვეთილები",
    drop_file: "ფაილი დატოვეთ აქ...",
    due_date: "გადახდის ვადა",
    due_date_end: "გადახდის ვადის დასრულება",
    due_date_start: "გადახდის ვადის დაწყება",
    duration: "ხანგრძლივობა",
    document_not_found: "დოკუმენტი ვერ მოიძებნა.",
    denizbank_education_credit: "Denizbank-ის საგანმანათლებლო სესხი",
    dormitory: "სასტუმრო",
    dormitory_status: "სასტუმროში განთავსების სტატუსი",
    diploma_ebys_send: "დიპლომის EBYS გაგზავნა",
    delay_do_date: "გადავადების თარიღი",
    document_verify: "დოკუმენტის გადამოწმება",
    document_verified: "დოკუმენტი დადასტურებულია.",
    document_download: "დოკუმენტის ჩამოტვირთვა",
    doctor:"ექიმი",
    did_he_take_the_exam: "გამოცდაზე მივიდა?",
    did_not_answer: "პასუხი არ გაუცია",
    downloaded: "ჩამოტვირთულია.",
    diploma_notebook: "დიპლომის წიგნი",
    delete_file_upload_again: "წაშალეთ ფაილი და თავიდან ატვირთეთ",
    data_filter: "მონაცემთა ფილტრი",
    double_major_yok_report: "ორმაგი სპეციალობის YÖK ანგარიში",
    death_status: "გარდაცვალების სტატუსი",
    died: "გარდაიცვალა",
    do_you_think_to_do_master_in_corp: "გსურთ, გააგრძელოთ მაგისტრატურა დაწესებულებაში?",
    do_you_want_to_transfer_next_installments: "გსურთ ზედმეტი თანხის გადატანა შემდეგ ქვითრებზე?",
    download_excel_template: "Excel შაბლონის ჩამოტვირთვა",
    disability_status: "შეზღუდულობის სტატუსი",
    define_credits: "კრედიტის განსაზღვრა",
    max_duration_information_for_advisor: "მაქსიმალური ხანგრძლივობის განსაზღვრა",
    delete_unpaid_courses: "გადაუხდელი კურსების წაშლა",
    document_barcode_no: "დოკუმენტის ბარკოდის ნომერი",

// E
    except_roles: "დასამალავი როლები",
    enable_editing: "რედაქტირების ჩართვა",
    close_editing: "რედაქტირების დახურვა",
    edit_end_date: "რედაქტირების დასრულების თარიღი",
    exempt: "თავისუფალი",
    exemptionStatus: "თავისუფლების სტატუსი",
    exam_definitions: "გამოცდის განმარტებები",
    earned_degree: "მიღებული ხარისხი",
    e_registration_system: "ონლაინ რეგისტრაციის სისტემა",
    e_registration_system_info: "* თუ გაქვთ რეგისტრაციის შეჩერების მოთხოვნა, რეგისტრაციის დასრულებისას შეიქმნება. UMIS-ში შესვლის შემდეგ 'ჩემი მოთხოვნები' აპლიკაციის 'რეგისტრაციის შეჩერება' გვერდიდან შეგიძლიათ ნახოთ სტატუსი.",
    early_discount_rate: "ადრეული გადახდის ფასდაკლების პროცენტი",
    ebys_status: "EBYS სტატუსი",
    ebys_send: "EBYS გაგზავნა",
    ebys_send_statement: "მოთხოვნა გაიგზავნება EBYS სისტემაში! ადასტურებთ?",
    ebys_type_id: "EBYS დოკუმენტის ტიპის ID",
    ects: "AKTS",
    ects_credit: "AKTS",
    ects_credit_of_uncompleted_slots: "დაუსრულებელი სლოტების AKTS",
    ects_credits_attempted: "აღებული AKTS კრედიტი",
    ects_credits_earned: "დასრულებული AKTS კრედიტი",
    edit: "რედაქტირება",
    edit_classrooms: "სასწავლო ოთახების რედაქტირება",
    edit_due_date: "გადახდის ვადის რედაქტირება",
    edit_grade_conversion: "ქულების სკალის რედაქტირება",
    edit_option: "ოპციის რედაქტირება",
    edit_payment: "გადახდის რედაქტირება",
    edit_preference: "უპირატესობის რედაქტირება",
    edit_question: "შეკითხვის რედაქტირება",
    edit_section: "სექციის რედაქტირება",
    edit_part: "სექციის რედაქტირება",
    edit_slot: "სლოტის რედაქტირება",
    edit_logo: "ლოგოს რედაქტირება",
    education: "განათლება",
    education_credits_report: "განათლების კრედიტების ანგარიში",
    edit_patient_information:"პაციენტის ინფორმაციის რედაქტირება",
    education_and_exam_info: "განათლების/გამოცდის ინფორმაცია",
    education_and_exam_reqired: "განათლების ველი სავალდებულოა!",
    education_credit: "განათლების კრედიტი",
    education_delete_info: "ირჩევთ განათლების ინფორმაციის წაშლას. გსურთ გაგრძელება?",
    education_info: "განათლების ინფორმაცია",
    education_information_reporting: "განათლების ინფორმაციის რეპორტი",
    education_information: "განათლების ინფორმაცია",
    education_line_cancel: "დააჭირეთ აქ, რომ წაშალოთ განათლების ინფორმაცია",
    education_status: "განათლების სტატუსი",
    educator_report: "პედაგოგის ანგარიში",
    effect_gpa: "გაძლიერებს თუ არა GPA-ს?",
    effect_ratio: "შეფასების წილი",
    egovernment_code: "E-Devlet კოდი",
    elective_pool: "არჩევითი აუზი",
    elective_pool_id: "არჩევითი აუზის ID",
    elective_pools_course_delete_confirm_text: "აპირებთ არჩევითი აუზის კურსის წაშლას, ადასტურებთ?",
    elective_pools_delete_confirm_text: "აპირებთ არჩევითი აუზის წაშლას, ადასტურებთ?",
    elective_pools_form: "არჩევითი აუზის დამატება",
    edit_class_information: "კლასის ინფორმაციის რედაქტირება",
    elective_pools_info: "არჩევითი აუზის ინფორმაცია",
    elective_pools_report: "არჩევითი აუზის რეპორტი",
    elective_pools_store_confirm_text: "აპირებთ არჩევითი აუზის დამატებას, ადასტურებთ?",
    elective_pools_title: "არჩევითი აუზი",



    elective_pools_update: "არჩევითი აუზის განახლება",
    email: "ელ-ფოსტა",
    email_address: "ელ-ფოსტის მისამართი",
    email_of_advisor: "კონსულტანტის ელ-ფოსტა",
    email_placeholder: "შეიყვანეთ თქვენი ელ-ფოსტის მისამართი",
    email_update: "ელ-ფოსტის განახლება",
    email_verify_not: "თქვენ უნდა დაადასტუროთ ელ-ფოსტის მისამართი!",
    email_send: "ელ-ფოსტის გაგზავნა",
    emergency_contact_txt: "საგანგებო სიტუაციებში საკონტაქტო პირი",
    emergency_person: "საგანგებო სიტუაციებში დასარეკი პირი",
    emergency_person_phone: "საგანგებო სიტუაციებში საკონტაქტო პირის ნომერი",
    employment_certificate: "სამუშაო სერტიფიკატი",
    empty_classrooms: "ცარიელი საკლასო ოთახები",
    empty_data_on_table: "გთხოვთ, შეავსოთ ცხრილის ველები!",
    end: "დასასრული",
    end_date: "დასრულების თარიღი",
    end_time: "დასრულების დრო",
    endorse: "ინდოსირება",
    english: "ინგლისური",
    english_education_percentage: "ინგლისურ ენაზე სწავლების პროცენტი",
    enter_attendance: "დასწრების შეყვანა",
    enter_explanation: "შეიყვანეთ განმარტება",
    entry_document: "შესვლის დოკუმენტი",
    entry_score: "შესვლის ქულა",
    entry_score_type: "შესვლის ქულის ტიპი",
    entry_section: "შეიყვანეთ სექცია",
    entry_note: "შესვლის შენიშვნა",
    enter_value: "შეიყვანეთ მნიშვნელობა",
    epayment: "ონლაინ გადახდა",
    epayments_report: "ონლაინ გადახდის ანგარიში",
    online_payment_agreement: "ონლაინ გადახდის ხელშეკრულება",
    error: "შეცდომა",
    error_min_0_max_100: "შეყვანილი მნიშვნელობა უნდა იყოს 0-100 შორის.",
    equal_weight_score: "თანაბარი წონა",
    equivalence_status: "ეკვივალენტობის სტატუსი",
    equivalence_information: "ეკვივალენტობის ინფორმაცია",
    evaluation: "შეფასება",
    evaluations: "შეფასებები",
    evaluation_type: "გამოცდა",
    events: "ღონისძიებები",
    event_announcement: "ღონისძიების განცხადება",
    event_owner: "ღონისძიების მფლობელი",
    event_type: "ღონისძიების ტიპი",
    event_name: "ღონისძიების სახელი",
    event_format: "ღონისძიების ფორმატი",
    event_start_date: "ღონისძიების დაწყების თარიღი",
    event_end_date: "ღონისძიების დასრულების თარიღი",
    event_location: "ღონისძიების ადგილი",
    event_registration_form: "ღონისძიების რეგისტრაციის ფორმა",
    event_ticket_details: "ღონისძიების სერტიფიკატის დეტალები",
    external_participation: "გარე მონაწილეობა",
    exam: "გამოცდა",
    examinations: "გამოცდები",
    exam_report: "გამოცდის ოქმი",
    exam_report_all_section: "გამოცდის ოქმი (ყველა სექცია)",
    exam_report_list: "გამოცდის ოქმების სია",
    exam_application_start_date: "გამოცდაზე განაცხადის დაწყების თარიღი",
    exam_application_to_date: "გამოცდაზე განაცხადის დასრულების თარიღი",
    exam_averages: "გამოცდის საშუალოები",
    exam_capacity: "გამოცდის ტევადობა",
    exam_date: "გამოცდის თარიღი",
    exam_delete_info: "ირჩევთ გამოცდის ინფორმაციის წაშლას. გსურთ გაგრძელება?",
    excused_absence_report:"განმარტებული არყოფნის ანგარიში",
    exam_effect_ratio: "გამოცდის გავლენის პროცენტი",
    exam_info: "გამოცდის ინფორმაცია",
    exam_line_cancel: "დააჭირეთ, რომ წაშალოთ გამოცდის ინფორმაცია",
    exam_method: "გამოცდის მეთოდი",
    exam_code: "გამოცდის კოდი",
    exam_name: "გამოცდის სახელი",
    exam_parts: "გამოცდის ნაწილები",
    exam_schedule1: "გამოცდის პროგრამა",
    exam_schedule: "გამოცდის განრიგი",
    exam_schedule_format: "კურსის კოდი, სექცია, მომხმარებლის ID, აუდიტორია, გამოცდის ტიპი, თარიღი, დაწყების დრო, დასრულების დრო",
    exam_schedule_id: "გამოცდის განრიგის ID",
    examination_date:"სამედიცინო შემოწმების თარიღი",
    exam_schedule_available_time: "გამოცდის განრიგისთვის შესაფერისი დროის პოვნა",
    exam_score: "გამოცდის ქულა",
    exam_status_report: "გამოცდის შესვლის სტატუსი",
    exam_type: "გამოცდის ტიპი",
    exam_time: "გამოცდის ხანგრძლივობა",
    exams: "გამოცდები",
    exams_to_take: "გამოცდები, რომლებშიც მიიღებს მონაწილეობას",
    exam_definition: "გამოცდის აღწერა",
    excel: "Excel",
    excel_file: "Excel ფაილი",
    excel_format: "Excel ფორმატი",
    excel_export: "Excel ექსპორტი",
    excel_export_items: "Excel ექსპორტის სათაურები",
    excluded_program_codes: "გარე პროგრამის კოდები",
    excluded_registration_types: "გარე რეგისტრაციის ტიპები",
    excuse_file: "მიზეზის დოკუმენტი",
    excuse_letter: "მიზეზის წერილი",
    expand_all: "ყველას გახსნა",
    expiry_month: "ვადის გასვლის თვე",
    expiry_year: "ვადის გასვლის წელი",
    explanation: "განმარტება",
    explanation_en: "ინგლისური განმარტება",
    extend: "გაგრძელება",
    external_application: "ინსტიტუციათაშორისი",
    extra_installment: "დამატებითი გადახდის ნაწილი",
    extra_time: "დამატებითი დრო",
    exam_overlap_report: "გამოცდის გადაფარვის ანგარიში",
    external_course: "გარე კურსი",
    early_payment_report: "ადრეული რეგისტრაციის ანგარიში",
    equivalence_decision_date: "ეკვივალენტობის გადაწყვეტილების თარიღი",
    equivalence_serial_number: "ეკვივალენტობის სერიული ნომერი",
    ebys_id: "EBYS ID",
    extension: "გაგრძელება",
    error_student_status_not_contiune: "სტუდენტის სტატუსი არ არის აქტიური, ამიტომ ამ გვერდზე შესვლა არ შეგიძლიათ",
    exchange_university_name: "სასწავლებელი უნივერსიტეტი",
    event_switch: "ღონისძიებები",
    event_show: "ჩვენება",
    event_hide: "არ აჩვენო",
    exception_logs: "შეცდომის ჟურნალები",
    explanation_for_sms: "განმარტება (ეს ინფორმაცია sms-ით არ გაიგზავნება)",
    exam_placement_type: "განთავსების ტიპი",
    exam_place: "გამოცდის ადგილი",
    exam_datetime: "გამოცდის თარიღი და დრო",
    estimate_status: "შეფასების სტატუსი",
    exam_date_enter: "შეყვანილია გამოცდის თარიღი?",
    exam_info_enter: "გამოცდის ინფორმაციის შეყვანა/რედაქტირება",
    equivalent_course: "ეკვივალენტური კურსი",
    exam_result_year: "გამოცდის შედეგის წელი",
    exam_result: "გამოცდის შედეგი",
    excluded_registration_academic_years: "გარე რეგისტრირებული აკადემიური წლები",
    excel_import_template: "Excel იმპორტის შაბლონი",
    ects_coordinator_course_definitions: "კურსის აღწერის ინფორმაცია",
    ects_course_definitions: "კურსის აღწერა",
    ects_objectives: "კურსის მიზნები",
    ects_other_components: "სხვა კომპონენტები",
    ects_notes_books: "ლექციის კონსპექტები",
    ects_other_resources: "სხვა რესურსები",
    ects_mode_of_delivery: "სწავლების მეთოდი",
    ects_program_courses: "პროგრამის კურსები",
    ects_course_polydef: "კურსის განმარტებები",
    ects_pending: "მოლოდინში",
    ects_approved: "დამტკიცებულია",
    ects_edit_request: "რედაქტირების მოთხოვნა",
    ects_course_assessment: "კურსის შეფასება",
    ects_basic_table: "ძირითადი AKTS ცხრილი",
    ects_weekly_table: "კვირეული AKTS ცხრილი",
    ects_total_course_load: "საერთო კურსის დატვირთვა",
    ects_constant: "AKTS მუდმივი",
    ects_tyyc_basic_field_type: "კურსის კომპეტენციის ტიპი",
    ects_course_outcome: "კურსის შედეგი",
    ects_course_program_outcomes: "კურსისა და პროგრამის შედეგები",
    ects_values_info: "მნიშვნელობები: - გავლენა არა, 1 - ყველაზე დაბალი, 2 - დაბალი, 3 - საშუალო, 4 - მაღალი, 5 - ყველაზე მაღალი",
    ects_course_program_relation: "კურსის და პროგრამის ურთიერთკავშირი",
    ects_values_info_2: "მნიშვნელობები: - გავლენა არ აქვს, 1 - გავლენა აქვს",
    ects_panel: "AKTS პანელი",


    // F
    first_password_get: "პირველი პაროლის მიღება",
    faculties: "ფაკულტეტები",
    faculty: "ფაკულტეტი",
    faculty_grade_entry_report: "ფაკულტეტების მიხედვით ნოტების შეყვანის ანგარიში",
    faculty_course_grade_entry_report: "ფაკულტეტის კურსების მიხედვით ნოტების შეყვანის ანგარიში",
    faculty_code: "ფაკულტეტის კოდი",
    faculty_code_name: "ფაკულტეტის კოდი / სახელი",
    faculty_name: "ფაკულტეტის სახელი",
    faculty_name_en: "ფაკულტეტის სახელი EN",
    faculty_of_choice: "არჩეული ფაკულტეტი",
    faculty_rank: "ფაკულტეტის რეიტინგი",
    faculty_comparison_report: "ფაკულტეტების შედარების ანგარიში",
    failed_data_count: "წარუმატებელი რაოდენობა",
    fall: "შემოდგომა",
    fall_and_spring: "შემოდგომა და გაზაფხული",
    fall_credit: "შემოდგომის კრედიტი",
    false: "არასწორი",
    family: "ოჯახი",
    family_info: "ოჯახის ინფორმაცია",
    family_information: "ოჯახის ინფორმაცია",
    fast_transactions: "სწრაფი ოპერაციები",
    father: "მამა",
    father_gsm: "მამის საკონტაქტო ტელეფონი",
    father_job: "მამის პროფესია",
    father_name: "მამის სახელი",
    father_name_placeholder: "შეიყვანეთ მამის სახელი",
    fathers_education: "მამის განათლების დონე",
    fathers_gsm: "მამის საკონტაქტო ტელეფონი",
    fathers_job: "მამის პროფესია",
    fees_and_installments: "გადასახადები და განვადებები",
    female: "ქალი",
    front_side:"წინა მხარე",
    fetch_document: "დოკუმენტის მოტანა",
    fields_are_reqired: "ველები სავალდებულოა!",
    file: "ფაილი",
    field: "ველი",
    field_program: "ველი/პროგრამა",
    file_name: "ფაილის სახელი",
    file_name_course_schedule: "კურსის-განრიგი",
    file_name_dispatch_postponemen: "გადავადების-მოწმობა",
    file_name_diploma: "დიპლომის დოკუმენტი",
    file_name_diploma_annexes: "დიპლომის დანართები",
    file_name_english_placement_exam: "დონის-გამოცდის-ბარათი",
    file_name_exam_schedule: "გამოცდის-განრიგი",
    file_name_language_proficiency: "ენის-კომპეტენციის-მოწმობა",
    file_name_military_status: "სამხედრო-მდგომარეობის-მოწმობა",
    file_name_missing_documents_report: "დაკლებული-დოკუმენტების-ანგარიში",
    file_name_new_password: "ახალი-პაროლი",
    file_name_prep_transcript: "მომზადების-ქულების-დოკუმენტი",
    file_name_school_certificate: "სკოლის-მოწმობა",
    file_name_student_certificate: "სტუდენტის-მოწმობა",
    file_name_student_information_system: "სტუდენტის-მონაცემთა-სისტემა",
    file_name_student_notes_report: "სტუდენტის-ქულების-ანგარიში",
    file_name_transcript: "ქულების-ფურცელი",
    file_name_user_guide: "მომხმარებლის-სახელმძღვანელო",
    file_name_welcome_letter: "მისასალმებელი-წერილი",
    file_upload_not_1: "ენის გამონაკლისის მოწმობის მქონე სტუდენტებმა ეს დოკუმენტი უნდა გაგზავნონ მისამართზე: <a href=mailto:kayit@sa.bau.edu.tr>kayit@sa.bau.edu.tr</a>",
    file_upload_not_2: "რეგისტრაციის გაყინვის ან სურვილისამებრ მომზადების კურსის აღების მსურველმა სტუდენტებმა უნდა დაუკავშირდნენ მისამართზე: <a href=mailto:kayit@sa.bau.edu.tr>kayit@sa.bau.edu.tr</a>",
    file_upload_not_3: "ონლაინ რეგისტრაციის დროს ტექნიკური პრობლემის შემთხვევაში შეგიძლიათ დაუკავშირდეთ მისამართზე: <a href=mailto:ekayit@bau.edu.tr>ekayit@bau.edu.tr</a>",
    files: "ფაილები",
    fill_at_least_one_field: "გთხოვთ შეავსოთ მინიმუმ ერთი ველი",
    f_letter_grade_repeat_status: "F ასო-ქულის გამეორების სტატუსი",
    filter1: "ფილტრი",
    filter: "ფილტრაცია",
    findings:"მიგნებები",
    filter_type: "ფილტრის ტიპი",
    filter_value: "ფილტრის მნიშვნელობა",
    final_letter_grade: "საბოლოო ასო-ქულა",
    finalize_the_application: "განაცხადის დასრულება",
    final_grades: "საბოლოო ქულები",
    finalize: "დასკვნა",
    finalize_grade_cancel: "დასრულების გაუქმება",
    final_exam: "საბოლოო გამოცდა",
    finance_offset: "გათანაბრება",
    finance_reports: "ფინანსური ანგარიშები",
    find: "პოვნა",
    find_student: "სტუდენტის პოვნა",
    finished_class: "რომელ კლასში დაამთავრა?",
    first_installment: "პირველი განვადება",
    first_student_count: "პირველად შემოსული სტუდენტების რაოდენობა",
    first_registration: "პირველი რეგისტრაცია",
    force_education_price: "სწავლის საფასურის ჩატვირთვა",
    foreign_document_number: "უცხოეთის პირადი ნომერი",
    foreign_student_community_internship_assignment: "უცხოელი სტუდენტების კოლექტიური სტაჟირების დანიშვნა",
    foreign_document_type: "უცხოეთის დოკუმენტის ტიპი",
    foreign_status: "უცხო ქვეყნის მოქალაქეობა",
    foreign_student: "საერთაშორისო სტუდენტი",
    foreign_student_credentials: "საერთაშორისო სტუდენტის მონაცემები",
    foreign_student_identity: "საერთაშორისო სტუდენტის პირადობა",
    foreign_participant: "უცხოელი მონაწილე",
    forgot_my_password: "დამავიწყდა პაროლი",
    friday: "პარასკევი",
    from_score: "საწყისი ქულა",
    from_email: "წასაშლელი ელფოსტა",
    frozen_semesters: "დასჯილი სემესტრები",
    full_name: "სახელი და გვარი",
    full_time: "სრული განაკვეთი",
    full_scholarship_students_enroll: "კურსზე რეგისტრაციის დამტკიცება",
    future_payment: "გადასახადის გადავადება",
    future_ai_summit: "Future AI Summit'25 16-17 აპრილი",
    future_ai_summit_title: "Future AI Summit'25",
    fykk_template: "FYKK შაბლონი",
    first_value_big_from_second: "პირველი მნიშვნელობა არ უნდა იყოს მეორეზე მეტი!",
    finalize_grades: "საბოლოო ქულის დასკვნა",
    from_where: "საიდან",
    from: "ვისგან",
    first_time: "პირველად",
    filters: "ფილტრები",
    foreign_student_q: "არის უცხოელი?",
    forward: "წინ",
    final_grade_entry: "საბოლოო ქულის შეყვანა",
    foreign_student_report: "უცხოელი სტუდენტის ანგარიში",
    filesize_alert: "ატვირთული ფაილის ზომა არ უნდა აღემატებოდეს 49 MB-ს",
    file_download: "ფაილის ჩამოტვირთვა",
    fashion_design: "ტექსტილი და მოდის დიზაინი",
    fashion_design_contact_info: "სასწრაფო კითხვებისთვის მოგვწერეთ: ozelyetenek@fashion.bau.edu.tr",
    fashion_design_app_approve: "განაცხადის პირობები წავიკითხე და ვეთანხმები",
    fashion_design_app_approve_multimedia: "ვადასტურებ, რომ ჩემი ხმა, სურათი და ვიდეო გამოიყენება თანხმობის ფარგლებში",
    fashion_design_applications: "ტექსტილისა და მოდის დიზაინის განაცხადები",
    fashion_design_filsize_alert: "ფაილები განიხილება პორტფოლიოს გასაუბრების დროს.",
    foundation_at: "დაარსების თარიღი",
    fee: "წევრობის გადასახადი",
    for_new: "ახლის დასამატებლად",
    format: "ფორმატი",
    future_ai_summit_team: "Future AI Summit საორგანიზაციო გუნდი",
    free: "უფასო",
    flight_information: "ფრენის ინფორმაცია",
    from_date: "დაწყების თარიღი",


    gateway: "Gateway",
    grading_scale:"შეფასების სკალა",
    gender: "სქესი",
    general: "ზოგადი",
    general_information: "ზოგადი ინფორმაცია",
    generate_ticket_discount_codes: "სასწავლო ფასდაკლების კოდების გენერირება",
    gep_course_count: "GEP კურსების რაოდენობა",
    gep_course_credit: "GEP კრედიტი",
    gep_course_ects_credit: "GEP AKTS კრედიტი",
    get_report: "ანგარიშის მიღება",
    gear: "მექანიზმი",
    give_exception_payment_approval: "განსაკუთრებული გადახდის დამტკიცება",
    giveable_roles: "გაცემადი როლები",
    gna_not_range: "GNO ქულის დიაპაზონი",
    gno: "საერთო საშუალო ქულა",
    gno_of_transferred_courses:"გადატანილი კურსების გნო",

    gno_simulation: "GNO სიმულაცია",
    gno_carculate: "საერთო საშუალო ქულა - გამოთვლა",
    gpa: "DNO",
    gpa_control_report: "GNO კონტროლის ანგარიში",
    grade: "ქულა",
    grand_total: "ჯამური თანხა",
    graduate_application_evaluation_exam: "სადიპლომო გამოცდის განსაზღვრა",
    grade_conversion_define_tabel: "ქულათა სკალის ცხრილი",
    grade_conversion_define_title: "ქულათა სკალის განსაზღვრის ფორმა",
    grade_conversion_id: "სკალის ID",
    grade_conversion_info: "ქულათა სკალის ინფორმაცია",
    grade_conversion_name: "სკალის სახელი",
    grade_conversion_range_end: "ქულათა დიაპაზონის დასასრული",
    grade_conversion_range_start: "ქულათა დიაპაზონის დასაწყისი",
    grade_conversion_table_title: "ქულათა სკალის ცხრილი",
    grade_conversion_update_title: "ქულათა სკალის განახლების ფორმა",
    grade_conversion_update_verify_text: "ქულათა სკალის ცხრილში დამატებას აპირებთ, ადასტურებთ?",
    grade_conversion_verify_text: "ქულათა სკალის ცხრილში დამატებას აპირებთ, ადასტურებთ?",
    grade_conversion_verify_text_2: "ქულათა სკალის ცხრილი შეინახება მონაცემთა ბაზაში, ადასტურებთ?",
    grade_entry: "ქულის შეყვანა",
    grade_entry_confirmation_modal: "თქვენი ქულები შეინახება, ადასტურებთ?",
    grade_id: "ასო ქულა",
    grade_is_deleted_text: "ქულათა სკალის განსაზღვრა წაშლილია.",
    grade_scala: "ქულათა სკალა",
    grade_table_is_empty: "ქულათა სკალის ცხრილი ცარიელია.",
    grade_up_lessons: "ქულის ასამაღლებელი კურსები",
    grade_system: "ქულათა სისტემა",
    grade_systems: "ქულათა სისტემები",
    grades: "ქულები",
    ge:'ქართული',
    grading_system: "ქულათა სისტემა",
    grading_systems: "ქულათა სისტემები",
    grading_system_id: "ქულათა სისტემის ID",
    graduate: "კურსდამთავრებული",
    graduate_application_after_verify_info: "თუ განაცხადი შეწყდება, შეგიძლიათ განაახლოთ Pin კოდით <a href=login>განაცხადის განახლება</a> გვერდზე.",
    graduate_application_form: "სადიპლომო განაცხადის ფორმა",
    graduate_application_form_update_btn: "განაცხადის ფორმის განახლება",
    graduate_application_yok_statement: "(საგარეო უნივერსიტეტების კურსდამთავრებულებმა YÖK-ის დოკუმენტები უნდა ატვირთონ სხვა დოკუმენტებში.)",
    graduate_applications: "სადიპლომო განაცხადები",
    graduate_exam_results: "სადიპლომო გამოცდის შედეგები",
    graduate_period: "დამთავრების პერიოდი",
    graduate_date: "დამთავრების თარიღი",
    guest:"სტუმარი",
    graduate_semester: "დამთავრების სემესტრი",
    graduate_detail_cpga: "დეტალური GNO",
    graduate_application_quotas: "სადიპლომო განაცხადის კვოტები",
    graduation_academic_year: "დამთავრების აკადემიური წელი",
    graduation_academic_year_season: "დამთავრების სეზონი",
    graduation_average: "დამთავრების საშუალო ქულა",
    graduation_date: "დამთავრების თარიღი",
    graduation_date_between: "დამთავრების თარიღის დიაპაზონი",
    graduation_decision_date: "დამთავრების გადაწყვეტილების თარიღი",
    graduation_decision_number: "დამთავრების გადაწყვეტილების ნომერი",
    graduation_degree: "დამთავრების ხარისხი",
    graduation_document_info: "დამთავრების დოკუმენტის ნომერი არის E-Devlet დიპლომის ბარკოდი.",
    Graduation_GPA: "დამთავრების GNO",
    graduation_information: "დამთავრების ინფორმაცია",
    graduation_semester: "დამთავრების სემესტრი",
    graduation_status: "დამთავრების სტატუსის კონტროლი",
    graduation_simulation: "დამთავრების სიმულაცია",
    graduation_university: "დამთავრებული უნივერსიტეტი",
    ge_elective_ects_credit: "GE არჩევითი AKTS კრედიტი",
    graduation_year: "დამთავრების წელი",
    graduate_full_scholarship_ratio_report: "სადიპლომო სრული სტიპენდიების ანგარიშის წილი",
    graduate_number_of_students_and_collection_report: "სადიპლომო სტუდენტების რაოდენობა და შემოსავალი",
    graduationDate: "დამთავრების თარიღი",
    georgia_address: "საქართველოს მისამართი",
    gross_price: "სრული ფასი",
    gross_price_certificate: "ბრუტო ფასი",
    gsm_no: "მობილური ნომერი",
    guarantee1: "გადამხდელი",
    guarantee1_address: "გადამხდელის მისამართი",
    guarantee1_national_id: "გადამხდელის პირადი ნომერი",
    guarantee1_phone: "გადამხდელის ტელეფონი",
    guarantee2: "გარანტი",
    guarantee2_address: "გარანტის მისამართი",
    guarantee2_national_id: "გარანტის პირადი ნომერი",
    guarantee2_phone: "გარანტის ტელეფონი",
    guarantee: "კეფილი",
    guarantee_address: "კეფილის მისამართი",
    guarantee_national_id: "კეფილის პირადი ნომერი",
    guarantee_phone: "კეფილის ტელეფონი",
    graduate_app_regular_student: "ჩვეულებრივი სტუდენტი",
    graduate_app_private_student: "სპეციალური სტუდენტი",
    graduate_app_scientific_preparation_student: "სამეცნიერო მომზადების სტუდენტი",
    graduate_information: "დამთავრების ინფორმაცია",
    guide_code: "სახელმძღვანელოს კოდი",
    guide: "სახელმძღვანელო",
    graduate_inquiry: "დამთავრების ძიება",
    guardian_national_id: "მეურვის პირადი ნომერი",
    guardian_mobile_tel: "მეურვის მობილური ტელეფონი",
    gpa_calculate: "საშუალოს გამოთვლა",
    gpa_calculate_info_text: "სტუდენტის საშუალო ქულა ხელახლა გამოითვლება, ადასტურებთ?",
    gpa_calculate_success: "საშუალო წარმატებით გამოითვალა! ახალი საშუალო: ",
    graduation_requirements: "დამთავრების მოთხოვნები",
    graduation_ects_credit: "AKTS კრედიტი",
    graduation_credit: "კრედიტი",
    graduation_dep: "შიგნაგანყოფილებითი არჩევითი რაოდენობა",
    intra_department_elective_credit: "შიგნაგანყოფილებითი არჩევითი კრედიტი",
    non_departmental_elective_credit: "გარე არჩევითი კრედიტი",
    dep_credit: "შიგნაგანყოფილებითი კრედიტი",
    dep_ects_credit: "შიგნაგანყოფილებითი AKTS კრედიტი",
    graduation_non_dep: "გარე არჩევითი რაოდენობა",
    ge_elective_number_ects_credits: "GE არჩევითი რაოდენობა AKTS კრედიტი",
    dge_elective_number_ects_credits: "შიგნაგანყოფილებითი არჩევითი AKTS კრედიტი",
    non_dep_credit: "გარე კრედიტი",
    non_dep_ects_credit: "გარე AKTS კრედიტი",
    graduation_general: "ზოგადი არჩევითი რაოდენობა",
    graduation_generage: "GE არჩევითი რაოდენობა",
    general_credit: "ზოგადი არჩევითი კრედიტი",
    general_ects_credit: "ზოგადი არჩევითი AKTS კრედიტი",
    graduate_requirement_info: "დამთავრების მოთხოვნები",
    graduate_requirement_info_short: "დამთ. მოთხოვ.",
    graduates: "კურსდამთავრებულები",
    graduate_card_create: "კურსდამთავრებულის ბარათის შექმნა",
    graduate_date_in: "დამთავრების თარიღი",
    graduation_scholarship_status: "მიიღო თუ არა დამთავრების სტიპენდია?",
    homework_entry: "შინაური დავალების შეყვანა",
    homework_list: "შინაური დავალებების სია",
    graduate_info: "კურსდამთავრებულის ინფორმაცია",
    ge_selective_credit: "GE არჩევითი კრედიტი",
    graduate_email: "კურსდამთავრებულის ელფოსტა",
    graduate_card_status: "კურსდამთავრებულის ბარათის სტატუსი",
    graduate_decision_date: "დამთავრების გადაწყვეტილების თარიღი",
    graduate_email_status: "კურსდამთავრებულის ელფოსტის სტატუსი",
    graduate_high_school_name: "დამთავრებული სკოლის სახელი",
    graduate_high_school_code: "დამთავრებული სკოლის კოდი",
    graduation_document_number: "დამთავრების დოკუმენტის ნომერი",
    graduation_is_required: "დამთავრების კონტროლი",
    gno_between: "GNO დიაპაზონი",
    gno_between_desc: "უნდა ჩაწეროთ 2 რიცხვი მძიმეით(,)",
    general_info: "ზოგადი ინფორმაცია",
    graduate_application: "სადიპლომო",
    graduate_bachelor_program: "დამთავრებული ბაკალავრიატი",
    graduate_master_program: "დამთავრებული მაგისტრატურა",
    graduate_phd_program: "დამთავრებული დოქტორანტურა",
    group_ticket: "ჯგუფური ბილეთი",
    graduate_document_no: "დამთავრების დოკუმენტის №",
    graduate_document_no_placeholder: "შეიყვანეთ დამთავრების დოკუმენტის №",


    have_student_program: "სტუდენტის ჩანაწერი არსებობს. აქედან ოპერაცია არ გააკეთოთ.",
    has_english_cert: "გექნებათ თუ არა მზადყოფნისგან გათავისუფლების მოთხოვნა?",
    has_teams_integration: "გაქვთ Teams ინტეგრაცია?",
    have_payment_approval: "გადახდის დამტკიცება",
    have_you_leave_of_absence_before: "ადრე გქონდათ თუ არა სწავლის შეჩერება?",
    head_of_department: "კათედრის ხელმძღვანელი",
    head_of_program: "კოორდინატორი",
    hall_setup: "სალონის განლაგება",
    health: "ჯანმრთელობა",
    health_information: "ჯანმრთელობის ინფორმაცია",
    hello: "გამარჯობა",
    help: "დახმარება",
    help_videos: "დახმარების ვიდეოები",
    hes_code: "HES კოდი",
    home_address: "სახლის მისამართი",
    home_number: "სახლში ტელეფონი (სტაციონარული)",
    home_tel: "სახლში ტელეფონი",
    healthcare_personnel:"ჯანდაცვის პერსონალი",
    habits:"ჩვევები",
    horizontal_or_vertical_attended_university: "ჰორიზონტალური/ვერტიკალური მისული უნივერსიტეტი",
    horizontal_or_vertical_attended_university_1: "ჰორიზონტალური/ვერტიკალური <u>მისული</u> უნივერსიტეტი",
    horizontal_or_vertical_coming_from_university: "ჰორიზონტალური/ვერტიკალური მოსული უნივერსიტეტი",
    horizontal_or_vertical_coming_from_university_1: "ჰორიზონტალური/ვერტიკალური <u>მოსული</u> უნივერსიტეტი",
    hour: "საათი",
    hours: "საათები",
    hybrid: "ჰიბრიდული",
    high_honor: "უმაღლესი ღირსების პროცესი",
    high_honor_status: "ღირსების სტატუსი",
    high_school: "საშუალო სკოლა",
    high_school_info: "საშუალო სკოლის ინფორმაცია",
    high_school_diploma_score: "საშუალო სკოლის დიპლომის საშუალო ქულა",
    high_school_major_type: "დამთავრებული მიმართულება",
    high_school_major_type_1: "შერეული (Eşit Ağırlık)",
    high_school_major_type_2: "სოციალური მეცნიერებები (Sözel)",
    high_school_major_type_3: "ზუსტი მეცნიერებები (Sayısal)",
    high_school_major_type_4: "უცხო ენა",
    high_school_major_type_5: "მხატვრული ხელოვნება",
    high_school_graduate_date: "საშუალო სკოლის დამთავრების თარიღი",
    holiday_day: "დასვენების დღეები",
    have_a_message: "აქვს თუ არა შეტყობინება?",
    headers: "სათაურები",
    header: "სათაური",
    hybrid_statuses: "ჰიბრიდული სტატუსები",
    honour_high_honour_achievement_ranking: "საპატიო / უმაღლესი საპატიო წარმატების რეიტინგი",


    insufficient_limit: "ლიმიტი არასაკმარისია",
    instructionLanguage: "სასწავლო ენა",
    iban: "IBAN",
    id: "Id",
    identity: "პირადობა",
    identify: "პირადობის ან პასპორტის ნომერი",
    identity_information: "პირადობის ინფორმაცია",
    image_upload: "სურათის ატვირთვა",
    image: "სურათი",
    import: "იმპორტი",
    illness_information:"ინფორმაცია ავადმყოფობის შესახებ",
    import_button: "იმპორტი",
    import_course_schedule: "საგნების განრიგის ატვირთვა",
    import_student_club_member_search: "კლუბის წევრის ძიება",
    import_draft: "მონახაზის იმპორტი",
    import_exam_schedule: "გამოცდების განრიგის ატვირთვა",
    import_photos: "ფოტოების იმპორტი",
    in_class: "პირისპირ",
    in_evaluation: "შეფასებაში",
    in_house_application: "ინსტიტუციური",
    included_registration_types: "შეიცავს რეგისტრაციის ტიპებს",
    indefinite: "უვადო",
    industry: "ინდუსტრია",
    internship_application: "სტაჟირების განაცხადი",
    internship_information: "სტაჟირების ინფორმაცია",
    interview_exam_participation: "გასაუბრება/გამოცდაში მონაწილეობა",
    interview_exam_participation_score: "გასაუბრება/გამოცდის ქულა",
    interest_rate: "პროცენტის განაკვეთი",
    info_file: "ინფორმაციის ფაილი",
    info_link: "ინფორმაციის ბმული",
    info_text: "ინფორმაციის ტექსტი",
    information: "ინფორმაცია",
    input_type: "შეყვანის ტიპი",
    installment: "განვადება",
    installment_amount: "განვადების თანხა",
    installment_count: "განვადების რაოდენობა",
    installment_options: "განვადების ვარიანტები",
    installment_payment: "განვადებით გადახდა",
    installment_payment_type: "განვადების გადახდის ტიპი",
    installment_start_date: "განვადების დასაწყისი თარიღი",
    installments: "განვადებები",
    installments_total: "განვადების ჯამი",
    installment_number: "განვადების ნომერი",
    instructor: "მასწავლებელი",
    instructor_can_use: "მასწავლებელს შეუძლია გამოიყენოს",
    instructor_courses_title: "ჩემი კურსები",
    instructor_name: "მასწავლებლის სახელი",
    instructor_surname: "მასწავლებლის გვარი",
    instructors: "მასწავლებლები",
    instructor_course_load_report: "მასწავლებლის საგნობრივი დატვირთვის ანგარიში",
    in_field: "სფეროში",
    instructor_letter_grade_excel_export: "მასწავლებლის ნიშნის Excel ანგარიში",
    instructor_attendance: "მასწავლებლის დასწრების კონტროლი",
    instructor_exam_requests: "მასწავლებლის გამოცდის მოთხოვნები",
    instructor_exam_request_admin: "მასწავლებლის გამოცდის მონაცემთა შეგროვება",
    intership_information: "სტაჟირების ინფორმაცია",
    invalid_course_coordinator: "თანამშრომელი ვერ მოიძებნა",
    invalid_student: "სტუდენტი ვერ მოიძებნა",
    invalid_value: "არასწორი მნიშვნელობა",
    invalid_values: "არასწორი მნიშვნელობები",
    invalid_national_id: "არასწორი პირადი ნომერი",
    invert: "შებრუნება",
    investigation_report: "გამოკვლევის ანგარიში",
    invitation_to_the_defense: "დაცვაზე მოწვევა",
    individual: "ინდივიდუალური",
    individual_ticket: "ინდივიდუალური ბილეთი",
    individual_ticket_for: "პირადი სერტიფიკატი",
    institutional: "ინსტიტუციური",
    institutional_ticket: "ინსტიტუციური ბილეთი",
    invoice1: "ინვოისი 1",
    invoice2: "ინვოისი 2",
    invoice3: "ინვოისი 3",
    invoice4: "ინვოისი 4",
    infirmary:"საავადმყოფო",
    international_student: "სტუდენტის შექმნა",
    is_certificate_sent: "სერტიფიკატის გაგზავნა",
    invoices: "ინვოისები",
    invoice_number: "ინვოისის ნომერი",
    invoice_amount: "ინვოისის თანხა",
    irregular: "არარეგულარული",
    irregular_status: "არარეგულარული სტატუსი",
    is_before_undergraduate_transfer: "ადრე გააკეთეთ თუ არა ჰორიზონტალური გადაცემა?",
    is_before_undergraduate_transfer_type: "რომელი ტიპის ჰორიზონტალური გადაცემა გააკეთეთ?",
    is_default: "ნაგულისხმევია?",
    is_graduate: "დამთავრებულია?",
    is_numeric: "რიცხვითი?",
    is_paid: "გადახდილია?",
    is_passing: "ჩააბარა?",
    is_rate: "პროცენტი",
    is_required: "სავალდებულოა?",
    is_multi_selection: "იქნება თუ არა მრავალჯერადი არჩევანი ?",
    is_revert: "შებრუნებულია?",
    is_there_a_header: "სათაური არის?",
    is_take_exam: "გამოცდაზე შესვლა",
    is_exam_time_lesson: "ეს არის გამოცდის დროის გაკვეთილი?",
    is_additional_classroom: "დამატებითი საკლასო ოთახია?",
    is_one_row: "ერთი ხაზი",
    is_in_program: "პროგრამაში იქნება?",
    is_cgpa_locked: "GNO დაბლოკილია",
    internship_remaining_count: "დარჩენილი სტაჟირების რაოდენობა",
    i_approve: "ვეთანხმები",
    i_not_approve: "არ ვეთანხმები",
    inbox: "შემოსული",
    include_graduates:"შეიყვანეთ კურსდამთავრებულები",
    instructors_letter_grade: "დაუსრულებელი ნიშნები",
    import_extra_payments: "დამატებითი გადახდების ატვირთვა",
    extra_payment: "დამატებითი სასწავლო გადახდა",
    issue_date: "გაცემის თარიღი",
    info: "ინფორმაცია",
    in_life: "ცოცხალი",
    include_cancelled: "გაუქმებულების ჩათვლით",
    installment_options_info: "ზოგიერთ საბანკო ბარათზე განვადების აქცია არ მოქმედებს. გთხოვთ, ჯერ თქვენს ბანკს დაუკავშირდეთ.",
    i_have_read_understood_and_approve: "წავშალე, გავიგე და ვეთანხმები",
    interview_preference: "გასაუბრების არჩევანი",
    interest_amount: "Vinov სხვაობა",
    vinov_amount: "Vinov თანხა",
    identity_card_placeholder: "პირადობის მოწმობა",
    internship_manager_name: "სტაჟირების მენეჯერის სახელი",
    internship_manager_surname: "სტაჟირების მენეჯერის გვარი",
    internship_manager_email: "სტაჟირების მენეჯერის ელ-ფოსტა",
    internship_type: "სტაჟირების ტიპი",

    // J
    job: "პროფესია",
    job_address: "სამსახურის მისამართი",
    job_and_contact_info: "სამსახური/საკონტაქტო ინფორმაცია",
    job_corporation: "დასაქმების ორგანიზაცია",
    job_department: "სამუშაო განყოფილება",
    job_description: "სამუშაოს აღწერა",
    job_experience: "სამუშაო გამოცდილება",
    job_experience_desc: "(თუ გაქვთ, მიუთითეთ წინა სამუშაო გამოცდილება საერთო ხანგრძლივობით.)",
    job_info: "სამუშაო ინფორმაცია",
    job_other: "სხვა პროფესია",
    job_sector: "სამუშაო სექტორი",
    job_tel: "სამსახურის ტელეფონი",
    jobs: "სამუშაოები",
    joining_place: "შეერთების ადგილი",
    just_active: "მხოლოდ აქტიური სტუდენტები",
    job_prep_student_period_status_create: "მომზადებითი სტუდენტის სემესტრის სტატუსის შექმნა",
    job_information: "პროფესიული ინფორმაცია",
    jazz: "ჯაზის ინსტრუმენტალური შესრულება",
    jazz_vocal: "ჯაზის ვოკალი",
    join: "შეუერთდი",

    // K
    key: "გასაღების ველი",
    kvkk_modal_title: "პირადი მონაცემების დამუშავების შესახებ განმარტებითი ტექსტი",
    kyk_information: "KYK ინფორმაცია",
    kvkk_data_approve: "პირადი მონაცემების დაცვას და <strong>გაცნობილი თანხმობის ტექსტი წავიკითხე</strong>, გავიგე და ვეთანხმები.",


    kvkk_content_text: `Bu metin, veri sorumlusu Bahçeşehir Konaklama ve Turizm Yatırımları Anonim Şirketi’nin (“Bahçeşehir Konaklama” veya "Şirket") kişisel verilerinizi nasıl işlediği hakkında sizleri bilgilendirmeyi amaçlamaktadır. Kişisel verilerinizin işlenmesine ilişkin konular, aşağıda başlıklar halinde sıralanmıştır. <br>
    	Kişisel verilerim hangi amaçlarla ve hangi hukuki sebeplere dayanılarak işleniyor? <br>
    Kişisel Verilerin Korunması Kanunu’nun (“Kanun”) 5. ve 6. maddeleri, kişisel veri işlemenin hukuki sebeplerini düzenlemektedir. Aşağıda kişisel verilerinizi hangi amaçlarla işlediğimize ve söz konusu amaçlar kapsamında hangi hukuki sebeplere dayandığımıza yer verdik:<br>
    Kişisel verileriniz, Kanunlarda açıkça öngörülmesi ile Şirket’in hukuki yükümlülüklerini yerine getirmesi için kişisel veri işlemenin zorunlu olması hukuki sebeplerine dayalı olarak aşağıdaki amaçlarla işlenmektedir:<br>
    •	Yetkili kurum veya kuruluşların Şirketimizden talepte bulunması ya da bu kurumlara bildirim yapmamızın öngörüldüğü durumlarda, yasal yükümlülüklerimizin yerine getirilmesi (örneğin, Kimlik Bildirme Kanunu kapsamında yurtta kalanlara ilişkin zorunlu kimlik bildirim yükümlülüğünün yerine getirilmesi),
    •	Faturalama dahil mevzuattan kaynaklı yükümlülüklerimizin yerine getirilmesi.<br>
    Kişisel verileriniz, bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli olması hukuki sebebine dayalı olarak aşağıdaki amaç ile işlenmektedir:<br>
    •	Öğrencilerin yurtlara yerleştirilme ve kabul süreçlerinin yürütülmesi,
    •	Konaklama hizmetlerinin sunumu için kaydınızın oluşturulması ve sözleşmeden doğan yükümlülüklerimizin yerine getirilmesi,
    •	Yurt ödemelerinin ve tahsilat işlemlerinin gerçekleştirilebilmesi.<br>
    Kişisel verileriniz, bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması hukuki sebebine dayalı olarak aşağıdaki amaçlarla işlenmektedir:

    •	Olası bir hukuki uyuşmazlık durumunda, haklarımızın korunabilmesi ve kullanılması ile hukuki süreçlerin ve disiplin işlemlerinin yürütülmesi.<br>
    Kişisel verileriniz, ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, Şirket’in meşru menfaatleri için veri işlenmesinin zorunlu olması hukuki sebebine dayalı olarak aşağıdaki amaçlarla işlenmektedir:<br>
    •	İletişim süreçlerinin yürütülmesi; talep ve şikayetlerin alınması ve sonuçlandırılması,
    •	Yurtlarımızın ve hizmetlerimizin güvenliğinin sağlanması; yetkisiz giriş-çıkışların engellenmesi,
    •	Şirket politika ve kurallarına uyumluluğun sağlanması; denetim ve yönetim faaliyetlerinin yürütülmesi.<br>
    Kişisel verileriniz, açık rıza vermiş olmanız halinde aşağıdaki amaçlarla işlenmektedir:<br>
    •	Adli sicil kaydı ve sağlık bilgileri için; konaklama hizmetlerinden yararlanacak kişiler için sağlık ve güvenlik kontrollerinin gerçekleştirilmesi, yurda yerleştirme ve kabul süreçlerinin yönetilmesi ve yetkili kişi, kurum ve kuruluşlara bilgi verilmesi.


    	<strong>Hangi kişisel verilerim işleniyor? </strong><br>
    Bahçeşehir Konaklama olarak, yukarıda belirtilen amaçlar doğrultusunda, kimlik, iletişim, eğitim-öğrenim bilgilerinizi, konaklama bilgilerinizi, finansal bilgilerinizi, yakınlarınıza/acil durumlarda ulaşılacak kişilere ilişkin bilgiler, yabancı öğrenciler için oturum izin bilgileri ile sağlık ve adli sicil kaydı bilgilerinizi işliyoruz. <br>
    <strong>Kişisel verilerim kimlere ve hangi amaçlarla aktarılıyor?</strong><br>
    Kişisel verilerinizi, “Kişisel verilerim hangi amaçlarla ve hangi hukuki sebeplere dayanılarak işleniyor?” başlığındaki amaçların yerine getirilebilmesi için, Kanun’un 5. ve 6. maddelerinde belirtilen hukuki sebeplere dayalı olarak, Kanun’un 8. ve 9. maddelerinde belirtilen kişisel verilerin aktarılmasına ilişkin kurallar dahilinde; iş ortaklarımız, tedarikçiler ve yetkili kişi, kurum veya kuruluşlar ile paylaşıyoruz.<br>
    <strong>Kişisel verilerim nasıl ve hangi hukuki sebeplere dayalı olarak toplanıyor? </strong><br>
    <strong>Kişisel verilerinizi aşağıdaki kanallar ve yöntemler aracılığıyla topluyoruz:</strong> <br>
    <strong>Kişisel verilerinizi toplama kanalları:</strong> Fiziki ya da elektronik ortamlarda form doldurmanız veya bilgilerinizi bizimle paylaşmanız; telefon, e-posta, sosyal medya hesapları üzerinden bizimle iletişime geçmeniz halinde belirtilen kanallar aracılığıyla kişisel verileriniz toplanmaktadır.<br>
    <strong>Kişisel verilerinizi toplama yöntemleri:</strong> Kişisel verileriniz, kısmen otomatik, otomatik veya veri kayıt sisteminin parçası olmak kaydı ile otomatik olmayan yöntemler ile toplanmaktadır.

    Kişisel verilerinizi Kanun’un 5. ve 6. maddelerinde düzenlenen kişisel veri işleme şartlarından;  sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli olması, bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması, ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla veri işlemenin meşru menfaatlerimiz için zorunlu olması, veri işlemenin kanunlarda açıkça öngörülmesi, veri işlemenin veri sorumlusunun hukuki yükümlülüklerini yerine getirebilmesi için zorunlu olması ile açık rızanızı vermeniz halinde açık rızanızın bulunması sebeplerine dayalı olarak topluyoruz.<br>
    	Kişisel veri sahibi olarak haklarımı nasıl kullanabilirim?
    Kanun’un 11. maddesi kişisel verileri işlenen gerçek kişilerin haklarını düzenlemektedir. Bu madde uyarınca aşağıdaki haklara sahipsiniz:<br>
    •	Kişisel verinizin işlenip işlenmediğini öğrenme,
    •	Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
    •	Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
    •	Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,
    •	Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,
    •	Kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,
    •	İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
    •	Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme.<br>
    Haklarınız ile ilgili taleplerinizi bize iletmek için, Abbasağa Mah. Ihlamur Yıldız Cad. No. 8/1A Beşiktaş/İstanbul adresine taleplerinizi içeren bir posta gönderebilirsiniz. Ayrıca, Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ’de belirtilen yöntemleri de kullanabilirsiniz.

    <strong>Kişisel Verilerin İşlenmesine Dair Açık Rıza Metni</strong><br>
    Kişisel verilerinizin işlenebilmesi için Kanun’da belirtilen hukuki sebeplerden biri bulunmadığında, Bahçeşehir Konaklama ve Turizm Yatırımları Anonim Şirketi (“Bahçeşehir Konaklama”) olarak kişisel verilerinizi işleyebilmek için açık rızanızın bulunup bulunmadığını soruyoruz.<br>
    Aşağıda belirtilen kişisel veri işleme süreçlerini yürütebilmemiz için açık rıza vermek istiyorsanız metinlerin alt kısmını imzalayabilirsiniz. Kişisel verilerinizin işlenebilmesi için vermiş olduğunuz rızayı, bizimle iletişime geçerek her zaman geri alabilirsiniz.<br>
    <strong>1.</strong>	Sağlık bilgilerimin, Bahçeşehir Konaklama tarafından, konaklama hizmetlerinden yararlanacak kişiler için sağlık ve güvenlik kontrollerinin gerçekleştirilmesi, yurda yerleştirme ve kabul süreçlerinin yönetilmesi ve yetkili kişi, kurum ve kuruluşlara bilgi verilmesi amaçlarıyla işlenmesi ve aynı amaçlarla yetkili kurum ve kuruluşlarla paylaşılmasına izin veriyorum.

    <strong>2.</strong>	Adli sicil kaydı bilgilerimin, Bahçeşehir Konaklama tarafından, konaklama hizmetlerinden yararlanacak kişiler için sağlık ve güvenlik kontrollerinin gerçekleştirilmesi, yurda yerleştirme ve kabul süreçlerinin yönetilmesi ve yetkili kişi, kurum ve kuruluşlara bilgi verilmesi amaçlarıyla işlenmesi ve aynı amaçlarla yetkili kurum ve kuruluşlarla paylaşılmasına izin veriyorum.`,


    kvkk_code: "KVKK კოდი",
    kvkk_code_send: "KVKK კოდის გაგზავნა",
    keyword_1: "საკვანძო სიტყვა 1",
    keyword_2: "საკვანძო სიტყვა 2",
    keyword_3: "საკვანძო სიტყვა 3",
    kilometer: "კილომეტრი",

    login_details: "შესვლის ინფორმაცია",
    login_user:"შესული მომხმარებელი",
    login_user_id:"შესული მომხმარებლის ID",
    last_message: "ბოლო შეტყობინება",
    last_status: "ბოლო მდგომარეობა",
    lab: "ლაბორატორია",
    lab_credit: "ლაბორატორიული კრედიტი",
    lab_section: "ლაბორატორიის სექცია",
    label: "იარლიყი",
    label_en: "იარლიყი (ინგლისურად)",
    language: "ენა",
    language_text: "ადრე Türkçe ენის სერტიფიკატი გაქვთ მიღებული?",

    language_exam_score: "ენის გამოცდის ქულა",
    language_proficiency_certificate_en: "ინგლისური ენის სერტიფიკატი",
    language_proficiency_certificate_tr: "თურქული ენის სერტიფიკატი",
    last_approve_date: "ბოლო დამტკიცების თარიღი",
    last_course: "ადრე გავლილი კურსი",
    last_course_registration_semester: "ბოლო კურსის რეგისტრაციის სემესტრი",
    last_course_registration_year: "ბოლო კურსის რეგისტრაციის წელი",
    last_education_status: "საგანმანათლებლო სტატუსი",
    last_lesson_registration_year: "ბოლო გაკვეთილის რეგისტრაციის წელი",
    last_process_date: "ბოლო პროცესის თარიღი",
    last_school: "ბოლო გავლილი სკოლა",
    last_school_date_of_graduation: "ბოლოGraduation-ის თარიღი",
    last_school_diploma_number: "ბოლო დიპლომის ნომერი",
    last_school_diploma_point: "ბოლო დიპლომის ქულა",
    last_school_registration_date: "ბოლო სკოლის რეგისტრაციის თარიღი",
    last_university: "ბოლო გავლილი უნივერსიტეტი",
    library_rooms:"სასწავლო ოთახები",
    last_update_date: "ბოლო განახლების თარიღი",
    leave_absences: "ჩანაწერების შეჩერების მოთხოვნების მონიტორინგი",
    leave_of_absence: "ჩანაწერის შეჩერება",
    leave_of_absence_count: "შეჩერებული სემესტრების რაოდენობა",
    leave_of_absence_fall: "შემოდგომის სემესტრში შეჩერებული ჩანაწერების რაოდენობა",
    leave_of_absence_period: "პერიოდი, რომელშიც განაცხადი გსურთ",
    leave_of_absence_reason: "ჩანაწერის შეჩერების მიზეზი",
    last_publication_date: "ბოლო გამოქვეყნების თარიღი",
    leave_of_city: "სახლობის ქალაქი",
    leave_of_district: "სახლობის რაიონი",
    leave_of_absence_description: "ჩანაწერის შეჩერების აღწერა",
    leave_of_absence_semesters: "შესაჩერებელი სემესტრები",
    leave_of_absence_settings_title: "ჩანაწერის შეჩერების პარამეტრები",
    leave_of_absence_spring: "გაზაფხულის სემესტრში შეჩერებული ჩანაწერების რაოდენობა",
    leave_of_absence_title: "ჩანაწერის შეჩერების მოთხოვნის ფორმა",





    leave_of_absence_verify_text:
        "Seçilen dönem için kayıt dondurma talebinizi onaylıyor musunuz? \n\n MADDE 16 – (1) Mazeretleri olan öğrenciler, kayıt dondurmak için mazeretlerini belgelemek koşuluyla en geç yarıyılın/yılın ilk dört haftası içinde Öğrenci İşleri Daire Başkanlığına başvururlar. Öğrencinin kayıt dondurma müracaatı, danışmanının ve bölüm başkanının görüşü alındıktan sonra, ilgili akademik birimin yönetim kurulunca karara bağlanır. \n\n" +
        "(2) Öğrenciler bir defada en çok iki yarıyıl kayıt dondurabilirler. Azami öğrencilik süresince, ön lisans öğrencilerine üç yarıyıl, dört yıllık veya üstü programlarda okuyanlara dört yarıyıl kayıt dondurma hakkı verilebilir. Zorunlu hallerde Yönetim Kurulu kararı ile bu süreler uzatılabilir. Yabancı dil hazırlık veya destek sınıfı öğrencileri en çok iki yarıyıl kayıt dondurabilir ve bu hakkı bir defa kullanabilirler. Kayıt dondurularak geçirilen süreler azami öğrenim süresinden sayılmaz. \n\n" +
        "(3) Öğrencilere aşağıdaki gerekçelerle ve mazeretleri belgelenmek koşulu ile kayıt dondurma hakkı verilebilir: \n\n" +
        "a) Hastalık: Öğrencinin durumunu bir yarıyıl/yıl kayıt dondurmayı gerektirecek süreyi kapsayan bir sağlık raporu ile belgelendirmesi koşulu ile kaydı dondurulabilir. Öğrencinin, kayıt dondurma süresi bitiminde, sağlık probleminin devam ettiğinin sağlık raporları ile belgelenmesi halinde, ilgili akademik birim yönetim kurulu bu süreyi uzatabilir. Bu süre sonunda, öğrencilerden eğitim-öğretime devam etmelerinde bir sakınca olmadığına dair sağlık raporu istenebilir.\n\n" +
        "b) Askerlik: Öğrencinin, tecil veya sevk tehiri işleminin zorunlu nedenlerle yapılamaması sonucu askere alınması halinde, askerlik süresince kayıt dondurma hakkı verilir. \n\n c) İlgili akademik kurullarca kabul edilen belgelendirilecek diğer haklı ve geçerli gerekçeler. \n\n (4) Kayıt donduran öğrencilere uygulanacak kurallar şunlardır:\n\n" +
        "a) Askerlik, hastalık ve doğal afetler nedeni ile kayıt donduran öğrencilerden öğrenim ücreti alınmaz. Başka gerekçelerle kayıt donduran öğrenciler, bu süreye ait öğrenim ücretinin yüzde yirmibeşini (%25) öderler\n\n b) Öğrenci, kayıt dondurmuş olduğu sürede başka bir kurumdan almış olduğu dersleri, Üniversitedeki öğretim programına transfer edemez. \n\nc) Hastalık ve gerekçesi belgelenmiş zorunlu sebepler dışındaki kayıt dondurma istekleri, en geç yarıyılın/yılın ilk dört haftası içinde yapılmalıdır. \n\n" +
        "ç) Genel hükümlere göre kesinleşmiş bir mahkûmiyeti olan veya Yükseköğretim Kurumları Öğrenci Disiplin Yönetmeliğine göre uzaklaştırma cezası alan öğrenciler kayıt donduramaz. Takipsizlik veya beraat kararı ile sona eren tutukluluk süresi, öğrencilerin azami öğrenim süresinden sayılmaz. Bu süre için herhangi bir öğrenim ücreti alınmaz. ",
    leave_of_absence_verify_text_graduate:
        "Seçilen dönem için kayıt dondurma talebinizi onaylıyor musunuz?\n\n" +
        "Kayıt Dondurma MADDE 43-\n\n" +
        "(1) Haklı ve geçerli mazeretleri olan lisansüstü öğrencileri, kayıt dondurmak için mazeretlerini belgelemek koşuluyla en geç yarıyılın/yılın ilk dört haftası içinde Öğrenci İşleri Daire Başkanlığına başvururlar. Öğrencinin kayıt dondurma müracaatı, anabilim/anasanat dalı koordinatörünün görüşü alındıktan sonra, Enstitü Yönetim Kurulu tarafından karara bağlanır.\n\n" +
        "(2) Kayıt dondurma başvuruları aşağıdaki kurallara göre değerlendirilir:\n\n" +
        "a) Geçerli sebepler nedeniyle tezsiz yüksek lisans öğrencileri öğrenim süresince en fazla bir yarıyıl, tezli yüksek lisans öğrencileri en fazla iki yarıyıl ve doktora öğrencileri en fazla üç yarıyıl kayıt dondurabilirler. Zorunlu hallerde Üniversite Yönetim Kurulu kararı ile bu süreler uzatılabilir. Kayıt dondurularak geçirilen süreler azami öğrenim süresinden sayılmaz.\n\n" +
        "b) Öğrencinin bir yarıyıl/yıl kayıt dondurmayı gerektirecek süreyi kapsayan bir sağlık raporu ile belgelendirmesi koşulu ile kaydı dondurulabilir. Öğrencinin, kayıt dondurma süresi bitiminde, sağlık probleminin devam ettiğinin sağlık raporları ile belgelenmesi halinde, Enstitü Kurulu bu süreyi uzatabilir. Bu süre sonunda, öğrencilerden eğitim-öğretime devam etmelerinde bir sakınca olmadığına dair sağlık raporu istenebilir.\n\n" +
        "c) Öğrencinin, tecil veya sevk tehiri işleminin zorunlu nedenlerle yapılamaması sonucu askere alınması halinde, askerlik süresince kayıt dondurma hakkı verilir.\n\n" +
        "(3) Öğrenci, kayıt dondurmuş olduğu sürede başka bir kurumdan almış olduğu dersleri, Üniversitedeki öğretim programına transfer edemez.\n\n" +
        "(4) Hastalık ve gerekçesi belgelenmiş zorunlu sebepler dışındaki kayıt dondurma istekleri, en geç yarıyılın/yılın ilk dört haftası içinde yapılır.\n\n" +
        "(5) Öğrencinin tutuklu veya hükümlü olması durumunda bu durumu belgelemesi koşuluyla müracaat etmesi halinde talepte bulunulan akademik yıl/dönem de dahil olmak üzere tutukluluk/hükümlülük tarihinin sona ereceği tarihe kadar Enstitü Yönetim Kurulu kararı ile kayıt dondurulur.\n\n" +
        "(6) Doğal afetler nedeniyle öğrenime ara vermek zorunda kalan öğrencinin kaydı, afetzede olduğunun resmî makamlarca verilecek bir belge ile belgelenmiş olması ve müracaat etmesi koşuluyla Enstitü Yönetim Kurulunun uygun göreceği tarihe kadar dondurulur.\n\n" +
        "(7) Askerlik, hastalık, tutukluluk/hükümlülük ve doğal afetler nedeni ile kayıt donduran öğrencilerden öğrenim ücreti alınmaz. Başka gerekçelerle kayıt donduran öğrenciler, bu süreye ait öğrenim ücretinin yüzde yirmi beşini öderler.",





    leave_with_consent: "კავშირი შეწყვეტა",
    library_chairs:"ბიბლიოთეკის სკამები",
    library_room_id:"ბიბლიოთეკის ოთახის ID",
    leave_with_consent_cap_excel: "CAP-კავშირის-შეწყვეტა",
    leave_with_consent_form: "კავშირის შეწყვეტის განაცხადის ფორმა",
    leave_with_consent_form_student: "საკუთარი სურვილით სამსახურიდან გათავისუფლების ფორმა",
    leave_with_consent_reason: "კავშირის შეწყვეტის მიზეზი",
    leave_with_consent_statement1: "ვაცხადებ, რომ კავშირის შეწყვეტის ეკრანზე შეყვანილი ინფორმაცია სწორია.",
    leave_with_consent_statement1_content: "",





    leave_with_consent_statement2_content:
        "\n" +
        "\n" +
        "Bu metin, Bahçeşehir Üniversitesi’nin kişisel verilerinizi nasıl işlediği hakkında sizleri bilgilendirmeyi amaçlamaktadır. Kişisel verilerinizin işlenmesine ilişkin konular, aşağıda başlıklar halinde sıralanmıştır.\n" +
        "\n" +
        "Kişisel verilerimin işlenmesinden kim sorumlu?\n" +
        "Bahçeşehir Üniversitesi (“BAU”) olarak, kişisel verilerinizin nasıl işleneceğini belirliyor ve veri kayıt sisteminin yönetimini sağlıyoruz. Diğer bir ifadeyle, kişisel verilerinizi işlerken veri sorumlusu olarak hareket ediyoruz.\n" +
        "\n" +
        "Kişisel verilerim nasıl toplanıyor?\n" +
        "Aşağıda kişisel verilerinizi toplama kanal ve yöntemlerimiz yer almaktadır:\n" +
        "Kişisel verilerinizi toplama kanalları: Fiziki ortamlarda form doldurmanız veya bilgilerinizi bizimle paylaşmanız; internet sitesi ya da dijital ortamlarda yer alan formları doldurmanız; telefon, e-posta, sosyal medya hesapları veya BAU whatsapp hattı üzerinden bizimle iletişime geçmeniz halinde belirtilen kanallar aracılığıyla kişisel verileriniz toplanmaktadır.\n" +
        "Kişisel verilerinizi toplama yöntemleri:Kişisel verileriniz, otomatik, kısmen otomatik veya veri kayıt sisteminin parçası olmak kaydı ile otomatik olmayan yöntemler ile toplanmaktadır.\n" +
        "\n" +
        "Hangi kişisel verilerim işleniyor?\n" +
        "BAU olarak mezunlarımızın aşağıda belirtilen kişisel verilerini işliyoruz:\n" +
        "Kimlik İletişim Diğer Bilgileriniz\n" +
        "\n" +
        "Ad-soyad, kimlik numarası, öğrenci numarası, doğum tarihi, medeni durum. Telefon numarası, e-posta adresi, adres. Fotoğraf, mezuniyet yılı, mezuniyet sezonu, mezun olunan fakülte/enstitü, mezun olunan bölüm/program, çalışma durumu, çalışılan sektör/kurum ve pozisyon, yüksek lisans/doktora bilgileri, BAU Network kullanıcı bilgileri, kulüp etkinlikleri-COOP katılım bilgisi, tavsiyeniz üzerine BAU’lu olan kişi, üniversite çağındaki yakın bilgisi.\n" +
        "\n" +
        "Özgeçmişinizin çeşitli firmalarda uygun pozisyonlarda değerlendirilmesi için BAU tarafından ilgili firmalarla paylaşımını talep etmeniz durumunda ayrıca özgeçmişinizde yer alan bilgiler işlenmektedir.\n" +
        "\n" +
        "Kişisel verilerim hangi amaçlarla işleniyor?\n" +
        "Kişisel verilerinizi, mezun ilişkilerinin yönetilmesi, iletişim süreçlerinin yürütülmesi, kariyer fırsatları, mezunlara özel indirimler ve etkinlikler gibi duyurular konusunda mezunların bilgilendirilmesi, mezun bağlılığının ölçümlenmesi; mezun bağlılığı ve memnuniyetinin artırılmasına yönelik aktivitelerin planlanması, mezunlarımızın akademik ve profesyonel hayat tecrübelerini paylaşabilmeleri için platformların oluşturulması ve yönetilmesi, organizasyon ve etkinliklerin planlanması ve yürütülmesi, organizasyon ve etkinlikler için iş ortakları ile işbirliği gerçekleştirilmesi, talep eden mezunlarımız için kariyer danışmanlığı desteği sunulması ile faaliyetlerimizin raporlanması, incelenmesi ve denetlenmesi amaçlarıyla yurtiçinde veya yurtdışında işliyoruz.\n" +
        "\n" +
        "Kişisel verilerim başkalarına aktarılıyor mu?\n" +
        "Kişisel verilerinizi yurtiçi veya yurtdışındaki üçüncü kişilere aktarıyoruz. Kişisel verilerinizi kimlere, hangi amaçlarla aktardığımız aşağıda belirtilmektedir:\n" +
        "Faaliyetlerimizin mevzuata uygun olarak yürütülmesi, yetkili kişi, kurum veya kuruluşlara bilgi verilmesi, hukuki yükümlülüklerimizin yerine getirilmesi; Yetkili Kişi, Kurum veya Kuruluşlar.\n" +
        "Üçüncü kişilerden mal veya hizmet tedariki kapsamında destek alınması, operasyonlarımızın devamlılığının sağlanması, finans ve muhasebe işlerinin yürütülmesi; Tedarikçiler.\n" +
        "Denetim ve raporlamaların yapılabilmesi, organizasyon ve etkinliklerin düzenlenmesi, iş ortaklarımız ile olan ilişkilerin yönetimi, Bahçeşehir Grup Şirketleri politika ve kurallarına uyumluluğun sağlanması; İş Ortakları.\n" +
        "\n" +
        "Kişisel verilerimi işlerken dayanılan hukuki sebepler neler?\n" +
        "Kişisel verilerinizi işlerken Kişisel Verilerin Korunması Kanunu’nun 5. maddesinde belirtilen “bir hakkın tesisi, kullanılması veya korunması” ile “kişisel veri işlemenin meşru menfaatlerimiz için zorunlu olması” hukuki sebeplerine dayanmaktayız. Bu hukuki sebepler, aşağıda örnek veri işleme faaliyetleri ile açıklanmıştır:\n" +
        "\n" +
        "– Örneğin, talep eden mezunlarımıza kariyer\n" +
        "danışmanlığı sunulması; özgeçmişlerinin talepleri\n" +
        "doğrultusunda firmalar ile paylaşılması.\n" +
        "\n" +
        "– Örneğin, mezunlarımızın üniversite ile bağlılıklarının\n" +
        "ölçümlenmesi, mezun bağlılığı ve memnuniyetinin\n" +
        "artırılmasına yönelik aktivitelerin planlanması.\n" +
        "\n" +
        "Kişisel veri sahibi olarak haklarımı nasıl kullanabilirim?\n" +
        "Kişisel Verilerin Korunması Kanunu’nun 11. maddesinde kişisel veri sahibi ilgili kişilere tanınan bazı haklar bulunmaktadır. Bu haklarınızı kullanmak için Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ’de (kısaca “Tebliğ”) bazı usuller belirlenmiştir. Haklarınızı kullanmak isterseniz, aşağıdaki yöntemlerden biri ile ya da Tebliğ’de belirtilen diğer yöntemlerle talebinizi bize iletebilirsiniz:\n" +
        "İnternet sitesi aracılığıyla; bau.edu.tr adresindeki İlgili Kişi Başvuru Formu’nu doldurarak,\n" +
        "Posta yoluyla; Çırağan Cad. Osmanpaşa Mektebi Sok. No: 4 – 6, 34353, Beşiktaş/İstanbul posta göndererek,\n" +
        "E-posta yoluyla; BAU İrtibat Kişisi’nin kvkk@bau.edu.tr adresine e-posta göndererek.\n" +
        "\n" +
        "Detaylı bilgiye nasıl ulaşabilirim?\n" +
        "BAU’nun kişisel verileri nasıl işlediği hakkında detaylı bilgi almak için;\n" +
        "bau.edu.tr adresindeki “Kişisel Verilerin İşlenmesi ve Korunması Politikası”nı inceleyebilir,\n" +
        "BAU İrtibat Kişisi’nin kvkk@bau.edu.tr adresine e-posta gönderebilirsiniz.\n",





    leave_of_absence_statement: "გსურთ დახუროთ ფორმა არჩეული görüşme შედეგით?",
    leave_with_consent_verify_text: "არჩევული პროგრამებისთვის კავშირის შეწყვეტის მოთხოვნას ადასტურებთ?",
    leaving_academic_year: "გასული სეზონი",
    leaving_date: "გასვლის თარიღი",
    lms_id: "LMS ID",
    leaving_date_between: "გასვლის თარიღის შუალედი",
    leaving_information: "გასვლის ინფორმაცია",
    leaving_semester: "გასული სემესტრი",
    lecturer_report: "კურსის ანგარიში",
    lesson_pool: "საგნების აუზი",
    lesson_time: "საგნის დრო",
    lesson_timetable: "საგნების განრიგი",
    lessons_only_and_delete_students: "საგნები დახურე, სტუდენტები წაშალე",
    lessons_only_and_delete_students_and_sms_send: "საგნები დახურე, სტუდენტები წაშალე და SMS გააგზავნე",
    lessons_we_have_not_taken_before: "მანამდე არჩეული საგნები",
    lessons_you_have_taken: "არჩეული და ჩავარდნილი საგნები",
    letter_grade: "ასო ნიშნები",
    level: "დონე",
    line_number: "{number}. ხაზი: ",
    list: "სია",
    list_of_student_taking_the_course: "კურსზე ჩაწერილი სტუდენტების სია",
    loading: "იტვირთება",
    log_detail: "ოპერაციის დეტალი",
    log_id: "ოპერაციის ID",
    log_message: "შეტყობინება",
    log_name: "ოპერაციის სახელი",
    log_status: "ოპერაციის სტატუსი",
    log_time: "ოპერაციის დრო",
    log_type: "ოპერაციის ტიპი",
    log_type_count: "ოპერაციის ტიპების რაოდენობა",
    login: "შესვლა",
    logo1: "ლოგო",
    logout: "უსაფრთხო გამოსვლა",
    local_name: "ლოკალური სახელი",
    local_surname: "ლოკალური გვარი",
    lookbook_detail: "ლუქბუქის დეტალები",
    loa_discount_rate: "კურსის შეჩერების ფასდაკლების კოეფიციენტი",
    log_rapors: "ლოგების ანგარიშები",
    leave_of_absence_cancel_proccess_text: "გსურთ პროცესის დასრულება? ადასტურებთ?",
    logs: "ლოგები",
    last_meeting_date_from: "ბოლო შეხვედრის დასაწყისი",
    last_meeting_date_to: "ბოლო შეხვედრის დასასრული",
    last_updated: "ბოლო განახლება",
    last_update_datetime: "ბოლო განახლების თარიღი",
    language_key: {
        tr: "თურქული",
        en: "ინგლისური"
    },
    letter_of_intent: "განზრახვის წერილი",
    letter_of_intent_info1: "ამ ველში დაწერეთ წერილი, რომელშიც წარმოაჩენთ საკუთარ თავს, კურსის არჩევის მიზნებს და აქამდე შესრულებულ სამუშაოებს.",
    link: "ბმული",
    letter_of_intent_info: "საკრავი შესრულების მიმართულების კანდიდატებმა განზრახვის წერილში თავიანთი ინსტრუმენტიც უნდა მიუთითონ.",


    // L
    library_reservation: "ბიბლიოთეკის რეზერვაცია",
    study_rooms: "სასწავლო ოთახები",
    library_reservation_info_text: "გთხოვთ, აირჩიოთ ოთახი, რომელშიც გსურთ მუშაობა, შემდეგ კი გახსნილ ეკრანზე აირჩიეთ თარიღი და სეანსი (დრო), რომ იხილოთ თავისუფალი ადგილები.",
    total_chairs: "სულ სავარძლები",
    reservation_transaction: "რეზერვაციის ტრანზაქცია",
    reservation_date: "რეზერვაციის თარიღი",
    session_seating_plan: "სეანსის დასაჯდომი გეგმა",
    occupied: "დაკავებულია",
    no_session_found_for_date: "ამ თარიღისთვის სეანსი ვერ მოიძებნა. გთხოვთ, აირჩიოთ სხვა თარიღი.",
    this_chair_is_occupied: "ეს სავარძელი სამწუხაროდ დაკავებულია თქვენი მიერ არჩეულ დროის ინტერვალში.",
    reservation_confirm: "რეზერვაციის დადასტურება",
    yes_reserve_for_me: "დიახ, დავაჯავშნი",
    on_date: "თარიღი",
    in_session: "სეანსი",
    reserve_chair_number: "გნებავთ დაჯავშნოთ სავარძელი ნომერი",
    open_door: "კარის გახსნა",
    open_door_confirm_text: "დარწმუნებული ხართ, რომ გსურთ კარის გაღება? მოქმედების შემდეგ ჯავშნის გაუქმება შეუძლებელია.",
    open_door_fail: "ოპერაცია ვერ შესრულდა",
    active_reservation: "აკტიური ჯავშნა",
    reservation_cancel: "ჯავშნის გაუქმება",
    session_cancellation_confirm: "დარწმუნებთ გააუქმოთ ეს სეანსი?",


    // M
    money_order: "გადარიცხვა/EFT",
    married: "ქორწინებული",
    mail_order: "ფოსტის შეკვეთა",
    major_type: "მიმართულება",
    major_types: "მიმართულების ტიპები",
    make_payment: "გადახდა",
    midterm: "შუალედური გამოცდა",
    final: "ფინალური გამოცდა",
    makeup: "გადასაათი გამოცდა",
    make_up_exam: "გადასაათი გამოცდა",
    make_up_exam_entry: "გადასაათი გამოცდის შესვლა",
    make_up_additional_student_list: "დამატებითი სტუდენტების სია გადასაათისთვის",

    male: "მამრობითი",
    mass_course_closure: "საგნების ერთობლივად დახურვა",
    mass_absence_chose: "ერთობლივი არყოფნის არჩევა",
    mass_absence_update: "არარსებობის დაფიქსირება",
    major_major_dismissal_report: "ძირითადი/ორმაგი სპეციალობის შეწყვეტის ანგარიში",
    mandatory: "აუცილებელი",
    max_capacity: "მაქს. ტევადობა",
    max_duration: "მაქს. ხანგრძლივობა",
    max_class_average: "მაქს. კლასის საშუალო",
    max_score: "მაქს. ქულა",
    minister_order_date:"მინისტრის ბრძანების თარიღი",
    minister_order_number:"მინისტრის ბრძანების ნომერი",
    material_requests: "მასალების მოთხოვნები",
    maintenance_date: "შენარჩუნების თარიღი",
    medicine_group_code: "მედიცინის ჯგუფის კოდი",
    medicine_groups_title: "მედიცინის ფაკულტეტის სტუდენტური ჯგუფის შეცვლა",
    medicinegroup: "მედიცინის ჯგუფები",
    medications_used:"მედიკამენტები_გამოყენებული",
    medicines: "თუ იღებს მუდმივ მედიკამენტებს",
    meeting_duration: "შეხვედრის ხანგრძლივობა",
    meeting_number: "შეხვედრების რაოდენობა",
    meeting_place: "შეხვედრის ადგილი",
    meetings: "შეხვედრები",
    member_type: "წევრობის ტიპი",
    menu: "მენიუ",
    menu_items: "მენიუს პუნქტები",
    message: "შეტყობინება",
    message_en: "შეტყობინება En",
    medium_of_instruction: "სწავლების ენა",
    microsoft_user_id: "Microsoft მომხმარებლის ID",
    microsoft_teams_group:"მაიკროსოფტ თიმ ჯგუფი",
    merge_section_deleted: "გაერთიანებული სექცია წაიშალა",
    my_make_up_exams: "ჩემი გადასაათი გამოცდები",
    my_observer: "ჩემი მეთვალყურეობები",
    my_courses: "ჩემი საგნები",
    my_invoices: "ჩემი ინვოისები",
    my_profile: "ჩემი პროფილი",
    my_uploaded_documents: "ჩემი ატვირთული დოკუმენტები",
    will_take_make_up_exams: "გადასაათი გამოცდაზე გასასვლელები",
    midterm_and_final_data_collection: "შუალედური და ფინალური მონაცემთა შეგროვება",
    midterm_exam: "შუალედური გამოცდა",
    minor_branch_dismissal_report_for_not_registering_for_courses: "კურსზე არჩენილი სტუდენტების გვერდითი მიმართულების შეწყვეტის ანგარიში",
    military: "სამხედრო",
    military_branch: "სამხედრო განყოფილება",
    military_branch_number: "სამხედრო განყოფილება - ნომერი",
    military_delay_date: "სამხედრო გადავადების თარიღი",
    military_information: "სამხედრო ინფორმაცია",
    military_office: "სამხედრო ოფისი",
    military_service_city: "სამხედრო განყოფილების ქალაქის კოდი/სახელი",
    military_service_city_code: "ქალაქის კოდი",
    military_status: "სამხედრო სტატუსი",
    major_graduate_minor_branch_dismissal_report: "ძირითადი კურსის დამთავრებისას გვერდითი მიმართულების შეწყვეტის ანგარიში",
    military_status_document: "სამხედრო სტატუსის დოკუმენტი",
    min_pass_count: "მინ. ჩაბარებების რაოდენობა",
    min_point: "მინ. ქულა",
    min_rank: "მინ. რანგი",
    min_score: "მინ. ქულა",
    minor_application: "გვერდითი სპეციალობის განაცხადი",
    minor_application_leave_with_consent_report_excel: "yandal-ilisik-kesme-raporu",
    minor_application_leave_with_consent_report: "გვერდითი სპეციალობის შეწყვეტის ანგარიში საშუალო ქულით",
    minor_application_start: "გვერდითი სპეციალობაზე განაცხადის დაწყება",
    minor_application_quotas: "გვერდითი სპეციალობის განაცხადის კვოტები",
    minor_applications: "გვერდითი სპეციალობის განაცხადები",
    minor_programs: "",
    minor_certificate: "გვერდითი სპეციალობის სერტიფიკატი",
    minor_certificate_ebys_send: "გვერდითი სერტიფიკატის EBYS გაგზავნა",
    minute: "წუთი",
    min_number_of_participants: "მინ. მონაწილეთა რაოდენობა",
    min_relative_score: "მინ. შედარებითი ქულა",
    min_final_score: "მინ. ფინალური ქულა",
    min_semester_score: "მინ. სემესტრის ქულა",
    ministry_of_health_registration_date: "რეგისტრაციის თარიღი",
    ministry_of_health_registration_number: "რეგისტრაციის ნომერი",
    missing_document: "დაკარგული დოკუმენტი",
    missing_documents: "დაკარგული დოკუმენტები",
    missing_documents_report: "დაკარგული დოკუმენტების ანგარიში",
    mobile_number: "მობილურის ნომერი",
    mobile_number_update: "მობილურის ნომრის განახლება",
    mobile_placeholder: "შეიყვანეთ მობილურის ნომერი",
    mobile_verify_not: "მობილურის ნომერი სავალდებულოა დასადასტურებლად!",
    mode_of_study: "სწავლების ტიპი",
    module: "მოდული",
    module_id: "მოდულის ID",
    model: "მოდელი",
    monday: "ორშაბათი",
    month: "თვე",
    month3:"3 თვე",
    mother: "დედა",
    mother_gsm: "დედის საკონტაქტო ნომერი",
    mother_job: "დედის პროფესია",
    mother_name: "დედის სახელი",
    mothers_education: "დედის განათლება",
    mothers_gsm: "დედის საკონტაქტო ტელეფონი",
    mothers_job: "დედის სამუშაო",
    move: "გადატანა",
    move_here: "აქ გადატანა",
    move_payment: "გადახდის გადატანა",
    move_payment_plan: "გადახდის გეგმის გადატანა",
    move_up_course: "დამატებითი კურსის შექმნა",
    multiple_choice: "მრავალჯერადი არჩევანი",
    multiselect_deselect: "წაშლისთვის დააჭირეთ Enter-ს",
    multiselect_select: "არჩევისთვის დააჭირეთ Enter-ს",
    multiselect_selected: "არჩეულია",
    my_jobs: "ჩემი სამუშაოები",
    mernis_edit: "Mernis განახლება",
    mernis_information: "Mernis ინფორმაცია",
    my_requests: "ჩემი მოთხოვნები",
    my_course_schedule: "ჩემი კურსის განრიგი",
    meeting_date: "შეხვედრის თარიღი",
    meeting_doing_person: "შეხვედრის წამყვანი",
    meeting_planed_date: "დაგეგმილი შეხვედრის თარიღი",
    meeting_content: "შეხვედრის შინაარსი",
    meeting_add: "შეხვედრის დამატება",
    meeting_type: "შეხვედრის ტიპი",
    meeting_status: "შეხვედრის სტატუსი",
    responsiblePerson: "პასუხისმგებელი პირი",
    responsible: "პასუხისმგებელი",
    meeting_description: "შეხვედრის აღწერა",
    meeting_report: "შეხვედრის ანგარიში",
    makeup_letter_entry: "გადასაათი ნიშნების შეყვანა",
    makeup_letter_grade_entry_save_msg: "გადასაათი ნიშნების ცხრილი შეინახება. ადასტურებთ?",
    messages: "შეტყობინებები",
    message_new: "შეტყობინების დაწერა",
    message_send: "შეტყობინების გაგზავნა",
    message_delete_confirm: "გსურთ შეტყობინების წაშლა?",
    message_lock: "დახურული შეტყობინება",
    message_unlock: "ღია შეტყობინება",
    meb_information: "MEB ინფორმაცია",
    military_status_description: "სამხედრო სტატუსის აღწერა",
    military_status_code: "სამხედრო სტატუსის კოდი",
    military_delay_status_code: "სამხედრო გადავადების კოდი",
    military_delay_status_description: "სამხედრო გადავადების აღწერა",
    military_branch_to: "სამხედრო განყოფილების ხელმძღვანელობას",
    minor_applications_yok_report: "გვერდითი სპეციალობის YÖK ანგარიში",
    monthly_collection_report: "თვიური შემოსავლის ანგარიში",
    marriage_status: "ქორწინების სტატუსი",
    meeting_note: "შეხვედრის შენიშვნა",
    must_have: "აუცილებელი კრედიტი",
    message_is_required: "შეტყობინების ველი სავალდებულოა.",
    message_date_is_required: "შეტყობინების და თარიღის ველი სავალდებულოა.",
    message_bulk_btn: "ჯგუფური შეტყობინება",
    message_bulk_title: "ჯგუფური შეტყობინების გაგზავნა",
    message_bulk_to: "ვისთვის: არჩეული ფილტრების მიხედვით ჯგუფური გაგზავნა!",
    mission: "მისია",
    member_at: "წევრობის თარიღი",
    member_search_import_excel: "სტუდენტის ნომერი, მისია, წევრობის თარიღი, ტელეფონი, ელ-ფოსტა",
    main_field: "ძირითადი სფერო",
    min_ticket_count: "მინ. ბილეთების რაოდენობა",
    max_ticket_count: "მაქს. ბილეთების რაოდენობა",
    music_teories: "მუსიკის თეორიები",
    manage: "მართვა",
    my_student_clubs: "ჩემი სტუდენტური კლუბები",


    no_announcements: "განცხადება არ მოიძებნა.",
    number_of_students_and_collection_report: "სტუდენტების რაოდენობა და ბრუნვის ანგარიში",
    number_of_students_and_collection_by_classes_report: "კლასების მიხედვით სტუდენტების რაოდენობა და ბრუნვის ანგარიში",
    number_of_people: "პირების რაოდენობა",
    not_sent: "გაგზავნილი არაა",
    not_verified: "ვერ დამოწმდა",
    not_placed: "ვერ განთავსდა",
    not_completed_undergraduate: "განაცხადი অসমাপ্তია, შეფასებაში ვერ მიიღეთ მონაწილეობა",
    nationality_type: "ქვეყნის კოდი",
    nationality_code: "მოქალაქეობის კოდი",
    number_characters_entered: "შეყვანილი სიმბოლოების რაოდენობა",
    n_options_selected: "{n} ვარიანტი არჩეულია",
    name: "სახელი",
    name_en: "სახელი (ინგლისურად)",
    name_placeholder: "შეიყვანეთ თქვენი სახელი",
    name_surname: "სახელი გვარი",
    national_credit: "ეროვნული კრედიტი",
    national_credit_of_uncompleted_slots: "დაუმთავრებელი სლოტების ეროვნული კრედიტი",
    national_id: "პირადი ნომერი",
    national_ids: "პირადი ნომრები",
    national_id_passport_no: "პირადი ნომერი / პასპორტის ნომერი",
    national_id_placeholder: "შეიყვანეთ პირადი ნომერი",
    national_number: "პირადი ნომერი",
    nationality: "მოქალაქეობა",
    nationality_option: "მოქალაქეობის ვარიანტი",
    necessity: "აუცილებლობა",
    neighborhood: "მეზობლობა",
    new: "ახალი",
    new_draft: "ახალი მონახაზი",
    new_exam: "ახალი გამოცდა",
    new_option: "ახალი ვარიანტი",
    new_password: "ახალი პაროლი",
    number_of_chairs:"სკამების რაოდენობა",
    new_password_repeat: "ახალი პაროლი - გამეორება",
    new_payment_collection: "ახალი ინკასო",
    new_request: "ახალი მოთხოვნა",
    new_question: "ახალი კითხვა",
    new_register: "ახალი სტუდენტის რეგისტრაცია",
    new_section: "ახალი სექცია",
    new_part: "ახალი ნაწილი",
    new_status_radio: "ახალი სტატუსის მინიჭება",
    new_window: "ახალი ფანჯარა",
    new_students: "ახალი სტუდენტები",
    new_and_reenrollment_collection_report: "ახალი და განახლებული რეგისტრაციის ბრუნვის ანგარიში",
    next: "შემდეგი",
    no: "არა",
    number_of_report_days:"ანგარიშგების დღეების რაოდენობა",
    no_lessons_to_be_added: "დასამატებელი საგანი არ მოიძებნა",
    no_course: "კურსი ვერ მოიძებნა.",
    no_grades_entered: "ქულები შეყვანილი არაა",
    no_installment_message: "თქვენს ბარათზე განვადება შეუძლებელია.",
    no_options: "ვარიანტები ვერ მოიძებნა.",

    no_payment: "გადაიხადეთ!",
    number_of_electives_within_the_department: "კათედრის შიგნით არჩევითი საგნების რაოდენობა",
    number_of_electives_within_the_department_credit: "კათედრის შიგნით არჩევითი საგნების AKTS კრედიტი",
    no_result: "ჩანაწერი ვერ მოიძებნა",
    no_result_1: "ვერ მოიძებნა",
    no_result_2: "ჩანაწერი ვერ მოიძებნა",
    no_info_found: "ინფორმაცია ვერ მოიძებნა",
    no_theoretical_course_selection_has_been_made: "აირჩიეთ სექცია.",
    no_practical_course_selection_has_been_made: "პრაქტიკული კურსი არჩეული არაა",
    non_dep_course_count: "დასამთავრებელი NOND საგნების რაოდენობა",
    non_dep_course_credit: "დასამთავრებელი NOND კრედიტი",
    non_dep_course_ects_credit: "დასამთავრებელი NOND AKTS",
    none: "არცერთი",
    non_renewal_yu_student_report: "ჩანაწერის განახლებამდე დავაკმაყოფილებელი ანგარიში YU",
    non_renewal_student_report: "ჩანაწერის განახლებამდე დავაკმაყოფილებელი ანგარიში",
    none_of_students: "ვერცერთი სტუდენტი",
    not_allow_attendance_updates: "ჰాజრობის განახლება აკრძალულია",
    not_selected: "არჩეული არაა",
    not_have_payment_approval: "გადახდის თანხმობა არ გაქვთ",
    not_include_calculation: "გამოთვლაში არ ჩაერთვება გამოცდების რაოდენობა",
    not_required: "სავალდებულო არაა",
    name_to_see: "საჩვენებელი სახელი",
    not_required_documents: "(*) მონიშნული დოკუმენტების ატვირთვა სავალდებულოა.",
    not_studied: "არ უსწავლია",
    not_taken: "არ აღებულა",
    not_uploaded: "ატვირთული არაა",
    note: "შენიშვნა",
    note_for_document: "შენიშვნა",
    note_you_want_to_add: "შენიშვნა, რომლის დამატებაც გსურთ",
    notes: "შენიშვნები",
    notexcredit: "ქულა x კრედიტი",
    notes_key: "შენიშვნები",
    note_area: "შენიშვნების ველი",
    now_job: "პროცესის დაუყოვნებლივ შესრულება",
    number: "რიგი",
    number_of_courses_taken: "აღებული საგნების რაოდენობა",
    number_of_done_exams: "გავლილი გამოცდების რაოდენობა",
    number_of_exams: "გამოცდების რაოდენობა",
    number_of_extra_course: "დამატებითი საგნების რაოდენობა",
    number_of_extra_course_taken: "აღებული დამატებითი საგნების რაოდენობა",
    number_of_installments: "განვადებების რაოდენობა",
    number_of_leave_of_absence: "დაყინული სემესტრების რაოდენობა",
    number_of_observers: "მეთვალყურეების რაოდენობა",
    participant_count: "მონაწილეთა რაოდენობა",
    number_of_promissory: "საგარანტიო წერილების რაოდენობა",
    nurse:"მედდა",
    number_of_records_updated: "განახლებული ჩანაწერების რაოდენობა",
    number_of_registered_courses: "დარეგისტრირებული კურსების რაოდენობა",
    number_of_remaining_semesters: "დარჩენილი სემესტრების რაოდენობა",
    number_of_semesters: "გასავლელი სემესტრების რაოდენობა",
    number_of_semesters_studied: "გავლილი სემესტრების რაოდენობა",
    number_of_students: "სტუდენტების რაოდენობა",
    number_of_class: "კლასების რაოდენობა",
    number_of_students_report: "სტუდენტების რაოდენობის ანგარიში",
    number_of_participants: "მონაწილეთა რაოდენობა",
    numerical_score: "ციფრული ქულა",
    new_message: "ახალი შეტყობინება",
    new_advisor_staff: "ახალი ხელმძღვანელი",
    number_of_students_by_status_report: "სტუდენტების რაოდენობის სტატუსის მიხედვით ანგარიში",
    new_event: "ახალი ღონისძიება",
    not_attended: "არ გამოცხადდა",
    not_approved:"არ არის დამტკიცებული",
    not_working: "არ მუშაობს",
    not_working_reason: "არამუშაობის მიზეზი",
    not_working_in_military: "სამხედრო სამსახურშია",
    not_working_no_info: "ინფორმაცია არ არის მიწოდებული",
    not_working_other: "სხვა",
    not_working_education: "განათლების გამო",
    not_working_marriage: "ქორწინება/შობადობა",
    not_working_searching_job: "სამუშაოს ეძებს",

    // O
    operation: "ოპერაცია",
    online_payment_read_and_approve: "<strong> ონლაინ გადახდის ხელშეკრულება </strong> წავიკითხე, გავიგე და ვეთანხმები.",
    is_online_required: "ონლაინ სავალდებულოა?",
    objectives: "მიზნები",
    oauth_confirmation_text: "{client} სურს UMIS ანგარიშით შესვლა.",
    observers: "მეთვალყურეები",
    observer: "მეთვალყურე",
    office: "ოფისი",
    offset_amount: "დარიცხვის თანხა",
    offset_date: "დარიცხვის თარიღი",
    offset_total: "დარიცხვის ჯამი",
    offsets_detail: "დარიცხვის დეტალი",
    offset_balance_report: "დარიცხვის ბალანსის ანგარიში",
    ok: "კარგი",
    old_name: "ძველი სახელი",
    old_name_if_exists: "თუ არსებობს ძველი სახელი",
    ombudsman: "ომბუდსმენი",
    one_time_payment: "ერთჯერადი გადახდა",
    ois_student_transfer: "OİS-დან სტუდენტის გადმოტანა",
    ois_student_course_transfer: "OİS-დან სტუდენტის კურსების გადმოტანა",
    online: "ონლაინ",
    online_credit_card: "ონლაინ საკრედიტო ბარათი",
    online_reg_not_1: "მხოლოდ ÖSYM-ით ჩარიცხული სტუდენტებისთვის გამოიყენება.",
    online_reg_not_2: "ონლაინ რეგისტრაციის პროცესში ტექნიკური პრობლემის შემთხვევაში",
    online_reg_not_3: "მისამართზე დაგვიკავშირდით.",
    online_reg_system: "ონლაინ რეგისტრაციის სისტემა",
    OSYM_score_inquiry: "ÖSYM ქულის ძიება",
    OSYM_score_inquiry_with_national_ids: "TCKN-ით ÖSYM ქულის ძიება",





    online_payment_text: `Yurt ücretleri Güz – Bahar Dönemleri olarak ( 9 ay ) alınır.

    1)	Üniversite Akademik takviminde yer alan ders başlama tarihinden önce yurttan ayrılanlara; yurt ücretinin %10’u dışındaki kısmı iade edilir.

    2)	Akademik Yıl Başında yapılan Üniversite Yabancı Diller Yüksekokulu Dil sınavını başarıyla geçerek 1.sınıfa başlayan öğrencilerin, sınavdan önceki süreçte yurda kayıt yaptırması durumunda, parasının tamamı iade edilir.

    3)	Ara dönemde Yabancı Diller Yüksekokulu Dil Sınavını başarıyla geçen öğrencilerin yurttan ayrılmak istemeleri durumunda barınma hizmeti alınan ayların ücreti, içinde bulunan ayın ücretinin tamamı ve kalan aylara ait yıllık barınma ücretinin %30’u kesilerek ücret iadesi yapılır. Hizmet Sunum Taahhütnamesi feshedilir.

    4)	Ders başlama tarihinden sonra ayrılanlara ise; barınma hizmeti alınan ayların ücreti, içinde bulunan ayın ücretinin tamamı ve kalan aylara ait yıllık barınma ücretinin %30’u kesilerek ücret iadesi yapılır.

    5)	Yabancı Diller Yüksekokulu Temmuz ayı 5.Modül (Yaz Okulu) devam edecek olan öğrencilerden 1 aylık ayrıca ücret tahsis edilecektir.

    6)	 Ücret iadeleri öğrencinin iade talebine dair dilekçesini sunduğu tarihten itibaren bir ay içinde beyan edeceği banka hesabına yapılır. İade talebi için onaylanmış Yurt İlişik Kesme Formu ve iade talebine dair dilekçe ile Yurt Müdürlüğü’ne başvuru yaparak Müdürlük onayı aranır.`,





    open_parameter: "პარამეტრის მახასიათებლები",
    option: "ვარიანტი",
    or: "ან",
    order: "დალაგება",
    ordered: "დალაგებული",
    unordered: "დაულაგებელი",
    order_of_preference: "პიროვნული უპირატესობის რიგი",
    osymDocCode: "შედეგების დოკუმენტის საკონტროლო კოდი",
    osym_preference_code: "ÖSYM უპირატესობის კოდი",
    osymExamCode: "შედეგების დოკუმენტის გადამოწმების კოდი",
    osym_address_information: "ÖSYM-დან მიღებული მისამართი",
    osym_code: "ÖSYM კოდი",
    osym_information: "ÖSYM ინფორმაცია",
    osym_placement_document: "ÖSYM განთავსების დოკუმენტი",
    osym_result_document: "ÖSYM შედეგების დოკუმენტი",
    osym_scholarship: "ÖSYM სტიპენდია",
    osym_score_information: "ÖSYM ქულების ინფორმაცია",
    osymquota: "ÖSYM კვოტა",
    osym_data: "ÖSYM მონაცემები",
    osym: "OSYM",
    osym_scholarship_rate: "ÖSYM სტიპენდიის პროცენტი",
    other: "სხვა",
    other_identies: "სხვა პირადობები",
    other_information: "სხვა ინფორმაცია",
    other_payments: "სხვა გადასახადები",
    other_programs: "სხვა პროგრამები",
    other_signers: "სხვა ხელმომწერები",
    other_university: "სხვა უნივერსიტეტი",
    outputs: "სერტიფიკატის ასლები",
    other_documents: "სხვა დოკუმენტები",
    outbox: "გაგზავნილი წერილები",
    out_of_field: "სფეროს გარეთ",
    open: "ღია",
    only_parent: "მხოლოდ ძირითადი განვადებები",
    only_pdf_files_can_be_uploaded: "მხოლოდ Pdf ფაილის ატვირთვა შეიძლება",
    only_png_files_can_be_uploaded: "მხოლოდ Png ფაილის ატვირთვა შეიძლება",
    opera_music_singer: "ოპერის მომღერალი",
    osym_exam_results: "ÖSYM შედეგები",
    osym_searching: "ÖSYM-ში ძიება...",
    obp_point: "საშუალო სკოლის წარმატების ქულა",
    occupational_profiles_of_graduates: "კურსდამთავრებულთა პროფესიული პროფილები",
    order_tr_en: "რიგი - Order",
    other_notes: "სხვა შენიშვნები",
    organization_message: "გამარჯობა, განაცხადისთვის მადლობას გიხდით. ჩვენი ორგანიზაციის გუნდი დაგიკავშირდებათ.",
    otomatic: "ავტომატური",
    opera_and_choir_singing: "ოპერა და გუნდის სიმღერა",
    options: "ვარიანტები",

    has_balance: "ბალანსის მქონენი",
    has_payments: "გადახდების მქონენი",

// Q
    question: "კითხვა",
    questioning: "კითხვის პროცესი",
    questioning_do: "დაკითხვა",
    questions: "კითხვები",
    quota: "კვოტა",
    quota_management: "კლასის ტევადობის მართვა",
    quota_type: "ტევადობის ტიპი",
    quota_type2: "კვოტის ტიპი",
    student_number_short_tr: "სტუდენტის ნომრის მიხედვით დალაგება",
    student_name_short_tr: "სტუდენტის სახელის მიხედვით დალაგება",
    student_number_short_en: "სტუდენტის ნომრის მიხედვით დალაგება (ინგლისური)",
    student_name_short_en: "სტუდენტის სახელის მიხედვით დალაგება (ინგლისური)",

// P
    pathname: "ფაილის გზა",
    patient_history:"პაციენტის ანამნეზი",
    preference: "პირადი უპირატესობა",
    preference_date: "შეფასების თარიღი",
    preference_delete: "პირადი უპირატესობა წაშლილია",
    preference_add: "პირადი უპირატესობა დამატებულია",
    price_edit: "ფასების რედაქტირება",
    price_add: "ფასის დამატება",
    printed_materials: "ბეჭდური მასალები",
    private_classroom: "პირადი საკლასო ოთახი",
    placed: "განთავსებულია",
    place_student: "სტუდენტის განთავსება",
    place_student_are_you_sure: "დარწმუნებული ხართ, რომ გსურთ სტუდენტის წინასწარი რეგისტრაცია?",
    proficiency_exams: "კვალიფიკაციის გამოცდები",
    page: "გვერდი",
    page_not_found: "გვერდი ვერ მოიძებნა!",
    page_messages: "გვერდის შეტყობინებები",
    paid: "გადახდილი",
    parameter: "პარამეტრი",
    placement_exam_scores_excel: "სტუდენტის ნომერი, ქულა, პროგრამის კოდი",
    parameter_id: "პარამეტრის კოდი",
    parameter_items: "პარამეტრის მნიშვნელობები",
    parent_id: "Parent ID",
    parent_course: "მშობელი კურსი",
    parts: "განყოფილებები",
    participation: "მონაწილეობა",
    passive: "პასიური",






    passport_country: "პასპორტის გაცემის ქვეყანა",
    passport: "პასპორტი",
    passport_number: "პასპორტის ნომერი",
    password: "პაროლი",
    pay: "გადახდა",
    preparation_report_card_publication_date: "მოსამზადებელი ბარათის გამოქვეყნების თარიღი",
    payments: "გადახდები",
    payment_waiting: "გადახდა მოლოდინშია",
    payment_success: "გადახდა შესრულდა",
    pay_type: "გადახდის ტიპი",
    payer: "გადამხდელი",
    payer_address: "გადამხდელის მისამართი",
    payer_national_id: "გადამხდელის პირადი ნომერი",
    payer_phone: "გადამხდელის ტელეფონი",
    payment: "გადახდა",
    payment_amount: "გადახდის ოდენობა",
    payment_approval: "გადახდის დამტკიცება",
    payment_approval_exceptions: "გადახდის დამტკიცების გამონაკლისები",
    payment_approval_failed: "გადახდის დამტკიცება წარუმატებელია",
    payment_approval_successful: "გადახდის დამტკიცება წარმატებულია",
    payment_approvals: "გადახდის დამტკიცებები",
    payment_date: "გადახდის თარიღი",
    payment_date_end: "გადახდის ბოლო თარიღი",
    payment_date_start: "გადახდის საწყისი თარიღი",
    payment_end_date: "გადახდის ბოლო თარიღი",
    payment_start_date: "გადახდის საწყისი თარიღი",
    payment_info: "გადახდის ინფორმაცია",
    payment_info_message: "გადახდა დამტკიცების შემდეგ ინფორმაცია მოგეწვდებათ ელფოსტით/SMS-ით.",
    payment_info_update: "გადახდის ინფორმაციის განახლება",
    payment_id: "გადახდის ID",
    payment_method: "გადახდის მეთოდი",
    payment_packages: "გადახდის პაკეტები",
    payment_plan: "გადახდის გეგმა",
    payment_plan_create_btn: "გადახდის გეგმის შექმნა",
    payment_plan_title: "გადახდის გეგმები",
    payment_plan_types: "ტიპი",
    payment_plans: "გადახდის გეგმები",
    payment_plans_report: "გადახდის გეგმების ანგარიში",
    payment_scholarship_information: "გადახდის/სტიპენდიის ინფორმაცია",
    payment_status: "გადახდის სტატუსი",
    payment_status_E: "არსებობს",
    payment_status_H: "არ არსებობს",
    payment_total: "გადასახდელი თანხა",
    payment_type: "გადახდის ტიპი",
    payment_type1: "ფასის ინფორმაცია",
    payment_type_group: "გადახდის ტიპის ჯგუფი",
    payment_types: "გადახდის ტიპები",
    payments_report: "ინკასო ანგარიში",
    payments_saved: "გადახდები შენახულია",
    payment_types_obj: {
        money_order: "ფულადი გადარიცხვა/EFT",
        credit_card: "საკრედიტო ბარათი",
    },
    please_upload_image: "გთხოვთ ატვირთოთ თქვენი სურათი ქვემოთ მოცემულ ველში.",
    pending: "მოლოდინშია",
    percentile_certificate: "პერსენტილური სერთიფიკატი",
    period: "სემესტრი",
    period_code: "სემესტრის კოდი",
    period_id: "სემესტრის ID",
    period_status: "სემესტრის სტატუსი",
    period_status_not_suitable: "სემესტრის სტატუსი აქტიური არ არის, სლოტის შეცვლა შეუძლებელია",
    period_x: "{period}. სემესტრი",
    periods: "სემესტრები",
    permission: "ნებართვები",
    permission_id: "ოპერაცია",
    permission_information: "ნებართვების ინფორმაცია",
    personal_email: "პირადი ელ-ფოსტა",
    personal_info: "პირადი ინფორმაცია",
    personal_information: "პირადი ინფორმაცია",
    personal_ticket_info: "თქვენს მონაწილეობისთვის გაიცემა ინდივიდუალური სერთიფიკატი.",
    program_outcome: "პროგრამის შედეგები",
    program_basic_field: "პროგრამის ძირითადი სფერო",
    tyyc_basic_fields: "tyyc ძირითადი ტიპი",
    program_outcome_definition: "პროგრამის შედეგის განსაზღვრა",
    program_outcome_definition_text: "პროგრამის შედეგები",
    ph_programs_info: "(*) მხოლოდ სადოქტორო პროგრამებისთვის",
    photo: "სურათი",
    pilotage_collection_report: "პილოტაჟის ინკასო ანგარიში",
    pilotage_invoices: "პილოტაჟის ინვოისები",
    pilotage_prices: "პილოტაჟის გადასახადები",
    pin_code: "Pin კოდი",
    pin: "Pin",
    place_added: "დამატებული ადგილი",
    placement_exam: "დონის განსაზღვრა",
    placement_exam_classroom_delete_confirm_text: "გსურთ წაშალოთ განთავსების გამოცდის კლასის ჩანაწერი?",
    placement_exam_classroom_store_confirm_text: "გსურთ დაამატოთ განთავსების გამოცდის კლასის ჩანაწერი?",
    placement_exam_classrooms_define: "განთავსების გამოცდის კლასის განსაზღვრა",
    placement_exam_classrooms_info: "განთავსების გამოცდის კლასის ინფორმაცია",
    placement_exam_classrooms_ranking: "განთავსების გამოცდის კლასის რეიტინგი",
    placement_exam_classrooms_ranking_success: "განთავსების გამოცდის კლასის რეიტინგი წარმატებით შესრულდა.",
    placement_exam_classrooms_title: "განთავსების გამოცდის კლასები",
    placement_exam_part_classroom_delete_confirm_text: "გსურთ წაშალოთ განთავსების გამოცდის სექციის კლასის ჩანაწერი?",
    placement_exam_part_classroom_store_confirm_text: "გსურთ დაამატოთ განთავსების გამოცდის სექციის კლასის ჩანაწერი?",
    placement_exam_part_classrooms_define: "განთავსების გამოცდის სექციის კლასის განსაზღვრა",
    placement_exam_student_not_fount: "განთავსების კლასის სტუდენტი ვერ მოიძებნა",
    placement_exam_part_classrooms_ranking: "განთავსების გამოცდის სექციის კლასის რეიტინგი",
    placement_exam_part_classrooms_ranking_success: "განთავსების გამოცდის სექციის კლასის რეიტინგი წარმატებით შესრულდა.",
    placement_exam_part_classrooms_title: "განთავსების გამოცდის სექციის კლასები",
    placement_exam_part_classrooms_update: "განთავსების გამოცდის სექციის კლასის განახლება",
    placement_exam_part_classrooms_update_info: "განთავსების გამოცდის სექციის კლასის ინფორმაცია",
    placement_exam_score_upload_info: "განთავსების გამოცდის შედეგების ატვირთვის ინფორმაცია",
    placement_exam_score_upload_title: "განთავსების გამოცდის შედეგების ატვირთვა",
    placement_exam_score_upload: "შედეგის ატვირთვა",
    placement_exams: "დონის განსაზღვრის გამოცდები",
    placement_rank: "განთავსების რიგი",
    placement_student: "განთავსება",
    preparationPeriodNo: "მოსამზადებელი სემესტრის ნომერი",
    program_accepted: "თქვენ მიიღეთ პროგრამაში",
    program_spare: "რეზერვი",
    program_other_placed: "გაიარეთ სხვა არჩევანში",
    placement_student_result: "განთავსების შედეგები",
    placement_score: "განთავსების ქულა",
    placement_success_order: "განთავსების წარმატების რიგი",
    plate: "ფირფიტა",
    please_try_again: "გთხოვთ სცადოთ თავიდან.",
    please_select_a_ticket_type: "აირჩიეთ მონაწილეობის ტიპი",
    point: "ქულის წონა",
    point_type: "ქულის ტიპი",
    points: "ქულები",
    pool: "პული",
    pool_name: "პულის სახელი",
    pool_name_en: "პულის სახელი (EN)",
    pool_type: "პულის ტიპი",
    postal_code: "საფოსტო კოდი",
    practical: "პრაქტიკული",
    practical_credit: "პრაქტიკული",






    precondition: "წინასწარი პირობა",
    preference_information: "პროგრამის არჩევანის ინფორმაცია",
    preference_procedures: "პროგრამის არჩევანის პროცედურები",
    preference_restore_success: "არჩევანი განულდა",
    preferences: "არჩევანები",
    preference_please_add: "გთხოვთ დაამატოთ თქვენი არჩევანები",
    preferences_delete: "არჩევანის წაშლა",
    preferences_edit: "არჩევანის რედაქტირება",
    preference_restore: "არჩევანის განულება",
    preferences_order_change: "არჩევანის თანმიმდევრობის შეცვლა",
    preferred_program: "არჩეული პროგრამა",
    prefers: "ამჯობინა",
    preliminary_information_form: "წინასწარი ინფორმაციის ფორმა",
    prepare_entry: "მონაცემების მომზადება",
    prep_academic_year: "მოსამზადებელი აკადემიური წელი",
    prep_attendance: "დასწრების ჩანაწერი",
    prep_attendance_confirmation_modal: "დასწრების ჩანაწერი შეინახება, ადასტურებთ?",
    prep_attendance_publish_modal: "დასწრების ჩანაწერი გამოქვეყნდება, ადასტურებთ?",
    prep_classes_define_form: "მოსამზადებელი კლასების განსაზღვრის ფორმა",
    prep_classes_delete_confirm_text: "მოსამზადებელი კლასის წაშლა გსურთ, ადასტურებთ?",
    prep_classes_store_confirm_text: "მოსამზადებელი კლასის დამატება გსურთ, ადასტურებთ?",
    prep_classes_title: "მოსამზადებელი კლასები",
    prep_classes_update_confirm_text: "მოსამზადებელი კლასის განახლება გსურთ, ადასტურებთ?",
    prep_classes_update_form: "მოსამზადებელი კლასების განახლების ფორმა",
    prep_classes_update_info: "მოსამზადებელი კლასების ინფორმაცია",
    prep_exam_confirmation_modal: "გსურთ ნოტების შენახვა?",
    prep_exam_definitions: "მოსამზადებელი გამოცდის განსაზღვრები",
    prep_exam_publish_modal: "გსურთ ნოტების გამოქვეყნება?",
    prep_exam_publish_check_modal: "ნოტების გამოქვეყნებამდე უნდა შეინახოთ!",
    please_select_a_course: "გთხოვთ აირჩიოთ კურსი",
    prep_grade_entry: "მოსამზადებელი ნოტების შეყვანა",
    prep_holiday_day: "მოსამზადებელი დასვენების დღეები",
    prep_levels: "დონის კოდი",
    prep_modules: "მოსამზადებელი მოდულები",
    prep_reports: "მოსამზადებელი ანგარიშები",
    prep_schedule: "მოსამზადებელი განრიგი",
    previous: "წინა",
    pos_return_days:"დაბრუნების დღეები",
    prep_schedule_draft_delete_confirm_text: "მოსამზადებელი განრიგის დრაფტის წაშლა გსურთ, ადასტურებთ?",
    prep_schedule_draft_store_confirm_text: "მოსამზადებელი განრიგის დრაფტის დამატება გსურთ, ადასტურებთ?",
    prep_schedule_draft_title: "მოსამზადებელი განრიგის დრაფტები",
    prep_schedule_import_data_excel_format: "სასწავლო ოთახის სახელი, დონე, კლასი, დღე, დაწყების დრო, დასრულების დრო, დაწყების დრო, დასრულების დრო, დაწყების დრო, დასრულების დრო, დაწყების დრო, დასრულების დრო, დაწყების დრო, დასრულების დრო, ლექტორის ID, ლექტორის კონფლიქტი, კლასის კონფლიქტი",
    prep_school: "მოსამზადებელი სკოლა",
    prep_school_approval: "მოსამზადებელი სკოლის დამტკიცება?",
    prep_status: "მოსამზადებელი სტატუსი",
    prep_students: "მოსამზადებელი სტუდენტები",
    prep_students_import_excel_format: "Student Number, Level, კლასი (Section)",
    prep_students_slot_situations: "მოსამზადებელი სტუდენტების სლოტის მდგომარეობა",
    preparation_note_entry: "მოსამზადებელი ნოტების შეყვანა",
    preparatory_bulk_grade_entry: "მოსამზადებელი მასობრივი ნოტების შეყვანა",
    preparatory_class_advancement_blocking: "მოსამზადებელი კლასის დაწინაურების დაბლოკვა",
    preparation_slot_status: "მოსამზადებელი სლოტის სტატუსი",
    preparatory_information: "მოსამზადებელი ინფორმაცია",
    preparatory_information_send: "მოსამზადებელი ინფორმაციის გაგზავნა",
    preparatory_notes: "მოსამზადებელი ქულების ბარათი",
    prerequisites: "წინაპირობები",
    preparation_for_bulk_import_operations: "მოსამზადებელი მასობრივი იმპორტის ოპერაციები",
    preparation_level_grade_entry: "მოსამზადებელი დონის ქულების შეყვანა",
    present: "არის",
    preview: "წინასწარი ნახვა",
    preview_btn_info: "განაცხადის დასასრულებლად დააჭირეთ ქვემოთ მოცემულ შენახვის ღილაკს!",
    preview_save_btn_info: "დოკუმენტების ატვირთვის გარეშე შეგიძლიათ შეინახოთ განაცხადი. შემდეგ მიიღებთ ბმულს, რომლის მეშვეობითაც შეძლებთ დოკუმენტების ატვირთვას.",
    president: "პრეზიდენტი",
    price: "ფასი",
    price_type: "ფასის ტიპი",
    priceless: "უფასო",
    prices: "ფასები",
    print: "ბეჭდვა",
    print_mail_order_form: "Mail Order ფორმის დაბეჭდვა",
    print_promissory_note: "საგარანტიო ქაღალდის დაბეჭდვა",
    print_receipt: "ქვითრის დაბეჭდვა",
    print_roster: "დასწრების სიის დაბეჭდვა",
    print_weekly_roste: "კვირის დასწრების სიის დაბეჭდვა",
    proccess_success: "ოპერაცია წარმატებით შესრულდა",
    proccess_will_be_started: "პროცესი დაიწყება. ადასტურებთ?",
    process: "ოპერაცია",
    process_select: "აირჩიეთ ოპერაცია",
    process_type: "ოპერაციის ტიპი",
    process_can: "ოპერაციის შესრულება",
    processes: "ოპერაციები",
    processing: "ოპერაცია მიმდინარეობს",
    processing_information: "დამუშავების ინფორმაცია",
    processing_model: "დამუშავების მოდელი",
    product: "პროდუქტი",
    product_code: "პროდუქტის კოდი",
    protocol_number:"პროტოკოლის ნომერი",


    products: "პროდუქტები",
    profession_job: "პროფესია",
    proficiency_certificate_type: "კვალიფიკაციის სერტიფიკატის ტიპი",
    proficiency_document: "კვალიფიკაციის სერტიფიკატი",
    proficiency_exam: "კვალიფიკაციის გამოცდა",
    proficiency_requests: "ინგლისური კვალიფიკაციის მოთხოვნები",
    proficiency_status: "მოსამზადებელი სტატუსი",
    proforma_invoice: "პროფორმა ინვოისი",
    proforma_invoices: "პროფორმა ინვოისები",
    program: "პროგრამა",
    program_code: "პროგრამის კოდი",
    program_type: "პროგრამის ტიპი",
    program_code_name: "პროგრამის კოდი / სახელი",
    program_codes: "პროგრამის კოდები",
    program_coordinator: "პროგრამის კოორდინატორი",
    program_days: "პროგრამის დღეები",
    program_decrease: "ამოაღებთ მონიშნულ პროგრამებს.",
    program_delete_info: "პროგრამის წაშლას აპირებთ. გსურთ გაგრძელება?",
    program_info: "პროგრამის ინფორმაცია",
    program_information: "პროგრამის ინფორმაცია",
    program_language: "პროგრამის ენა",
    program_level: "პროგრამის დონე",
    program_level_1: "სასწავლო დონე",
    program_level_d: "დოქტორანტურა",
    program_level_l: "ბაკალავრიატი",
    program_level_ol: "ასოცირებული ხარისხი",
    program_level_yl: "მაგისტრატურა",
    program_name: "პროგრამის სახელი",
    program_name_en: "პროგრამის სახელი EN",
    program_select: "პროგრამის არჩევა",
    program_select_min: "გთხოვთ აირჩიოთ მინიმუმ ერთი პროგრამა!",
    program_selected: "პროგრამა უკვე არჩეულია.",
    programs: "პროგრამები",
    programs_applied: "განაცხადებული პროგრამები",
    programs_selected: "არჩეული პროგრამები",
    programs_to_choose: "არჩევადი პროგრამები",
    programs_you_are_applying: "თქვენი განაცხადის პროგრამები",
    program_groups: "პროგრამის ჯგუფები",
    project_advisory: "პროექტის კონსულტაცია",
    promissory_no: "საგარანტიო ნომერი",
    promissory_note: "საგარანტიო ქაღალდი",
    promissory_payment: "საგარანტიო გადახდა",
    provision: "პროვიზია",
    promotion_code: "პრომო კოდი",
    promotion_code_message: "პრომო კოდი წარმატებით იქნა გამოყენებული!",
    promotion_code_error_message: "პრომო კოდი არასწორია!",
    promotional_process: "სარეკლამო პროცესი",
    public_scholarship: "სახელმწიფო სტიპენდია",
    publish: "გამოქვეყნება",
    publish_at: "გამოქვეყნების თარიღი",
    published: "გამოქვეყნდა",
    punishment: "სასჯელი",
    punishment_end_date: "სასჯელის დასრულების თარიღი",
    punishment_number: "სასჯელის მუხლი",
    punishment_start_date: "სასჯელის დაწყების თარიღი",
    ph_documents_info: "თქვენი დოკუმენტები აირჩიეთ „ფაილის არჩევა“-ზე დაჭერით. ატვირთვის დასასრულებლად უნდა დააჭიროთ „+“ ღილაკს.",
    program_groups_lte: "საერტო საგანმანათლებლო (ლიცენზირებული) პროგრამის ჯგუფები",
    prep_score: "მოსამზადებელი ქულა",
    prep_attendance_status: "მოსამზადებელში დასწრების სტატუსი",
    prep_exam_status: "მოსამზადებელი გამოცდის სტატუსი",
    person: "პირი",
    product_prices_import_format: "ფაკულტეტის კოდი, პროგრამის კოდი, რეგისტრაციის სეზონი, რეგისტრაციის სემესტრი, სტუდენტთა ჯგუფი, ღირებულება, ვალუტა, ვადის თარიღი, ტარიფის რაოდენობა, დაწყების თარიღი, დასრულების თარიღი",
    program_period: "სწავლის ხანგრძლივობა",
    prep_class_studying: "მოსამზადებელი კლასი ესწავლა?",
    prep_class_studying_semesters: "რამდენი სემესტრი ისწავლა მოსამზადებელში",
    program_id: "პროგრამის ID",
    proficiency_status_title: "მოსამზადებელი გათავისუფლება",
    payment_confirmation_document:"გადახდის დადასტურების დოკუმენტი",
    proficiency_point: "მოსამზადებელი გამოცდის ქულა",
    passed_exams_report: "ლექტორის გავლილი გამოცდების ანგარიში",
    passed_absence_report: "ლექტორის გავლილი გაცდენების ანგარიში",
    proficiency_exam_entry_status: "კვალიფიკაციის გამოცდის შესვლის სტატუსი",
    positional_status: "პოზიცია",
    position_detail: "პოზიციის დეტალი",
    password_sent: "პაროლი გაიგზავნა",
    prep_number_of_semesters: "მოსამზადებელში ნასწავლი სემესტრების რაოდენობა",
    payment_or_refund: "გადახდა/დაბრუნება",
    price_simulation: "ფასის სიმულაცია",
    previous_course_code: "ადრე აღებული კურსის კოდი",
    previous_course_name: "ადრე აღებული კურსის სახელი",
    pay_with_vakifbank_vinov: "გადახდა Vakıfbank Vinov-ით",
    prep_module_success_point: "მოსამზადებელი მოდულის ქულა",
    progress_bar_text: "ეს პროცესი შეიძლება გაგრძელდეს {min} წუთი ფაილის ზომიდან გამომდინარე. გთხოვთ არ დააჭიროთ სხვა ღილაკს და არ განაახლოთ გვერდი.",
    password_reminder: "პაროლის შეხსენება",
    popular_music_singer: "პოპულარული მუსიკის მომღერალი",
    placement_exam_name:"განსათავსებლის გამოცდის დასახელება",
    proficiency_exam_scores: "კვალიფიკაციის ქულები",
    province_name: "მხარის სახელი",
    program_definitions: "პროგრამის განსაზღვრები",
    program_duration: "პროგრამის ხანგრძლივობა",
    profile: "პროფილი",
    placemnet_exam_report: "სწავლის დონის განსაზღვრის ანგარიშის ანგარიში",
    program_outcome_definition_name: "პროგრამის შედეგი",
    program_basic_fields: "პროგრამის ძირითადი სფეროები",
    program_level_outcomes: "პროგრამის დონის შედეგები",
    program_basic_field_outcomes: "პროგრამის ძირითადი სფეროს შედეგები",
    program_transition_information: "პროგრამის გადასვლის ინფორმაცია",
    program_vertical: "პროგრამის ვერტიკალური გადასვლა",
    preliminary_course_material: "წინასწარი მოსამზადებელი სასწავლო მასალა",
    purpose: "მიზანი",
    purchase_ticket: "ბილეთის შეძენა",
    purchase_successful: "შეძენა წარმატებულია",
    purchased_tickets: "შეძენილი ბილეთები",
    privacy_notice: "ინფორმაციის შეტყობინება",
    privacy_policy: "კონფიდენციალურობის პოლიტიკა",
    past_application_date: "ძვირფასო კანდიდატ სტუდენტო,",
    previous_exams_must_be_taken: "წინა გამოცდის ქულები უნდა შეყვანილ იქნას",
    purchased_ticket_not_found: "შეძენილი ბილეთი ვერ მოიძებნა.",
    pilotage_payment: "პილოტაჟის გადახდა",
    past_application_date_desc: "ეს არ არის სამაგისტრო პროგრამების განაცხადის პერიოდი. გთხოვთ იხილოთ მიმდინარე განაცხადის თარიღები და ინფორმაცია სამაგისტრო განათლების ინსტიტუტის გვერდზე.",
    popular_music_singing: "პოპულარული მუსიკის შესრულება",
    portfolio: "პორტფოლიო",
    portfolio_share_link: "პორტფოლიოს გაზიარების ბმული",
    portfolio_input_info: "გთხოვთ არ ჩართოთ WeTransfer ბმული. თუ Drive ბმულს ტვირთავთ, დარწმუნდით რომ ღია წვდომაა.",
    portfolio_filesize_alert: "ატვირთული ფაილის ზომა არ უნდა აღემატებოდეს 49MB-ს და უნდა იყოს MP4, PDF ან WAV ფორმატში.",
    paymennt_cartoon_animation: "გადახდა",
    payment_not_paid: "გადახდა არ შესრულდა",
    pool_edit: "ჰავუზის რედაქტირება",

    record_type: {
        manual: "მექანიკური",
        online: "ონლაინ",
    },
    readonly: "შეუძლია ნახოს",
    requirements: "მოთხოვნები",
    random: "შემთხვევითი",
    rank: "რიგი",
    ranking: "დალაგება",
    read_and_accept: " წავიკითხე, გავიგე",
    reason: "მიზეზი",
    reason_for_leaving: "გაყრის მიზეზი",
    reason_for_return: "დაბრუნების მიზეზი",
    return_your_account:"დაბრუნე შენი ანგარიში",
    reason_for_rejection: "უარის მიზეზი",
    reason_for_postponement: "გადავადების მიზეზი",
    reason_to_increase_max_duration: "მაქსიმალური ვადის გაზრდის მიზეზი",
    receipt_number: "ქვითრის ნომერი",
    receipt_number_format: "ქვითრის ნომრის ფორმატი",
    receipt_number_not_created: "ქვითრის ნომერი ვერ შეიქმნა",
    receipt_search: "ქვითრების სია",
    receipts: "ქვითრები",
    refund: "დაბრუნება",
    refund_amount: "დაბრუნების თანხა",
    refund_date: "დაბრუნების თარიღი",
    refund_form: "დაბრუნების ფორმა",
    refund_reason: "დაბრუნების მიზეზი",
    refund_request: "გადახდის დაბრუნების მოთხოვნა",
    refund_requests: "გადახდის დაბრუნების მოთხოვნები",
    refund_request_list: "გადახდის დაბრუნების მოთხოვნების სია",
    refund_type: "დაბრუნების ტიპი",
    registration: "რეგისტრაცია",
    registration_academic_year: "რეგისტრაციის აკადემიური წელი",
    registration_data: "რეგისტრაციის მონაცემები",
    registration_date: "რეგისტრაციის თარიღი",
    registration_dates: "რეგისტრაციის თარიღები",
    registration_date_between: "რეგისტრაციის თარიღის დიაპაზონი",
    registration_delete_text: "გსურთ რეგისტრაციის წაშლა?",
    registration_document_types: "რეგისტრაციის დოკუმენტების ტიპები",
    registration_guide: "რეგისტრაციის გზამკვლევი",
    registration_hour: "რეგისტრაციის საათი",
    registration_information: "რეგისტრაციის ინფორმაცია",
    registration_number: "სარეგისტრაციო ნომერი",
    registration_numbers_by_faculty_report: "ფაკულტეტების მიხედვით რეგისტრაციის ანგარიში",
    registration_numbers_by_faculty_osym_report: "ფაკულტეტების მიხედვით რეგისტრაციის ანგარიში (ÖSYM)",
    registration_season: "რეგისტრაციის სეზონი",
    registration_semester: "რეგისტრაციის სემესტრი",
    registration_statement: "რეგისტრაციის განაცხადი",
    registration_status: "რეგისტრაციის სტატუსი",
    registration_type: "რეგისტრაციის ტიპი",
    registration_type_code: "რეგისტრაციის ტიპის კოდი",
    registration_type_1: "შესვლის ტიპი",
    registration_type_2: "რეგისტრაციის ტიპი",
    registration_type_registration: "რეგისტრაცია",
    registration_type_student: "სტუდენტი",
    registration_types: "რეგისტრაციის ტიპები",
    registration_year: "რეგისტრაციის წელი",
    registrations: "რეგისტრაციები",
    registrations_page_bulk_student_transfer: "რეგისტრაციის გვერდზე სტუდენტების მასობრივი გადატანა",
    registration_and_Collection_report: "რეგისტრაციის და შემოსავლის ანგარიში",
    rector_behalf: "რექტორის მოადგილე",
    rector_title_behalf: "რექტორის მოადგილის წოდება",
    rector_title_en_behalf: "რექტორის მოადგილის წოდება (EN)",
    rector_behalf_start_date: "რექტორის მოადგილის დაწყების თარიღი",
    rector_behalf_end_date: "რექტორის მოადგილის დასრულების თარიღი",
    rejected: "უარყოფილია",
    reject: "უარყოფა",
    reject_why: "უარის მიზეზი",
    relative_grades: "ფარდობითი ნიშნები",
    remaining_amount: "დარჩენილი თანხა",
    remaining_credit: "დარჩენილი კრედიტი",
    remaining_payment_amount: "დარჩენილი გადახდის თანხა",
    remaining_quota: "დარჩენილი კოტა",
    remaining_students_radio: "დარჩენილი სტუდენტები",
    remove_exception_payment_approval: "გამონაკლისი გადახდის დამტკიცების მოხსნა",
    remind_password: "პაროლის შეხსენება",
    repeat: "გამეორება",
    repeat_count: "გამეორების რაოდენობა",
    repeat_student_count: "გამეორების მქონე სტუდენტების რაოდენობა",
    repeat_type: "გამეორების ტიპი",
    repeated_registration: "გამეორებითი რეგისტრაცია",
    repetition_status: "სლოტის გამეორების სტატუსი",
    repetition_status_1: "გამეორების სტატუსი",
    report: "ანგარიში",
    report_type: "ანგარიშის ტიპი",
    reporter_analysis_report: "რეპორტიორის ანალიზის ანგარიში",
    reporter_assignment_letter: "რეპორტიორის დანიშვნის წერილი",
    request_data_count: "მოთხოვნების რაოდენობა",
    request_date: "მოთხოვნის თარიღი",
    request_date_range: "მოთხოვნის თარიღის დიაპაზონი",
    request_information: "მოთხოვნის ინფორმაცია",
    request_number: "მოთხოვნის ნომერი",
    request_reason: "მოთხოვნის მიზეზი",
    request_type: "მოთხოვნის ტიპი",
    requests_info: "მოთხოვნები",
    requests_of_leave_with_consent: "ურთიერთშეთანხმებით დატოვების მოთხოვნები",
    request_result: "მოთხოვნის შედეგი",
    requirement_list: "საჭიროებების სია",
    declined_reason: "უარის მიზეზი",
    required: "აუცილებელია",
    required_course_count: "სავალდებულო კურსების რაოდენობა",
    required_course_credit: "სავალდებულო კურსების კრედიტი",
    required_course_ects_credit: "სავალდებულო კურსების AKTS კრედიტი",
    reservation_add: "რეზერვაციის დამატება",
    reservation_system: "რეზერვაციის სისტემა",
    reservation_type: "რეზერვაციის ტიპი",
    reservations: "რეზერვაციები",
    reset: "განულება",
    residence_address: "საცხოვრებელი მისამართი",
    residence_city: "საცხოვრებელი ქალაქი",
    residence_permit: "ბინადრობის ნებართვა",
    residence_permit_end_date: "ბინადრობის ნებართვის დასრულების თარიღი",
    residence_permit_no: "ბინადრობის ნებართვის ნომერი",
    residence_permit_start_date: "ბინადრობის ნებართვის გაცემის თარიღი",
    residence_permit_validity_dates: "ბინადრობის ნებართვის მოქმედების თარიღები",
    residence_permit_validity_end_date: "მოქმედების დასრულების თარიღი",
    residence_permit_validity_start_date: "მოქმედების დაწყების თარიღი",
    responsible_email: "პასუხისმგებელი პერსონალის ელფოსტა",
    responsible_name: "პასუხისმგებელი პერსონალის სახელი",
    responsible_surname: "პასუხისმგებელი პერსონალის გვარი",
    result: "შედეგი",
    results: "შედეგები",
    role: "როლი",
    role_excel: "როლის Excel",
    role_permissions: "როლის უფლებები",
    roles: "როლები",
    role_filter: "როლის ფილტრი",
    rollback: "დაბრუნება",
    rollback_cancel: "გაუქმების დაბრუნება",
    room: "ოთახი",
    registration_delete_payment_status_error: "გადახდის სტატუსის არსებობის გამო წაშლა შეუძლებელია!",
    remove_approve: "დამტკიცების მოხსნა",
    remove: "ამოშლა",
    refund_date_start: "დაბრუნების თარიღის დაწყება",
    refund_date_end: "დაბრუნების თარიღის დასრულება",
    refunds_report: "დაბრუნების ანგარიში",
    registration_documents_confirm_text: "რეგისტრაციის დოკუმენტის ტიპის დამატებას აპირებთ. გსურთ გაგრძელება?",
    registration_documents_confirm_delete_text: "რეგისტრაციის დოკუმენტის ტიპის წაშლას აპირებთ. გსურთ გაგრძელება?",
    receivers: "მიმღებები",
    receivers_id_added_before: "მითითებული კრიტერიუმების მქონე მიმღებები უკვე დამატებულია!",
    registration_date_just: "რეგისტრაციის თარიღი",
    rows_selected: "სტრიქონი არჩეულია",
    reason_of_extension: "გაგრძელების მიზეზი",
    responsible_person: "პასუხისმგებელი პირი",
    responsible_person_email: "პასუხისმგებელი პირის ელფოსტა",
    responsible_person_update: "პასუხისმგებელი პირის განახლება",
    release_application: "განაცხადის დატოვება",
    raise_rate: "ზრდის მაჩვენებელი",
    registrations_bulk_delete: "სტუდენტების მასობრივი წაშლა",
    recalculate: "თავიდან გამოთვლა",
    n_receivers_created: "%{n} მიმღები დაემატა",
    rector: "რექტორი",
    referred_hospital:"დანიშნული საავადმყოფო",
    rector_order_date:"რექტორის ბრძანების თარიღი",
    rector_order_number:"რექტორის წესრიგის ნომერი",

    rector_title: "რექტორის წოდება",
    rector_title_en: "რექტორის წოდება (EN)",
    register_start_date: "რეგისტრაციის დაწყების თარიღი",
    register_end_date: "რეგისტრაციის დასრულების თარიღი",
    table_11_yok_report: "ცხრილი 11 YÖK ანგარიში",
    table_11b_yok_report: "ცხრილი 11B YÖK ანგარიში",
    recognition_of_prior_learning: "წინა სწავლის აღიარება",
    register_online: "ონლაინ რეგისტრაცია",
    raise_rates: "ზრდის მაჩვენებლები",
    rate: "მაჩვენებელი",
    route_permissions: "მარშრუტის უფლებები",
    report_upload: "ატვირთეთ ანგარიში",
    report_upload_info: "დოკუმენტი JPG ან PDF ფორმატში უნდა იყოს.",

    t_score_multiplier: "ძირითადი მრავლობითი",
    t_score_effect: "ქულის ეფექტი",


    select_image_upload: "აირჩიეთ ასატვირთი სურათი",
    merged_sections: "გაერთიანებული სექციები",
    student_transcript: "ტრანსკრიპტი",
    student_overlap_report: "სტუდენტის საგნების გადაფარვის ანგარიში",
    student_overlap_report_excel: "სტუდენტისგადაფარვისანგარიში",
    student_english_language_proficiency_document: "ენის საკმარისობის დოკუმენტი",
    surveyReportJob: "გამოკითხვის ანგარიშის ოპერაცია",
    scholarship_code: "სტიპენდიის კოდი",
    s_grade_conversion: "S ნიშნის გარდაქმნა",
    saturday: "შაბათი",
    save: "შენახვა",
    save_and_continue: "შენახვა და გაგრძელება",
    save_and_go: "შენახვა და წინ წასვლა",
    save_application: "განაცხადის შენახვა",
    save_preferences: "არჩევანის შენახვა",
    send_preferences: "არჩევანის გაგზავნა",
    saved: "შენახულია",
    scala_id: "სკალის ID",
    scala_name: "სკალის სახელი",
    scholarship_detail: "სტიპენდიის დეტალი",
    scholarship_rate: "სტიპენდია",
    scholarship_status: "სტიპენდიის სტატუსი",
    scholarship_type: "სტიპენდიის ტიპი",
    scholarship_report: "სტიპენდიის ანგარიში",
    scholarships: "სტიპენდიები",
    scholarshiptypes: "სტიპენდიის ტიპი",
    scholarship_analysis_report: "სტიპენდიის ანალიზის ანგარიში",
    osym_scholarship_analysis_report: "ÖSYM-ში ჩარიცხულთა სტიპენდიის ანალიზის ანგარიში",
    scholor_ship_rate_ration: "სტიპენდიის გარეშე",
    scholarship_collection_report: "სტიპენდიის ბრუნვის ანგარიში",
    school: "სკოლა",
    school_name: "სკოლის სახელი",
    school_type: "სკოლის ტიპი",
    school_scope: "სკოლის არეალი",
    school_certificate: "სასწავლო მოწმობა",
    school_council_date: "სკოლის საბჭოს თარიღი",
    school_council_number: "სკოლის საბჭოს ნომერი",
    scientific_preparation: "სამეცნიერო მომზადება",
    scientific_preparation_courses: "სამეცნიერო მომზადების კურსები",
    score: "ქულა",
    score_information: "ქულის ინფორმაცია",
    score_type: "ქულის ტიპი",
    score_with_the_selected_program: "არჩეულ პროგრამასთან დაკავშირებული ქულა",
    search: "ძებნა",
    search_course: "საგნის დამატება",
    seating_types: "დაჯდომის ტიპები",
    section: "სექცია",
    section_1: "სექცია",
    section_number: "სექციის ნომერი",
    section_message: "გთხოვთ აირჩიოთ სექცია",
    section_status: "სექციის სტატუსი",
    section_detail: "სექციის დეტალი",
    section_not_found: "სექცია ვერ მოიძებნა",
    section_count: "სექციების რაოდენობა",
    section_id: "სექციის ID",
    section_information: "სექციის ინფორმაცია",
    section_operations: "სექციის ოპერაციები",
    section_type: "სექციის ტიპი",
    sections: "სექციები",
    section_import_excel: "საგნის კოდი, სექცია, მასწავლებლის ID, კოტა, ტიპი, სექციის ენა",
    section_detail_import_excel: "საგნის კოდი, სექცია, დეტალის ტიპი, დეტალის კოდი, დეტალი, პირიქით",
    select: "აირჩიეთ",
    select_all: "ყველას არჩევა",
    select_btn: "არჩევა",
    select_date: "თარიღის არჩევა",
    select_file: "აირჩიეთ ფაილი",
    select_is_cash_or_installment: "აირჩიეთ ნაღდი თუ განვადება",
    select_it: "აირჩიეთ",
    select_report_type: "აირჩიეთ ანგარიშის ტიპი",
    select_program: "აირჩიეთ პროგრამა",
    selected_field_is_invalid: "არჩეული %{numberof} ველი არასწორია",
    semester: "სემესტრი",
    semester_name: "სემესტრის სახელი",
    semester_name_en: "სემესტრის სახელი (EN)",
    semester_1: "აკადემიური წელი/სემესტრი",
    semester_count: "სემესტრების რაოდენობა",
    semester_registration_information: "სემესტრი/რეგისტრაციის ინფორმაცია",
    semester_settings: "სემესტრის პარამეტრები",
    semester_status: "სემესტრის სტატუსი",
    semester_text: "ნახევარწლეული",
    semester_text_en: "ნახევარწლეული (EN)",
    semester_title: "სემესტრები",
    semester_x: "{semester}. ნახევარწლეული",
    semester_status_analysis: "სემესტრის სტატუსის ანალიზი",
    semesterdate: "სემესტრის თარიღები",
    semesters: "ნახევარწლეული",
    semester_info: "სემესტრის ინფორმაცია",
    semester_status_warning: "თქვენი სემესტრის სტატუსი განსაზღვრულია როგორც <strong>{semester_status}</strong>. თუ ფიქრობთ, რომ შეცდომაა, დაუკავშირდით ფაკულტეტის მდივანს.",
    sent: "გაგზავნილია",
    send: "გაგზავნა",
    selected_course: "არჩეული საგანი",
    send_again: "თავიდან გაგზავნა",
    send_again_btn: "თავიდან გაგზავნა",
    send_again_not: "გთხოვთ სცადოთ თავიდან ღილაკზე 'თავიდან გაგზავნა' დაჭერით.",
    send_approve: "გაგზავნა დასამტკიცებლად",
    send_application: "განაცხადის გაგზავნა",
    send_password: "პაროლის გაგზავნა",
    send_request: "მოთხოვნის გაგზავნა",
    send_sms: "SMS გაგზავნა",
    send_email: "ელ.ფოსტის გაგზავნა",
    send_verification_code: "დამადასტურებელი კოდის გაგზავნა",
    send_yoksis_transcript: "YÖKSİS ტრანსკრიპტის გაგზავნა",
    services: "სერვისები",
    session: "სეზონი",
    set_as_active_step: "გააქტიურებულ ნაბიჯად დაყენება",
    settlement_scholarship: "ჩარიცხვის სტიპენდია",
    short_name: "მოკლე სახელი",
    short_name_en: "მოკლე სახელი (EN)",
    show: "ჩვენება",
    show_or_update: "ჩვენება/განახლება",
    show_application: "განაცხადის ჩვენება",
    show_on_login: "Login-ზე ჩვენება",
    show_empty_classrooms: "ცარიელი საკლასო ოთახების ჩვენება",
    signature: "ხელმოწერა",
    signature_name: "ხელმომწერი",
    signature_type: "ხელმოწერის ტიპი",
    sign_up: "რეგისტრაცია",
    signer: "ხელმომწერი",
    signers: "ხელმომწერები",
    students_active_university_information: "სტუდენტის აქტიური უნივერსიტეტის ინფორმაცია",
    signer_name_surname: "ხელმომწერი",
    signer_national_id: "ხელმომწერის პირადი ნომერი",
    signer_title: "ხელმომწერის წოდება",
    signer_title_en: "ხელმომწერის წოდება (EN)",
    single: "განქორწინებული",
    slot: "სლოტი",
    slot_type: "სლოტის ტიპი",
    slot_type_code: "სლოტის ტიპის კოდი",
    slot_types: "სლოტის ტიპები",
    slot_semester: "სასწავლო სემესტრი",




    slots: "სლოტები",
    something_went_wrong: "შეცდომა მოხდა. გთხოვთ სცადოთ მოგვიანებით.",
    sorry_we_could_not_find_the_page_you_were_looking_for: "ბოდიშით, თქვენ მიერ ნაპოვნი გვერდი ვერ მოიძებნა.",
    sort: "დახარისხება",
    sort_by_graduation_grade_point_average: "დახარისხება სასწავლებლის საშუალო ქულით",
    sort_by_semester_grade_point_average: "დახარისხება სემესტრის საშუალო ქულით",
    sound_systems: "აუდიო სისტემები",
    speaker_lecturer: "მომხსენებელი ლექტორი",
    speaking_exam: "საუბრის გამოცდა",
    spring: "გაზაფხული",
    spring_credit: "გაზაფხულის კრედიტი",
    staff: "პერსონალი",
    staff_information: "პერსონალის ინფორმაცია",
    start: "დაწყება",
    start_date: "დაწყების თარიღი",
    start_process: "პროცესის დაწყება",
    start_time: "დაწყების დრო",
    statement1_error: "გთხოვთ გადაამოწმოთ რეგისტრაციის ეკრანზე შეყვანილი ინფორმაციის სიზუსტე!",
    statement2_error: "გთხოვთ დაამტკიცოთ პერსონალური მონაცემების დამუშავების განმარტების ტექსტი!",
    statement3_error: "გთხოვთ დაამტკიცოთ პერსონალური მონაცემების დამუშავების თანხმობის ტექსტი!",
    statement4_error: "გთხოვთ დაამტკიცოთ ონლაინ გადახდის შეთანხმება!",
    statement5_error: "განვადების ვარიანტის გადახდა საბანკო გადარიცხვით შეუძლებელია",
    statement_1: "ვაცხადებ, რომ რეგისტრაციის ეკრანზე შეყვანილი ინფორმაცია სწორია.",
    statement_2: "პერსონალური მონაცემების დამუშავების <a href=#>განმარტების ტექსტი</a> წავიკითხე და ვადასტურებ.",
    statement_3: "პერსონალური მონაცემების დამუშავების თანხმობის ტექსტი",
    statement_4: "პერსონალური მონაცემების დამუშავების თანხმობის ტექსტი (პილოტაჟი)",
    status: "სტატუსი",
    stay_of_execution_decision: "შესრულების შეჩერების გადაწყვეტილება",
    step_name: "დამტკიცების ეტაპი",
    status_approval_awaited: "მოსალოდნელია დამტკიცება",
    status_approved: "დამტკიცებულია",
    status_required_message: "აუცილებელია შევსდეს არჩეული ველები.",
    status_accepted: "მიღებულია",
    status_declined: "უარყოფილია",
    status_denied: "უარყოფილია",
    status_update: "სტატუსის განახლება",
    status_waiting_payment: "გადასახდის მოლოდინში",
    status_uploaded: "ატვირთულია",
    status_waiting: "მოლოდინშია",
    status_waiting_publish: "გამოქვეყნების მოლოდინში",
    street: "ქუჩა",
    street_and_no: "ქუჩა/№",
    student: "სტუდენტი",
    student_explanation: "სტუდენტის განმარტება",
    student_exam_data: "სტუდ. გამოცდ. მონაცემი",
    student_unihall_info: "{0} სემესტრისთვის რეგისტრირებული უნდა იყოს",
    student_unihall_info2: "BAU-ს მოსამზადებელი კლასის სტუდენტი უნდა იყოს",
    student_unihall_info3: "განვადების გადახდის ვარიანტი მოქმედებს მხოლოდ İş Bankası, Vakıfbank და Denizbank ბარათებზე.",
    student_bea_bau: "BAU-ს სტუდენტი უნდა იყოს",
    student_document_create1: "დოკუმენტების მასობრივი შექმნა",
    student_affairs: "სტუდენტური საქმეები",
    student_approval_sent_date: "სტუდენტის დამტკიცების გაგზავნის თარიღი",
    student_certificate: "სტუდენტის მოწმობა",
    student_collection_report: "სტუდენტთა აღრიცხვის-ბრუნვის ანგარიში",
    student_count: "სტუდენტების რაოდენობა",
    student_courses_title: "საგნების მიმოხილვის ანგარიში",
    student_course: "სტუდენტის საგანი",
    student_document_create: "სტუდენტის დოკუმენტის შექმნა",
    student_email: "სტუდენტის ელფოსტა",
    student_gno_simulation: "სტუდენტის საშუალო ქულის სიმულაცია",
    student_gno_report: "სტუდენტის საშუალო ქულის ანგარიში",
    student_graduation_requirement_report: "სტუდენტის დამთავრების მოთხოვნების ანგარიში",
    student_group: "სტუდენტთა ჯგუფი",
    student_grade_entry_failed: "{number} ნომრის {name} {surname} სტუდენტისთვის ქულის შეყვანა წარუმატებელი",
    student_information: "სტუდენტის ინფორმაცია",
    student_based_full_schedule_report: "სასწავლო განრიგის ცვლილების ანგარიში",
    sending_sms_with_mobile_phone_information: "SMS გაგზავნა მობილური ტელეფონის ინფორმაციით",
    sending_sms_to_staff: "SMS გაგზავნა პერსონალისთვის",
    send_sms_excel: "პირადი №, სტუდენტის №, მობილურის №",
    sending_sms: "SMS გაგზავნა",
    sending_sms_student_search: "სტუდენტის ძიებით SMS გაგზავნა",
    student_information_system: "სტუდენტური საინფორმაციო სისტემა",
    student_list: "სტუდენტთა სია",
    student_list_report: "ჩარიცხული სტუდენტების ანგარიში",
    student_list_with_photo: "სტუდენტთა სია (ფოტო付き)",
    student_mobile_number: "სტუდენტის მობილური ნომერი",
    student_name: "სტუდენტის სახელი",
    student_notes: "სტუდენტის ჩანაწერები",
    student_notes_report: "სტუდენტის ჩანაწერების ანგარიში",
    student_number: "სტუდენტის №",
    student_number_format: "სტუდენტის ნომრის ფორმატი",
    student_number_long: "სტუდენტის ნომერი",
    student_number_filter: "დახარისხება სტუდენტის ნომრით",
    student_name_filter: "დახარისხება სტუდენტის სახელით",
    student_numbers: "სტუდენტთა ნომრები",
    student_program_class_success_title: "სემესტრის წარმატების რეიტინგი",
    student_program_graduation_success_title: "დამთავრების წარმატების რეიტინგი",
    student_report: "სტუდენტის ანგარიში",
    student_reports: "სტუდენტთა ანგარიშები",
    student_section_change: "სტუდენტის სექციის ცვლილება",
    student_sections: "სტუდენტის სექციები",
    student_semester_count: "გავლილი სემესტრების რაოდენობა",
    student_semester_report: "სემესტრის სტატუსის ანგარიში",
    student_slots: "სტუდენტის სლოტები",
    student_status: "სტუდენტობის სტატუსი",
    student_status_btn: "სტუდენტის სტატუსი",
    student_surname: "სტუდენტის გვარი",
    students: "სტუდენტები",
    student_program_id: "სტუდენტის პროგრამის ID",
    studied: "ისწავლა",
    student_educational_status: "სტუდენტის საგანმანათლებლო სტატუსი",
    student_preference_reset_info: "სტუდენტის არჩევანის განულებას აპირებთ. დარწმუნებული ხართ?",
    student_preferences: "სტუდენტის არჩევანი",
    student_club_applications: "სტუდენტური კლუბის განაცხადები",
    subject: "თემა",
    subject_en: "თემა (ინგლისურად)",
    subtitle: "ქვათემა",
    sub_course_code: "ქვეკურსის კოდი",
    sub_course_section: "ქვეკურსის სექცია",
    success: "წარმატება",
    success_data_count: "წარმატებულთა რაოდენობა",
    success_rate: "წარმატების მაჩვენებლები",
    success_rate1: "წარმატების მაჩვენებელი",
    success_status: "წარმატების სტატუსი",
    success_status_report: "წარმატების სტატუსის ანგარიში",
    successfully_added: "წარმატებით დაემატა.",
    successfully_changed: "წარმატებით შეიცვალა.",
    successfully_deleted: "წარმატებით წაიშალა.",
    successfully_saved: "წარმატებით შეინახა.",
    successfully_updated: "წარმატებით განახლდა.",
    sum_of_credits: "კრედიტების ჯამი",
    sum_of_ects_credits: "AKTS კრედიტების ჯამი",
    summary: "რეზიუმე",
    summary_of_project: "პროექტის რეზიუმე",
    summary_of_thesis: "თეზისის რეზიუმე",
    summary_statement_content: "ვაცხადებ, რომ ფორმაში მოცემული ინფორმაცია სწორია.",
    summer: "ზაფხული",
    summer_school_report: "ზაფხულის სკოლის ანგარიში",
    sunday: "კვირა",
    surgery_illness_history: "თუ ყოფილა გაკეთებული ოპერაცია ან აქვს მუდმივი ავადობა",
    surgery_or_discomfort: "თუ გაკეთებული გაქვთ ოპერაცია ან გაქვთ ქრონიკული დაავადება",
    surname: "გვარი",
    surname_placeholder: "შეიყვანეთ თქვენი გვარი",
    survey: "გამოკითხვა",
    survey_questions: "გამოკითხვის კითხვები",
    survey_result: "გამოკითხვის შედეგი",
    survey_result_download: "გამოკითხვის შედეგის ჩამოტვირთვა",
    survey_result_show: "გამოკითხვის შედეგის ნახვა",
    surveys: "გამოკითხვები",
    switch_user: "მომხმარებლის შეცვლა",
    synchronous: "სინქრონული",
    system_name: "სისტემის სახელი",
    speacial_student_error: "სპეციალური სტუდენტები ვერ აირჩევენ საგნებს",
    scholarship_coop: "Coop სტიპენდია",
    scholarship_public: "საჯარო სტიპენდია",
    student_registration_form: "სტუდენტის რეგისტრაციის ფორმა",
    student_card: "სტუდენტის ბარათი",
    section_definition: "სექციის განსაზღვრა",
    student_detail_absence_report: "სტუდენტის დეტალური გაუცდენის ანგარიში",
    section_update_success: "{name} {surname} სტუდენტის სექცია განახლდა {section}-ად.",
    section_update_unsuccess: "{name} {surname} სტუდენტის სექცია ვერ განახლდა {section}! {add_info} <br> <br> საგნის კოდი: {course_code} <br> სექცია: {section} <br> დღე: {day_name}<br> დაწყების დრო: {start_time}<br> დასრულების დრო: {end_time}",
    schedule_overlap_message: "თქვენი არჩეული საგანი ემთხვევა საგანს #course",
    section_update_unsuccess2: "{name} {surname} სტუდენტის სექცია ვერ განახლდა {section}! <br> სექცია:{section}",
    success_send_message: "შეტყობინება წარმატებით გაიგზავნა.",
    section_update_overlap: "სტუდენტის საგნების გადაფარვის გამო განახლება ვერ მოხერხდა.",
    student_programs_graduation_requirement: "მასობრივი დამთავრების მოთხოვნების მართვა",
    sender: "გამგზავნი",
    semester_add: "სემესტრის დამატება",
    student_right: "სტუდენტობის უფლება",
    student_statutility: "სტუდენტობის სტატუსი",
    student_right_having: "აქვს თუ არა სტუდენტობის უფლება",
    student_right_having_end_date: "სტუდენტობის უფლების დასრულების თარიღი",
    student_diploma_name: "დიპლომის სახელი",
    student_diploma_surname: "დიპლომის გვარი",
    system_maintance: "თუ ხედავთ ამ გვერდს, გთხოვთ მიჰყვეთ ქვემოთ მოცემულ DNS განახლების ინსტრუქციებს.",
    system_maintance_2: "გმადლობთ გაგებისთვის.",
    student_absence_report: "სტუდენტის გაუცდენის ანგარიში",
    students_should_take_course: "საგნის ამღებთ სტუდენტთა სია",
    students_should_take_courses: "საგნის ამღებთ სტუდენტთა სია (ყველა)",
    students_should_take_elective: "არჩევით საგნის ამღებთ სტუდენტთა სია",
    survey_results: "გამოკითხვის შედეგები",
    survey_results_loading: "გამოკითხვის შედეგების დათვლა მიმდინარეობს",
    survey_instructor_results: "ლექტორის გამოკითხვის შედეგები",
    select_theoretical_section: "აირჩიეთ თეორიული სექცია",
    select_practical_section: "აირჩიეთ პრაქტიკული სექცია",
    survey_question_about_course: "საგანთან დაკავშირებული კითხვები",
    survey_staff_avg: "ლექტორთა საშუალო",
    survey_faculty_avg: "ფაკულტეტის საშუალო",
    survey_university_avg: "უნივერსიტეტის საშუალო",
    survey_comment_question_select: "აირჩიეთ კომენტარის კითხვა.",
    sms_sending_title: "SMS გაგზავნა",
    sms_sending_with_number_info: "SMS გაგზავნა მობილურის ნომრით",
    sms_sending_with_student_search: "SMS გაგზავნა სტუდენტის ძიებით",
    sms_to_will_send: "გაგზავნის ადრესატი",
    student_selected: "{numberOf} სტუდენტი არჩეულია",
    student_status_changes: "სტუდენტის სტატუსის ცვლილებები",
    show_programs: "პროგრამების ჩვენება",
    scholarship_status_form: "სტიპენდიის სტატუსის დოკუმენტი",
    student_affairs_grade_import: "მასობრივი ქულის შეტანა",
    sample_template_excel: "EXCEL - ნიმუშის შაბლონი",
    student_affairs_academic_year: "აკადემიური წელი (YYYY-YYYY)",
    student_affairs_period: "სემესტრი (1,2,3,4)",
    student_affairs_exam_type: "გამოცდის ტიპი (F ან M)",
    session_timeout_warning: "თქვენი სესია მალე დასრულდება",
    session_timeout_warning_text: "თქვენი სესიის დრო იწურება. გსურთ გაგრძელება?",
    session_timeout_continue: "გაგრძელება",
    session_timeout_logout: "დასრულება",
    session_timer_title: "დარჩენილი სესიის დრო",
    second_language: "მეორე ენა",
    second_prep_module_success_point: "მეორე ენის მოდულის ქულა",
    second_prep_proficiency_success_point: "მეორე ენის საკმარისობის გამოცდის ქულა",
    special_talent_exam: "განსაკუთრებული ნიჭის გამოცდა",
    student_course_delete: "სტუდენტის საგნის წაშლა",
    student_numbers_by_nationality_and_faculty: "სტუდენტების რაოდენობა ეროვნებისა და ფაკულტეტის მიხედვით",
    section_for_repeats: "წარუმატებელი თეზისის სექციის გახსნა",
    search_by_yoksis: "YÖKSİS-დან მოძიება",
    search_by_osym: "ÖSYM-დან მოძიება",
    search_kps_by_staff_national_id: "პერსონალის პირადი ნომრით KPS-ის მოთხოვნა",
    staff_tc: "პერსონალის პირადი ნომერი",
    scholarships_import: "სტიპენდიის მასობრივი განსაზღვრა",
    student_semester_status_update: "სემესტრის მასობრივი განახლება",
    special_scholarship_rate: "სპეციალური სტიპენდიის პროცენტი",
    special_scholarship_code: "სპეციალური სტიპენდიის კოდი",
    show_in_information_package: "ინფორმაციულ პაკეტში ჩვენება",
    show_in_coordinators_page: "კოორდინატორის გვერდზე ჩვენება",
    student_clubs: "სტუდენტური კლუბები",
    student_club_member_search: "კლუბის წევრთა ძიება",
    season: "სეზონი",
    student_club_selection_search: "სტუდენტური კლუბების შერჩევის ძიება",
    sms_list: "SMS სია",
    sms_message: "SMS შეტყობინება",
    speaker: "მომხსენებელი",
    sponsor: "სპონსორი",
    story:"ისტორია",
    student_ticket: "სტუდენტის ბილეთი",
    search_kps_by_student_numbers: "სტუდენტის ნომრებით KPS-ში მოძიება",
    slug: "სლაგი",
    still_working: "მუშაობს",
    school_found_job_opportunity: "სამუშაო შესაძლებლობა სკოლამ იპოვა",
    sporty: "სპორტული",
    social_cultural: "სოციალურ-კულტურული",
    stundent_club_events: "სტუდენტური კლუბების ღონისძიებები",



    timeout: "დროის ამოწურვა",
    two_factor_authentication: "ორი ფაქტორი",
    take_the_lesson: "საგნის დაჯავშნა",
    take_the_survey:"გაიარეთ გამოკითხვა",
    date_took_the_course: "საგნის აღების თარიღი",
    taking_during_active_semester: "აქტიურ სემესტრში სწავლობს",
    that_course_had_been_taken: "ეს საგანი ადრე სხვა სლოტის სანაცვლოდ აღებულია",
    turkmer_page_title: "TÜRKMER პროგრამების განაცხადის ფორმა",
    turkmer_page_show_title: "Türkmer პროგრამების განაცხადის ნახვა",
    turkmer_admin_page_title: "TÜRKMER პროგრამების განაცხადების სია",
    tc_no: "საიდენტიფიკაციო ნომერი (TC)",
    tc_or_passport: "TC პირადობა/პასპორტის №",
    teaching_staff: "სასწავლო პერსონალი",
    teaching_staff_no: "სასწავლო პერსონალის კოდი",
    temporary_graduation: "დროებითი დიპლომი",
    telephone: "ტელეფონი",
    terminal: "ტერმინალი",
    technological_materials: "ტექნოლოგიური მასალები",
    the_class_finished_in_the_program_came: "თეზისის სათაური",
    the_person_who_person: "დამატებელი პირი",
    the_values_you_entered_have_already_been_added: "თქვენს მიერ შეყვანილი მონაცემები უკვე დამატებულია.",
    theoretical: "თეორიული",
    theoretical_credit: "თეორიული კრედიტი",
    theoric: "თეორიული",
    theoric_section: "თეორიული სექცია",
    there_are_no_records: "ჩანაწერები არ მოიძებნა.",
    there_is: "არსებობს",
    there_is_a_protocol: "არსებობს პროტოკოლი",
    there_is_any_course_in_active_semester: "აქტიურ სემესტრში საგანი ვერ მოიძებნა",
    there_is_no_authorization: "უფლება არ არსებობს.",
    thesis_advisor: "თეზისის ხელმძღვანელი",
    thesis_advisory: "თეზისის ხელმძღვანელობა",
    thesis_co_advisor: "თეზისის თანახელმძღვანელი",
    thesis_and_project: "თეზისი",
    transfer_count:"ადაპტირებული კურსების საერთო რაოდენობა",
    thesis_and_topic_determination: "თეზისის თემის განსაზღვრა",
    thesis_and_project_advisor_approve_title: "ხელმძღვანელის განაცხადის ნახვა",
    thesis_and_project_application: "თეზისის განაცხადი",
    thesis_and_project_coordinator_approve_title: "კოორდინატორის განაცხადის ნახვა",
    thesis_and_project_info: "თეზისის/პროექტის ინფორმაცია",
    thesis_and_projects_admin_title: "თეზისის ადმინისტრაციული განაცხადების ნახვა",
    thesis_and_projects_admin_update: "თეზისის/პროექტის ადმინისტრაციული განაცხადის განახლება",
    thesis_project_advisor_report: "თეზისის/პროექტის ხელმძღვანელი პერსონალის ანგარიში",
    thesis_students: "თეზისის/პროექტის სტუდენტები",
    thesis_title: "თეზისის სათაური",
    thesis_and_project_status: "სადისერტაციო ნაშრომი",
    threshold_value: "გამოცდის მინიმალური ზღვარი",
    this_field_is_required: "ეს ველი სავალდებულოა.",
    thursday: "ხუთშაბათი",
    basic_field_type: "ძირითადი სფეროს ტიპი",
    show_in_diploma_supplement: "დიპლომის დანართში ჩვენება",
    tr_name: "TR სახელი",
    translate: "თარგმნა",
    en_name: "EN სახელი",
    title1: "პদব",
    title2: "პদব",
    title: "სათაური",
    title_en: "სათაური (ინგლისურად)",
    titles: "სათაურები",
    title_of_project: "პროექტის სათაური",
    title_of_thesis: "თეზისის სათაური",
    title_title: "სათაური",
    ticket: "ბილეთი",
    ticket_message: "Future AI Summit'25 გაიმართება 16-17 აპრილს BAU ბეშიქთაშის სამხრეთ კამპუსში! „Metamorph“ თემით გამართული ეს უნიკალური ღონისძიება საშუალებას მოგცემთ შეხვდეთ გლობალურ ლიდერებს ხელოვნური ინტელექტის სფეროში და მიიღოთ შთამაგონებელი სესიები და ინტერაქტიული გამოცდილებები. შეგიძლიათ ახლავე დარეგისტრირდეთ.",
    ticket_message1: "თქვენი სერტიფიკატი ჯერ არ არის დაჯავშნილი, შეგიძლიათ შეცვალოთ არჩევანი.",
    ticket_message2: "განვადებით გადახდისას ბანკის მიხედვით განსხვავებული საკომისიო შეიძლება დაემატოს.",
    ticket_message3: "ამ საიტზე ოპერაციის შესრულებით, თქვენ ეთანხმებით გამოყენების პირობებს.",
    ticket_success_message: "გმადლობთ შეძენისთვის! თქვენი ბილეთი წარმატებით შეიქმნა და მოუთმენლად გელოდებით Future AI Summit'25-ზე. ბილეთების ჩამოტვირთვა ქვემოთ შეგიძლიათ.",
    to_score: "საბოლოო ქულა",
    to_email: "გადაცემული ელფოსტა",
    toefl_password: "TOEFL პაროლი",
    toefl_username: "TOEFL მომხმარებლის სახელი",
    total_advisory: "სულ ხელმძღვანელობა",
    total_amount: "სულ თანხა",
    total_course_count: "საგნების საერთო რაოდენობა",
    total_credits: "ადაპტირებული კურსის კრედიტების ჯამი",
    total: "სულ",
    today:"დღეს",
    total_credits_attempted: "სულ აღებული კრედიტები",
    total_credits_earned: "სულ დასრულებული კრედიტები",
    total_number_of_working_days: "სულ სამუშაო დღეების რაოდენობა",
    total_debt: "სულ ვალი",
    total_discount: "სულ ფასდაკლება",
    total_discount_amount: "სულ სტიპენდიის თანხა",
    total_discount_rate: "სულ სტიპენდიის პროცენტი",
    total_ects_credits: "სულ AKTS კრედიტები",
    ects_credits: "AKTS კრედიტი",
    total_ects_credits_attempted: "სულ აღებული AKTS კრედიტები",
    total_ects_credits_earned: "სულ დასრულებული AKTS კრედიტები",
    total_installment: "სულ განვადება",
    total_paid: "სულ გადახდილი",
    total_points: "სულ ქულები",
    total_refund: "სულ დაბრუნება",
    topic: "თემა",
    total_ects_range_completed: "სულ დასრულებული AKTS-ის დიაპაზონი",
    total_credit_range_completed: "სულ დასრულებული კრედიტების დიაპაზონი",
    total_slots: "სულ სლოტები",
    total_capacity: "სულ ტევადობა",
    total_student_count: "სულ სტუდენტების რაოდენობა",
    total_payment: "სულ გადახდა",
    to_date: "დასრულების თარიღი",
    transaction_date: "ტრანზაქციის თარიღი",
    transaction_end_date: "ტრანზაქციის დასრულების თარიღი",
    transaction_reference: "რეფერენს ნომერი",
    transaction_start_date: "ტრანზაქციის დაწყების თარიღი",
    transcript: "ტრანსკრიპტი",
    transcript_publication_date: "ტრანსკრიპტის გამოქვეყნების თარიღი",
    transitions: "გადასვლები",
    transfer: "გადატანა",
    transfer_applications: "განაცხადების გადატანა",
    transport_audio_video_systems: "ტრანსპორტის აუდიო/ვიდეო სისტემები",
    true: "მართალი",
    tuesday: "სამშაბათი",
    tuition: "სასწავლო გადასახადი",
    turkey: "თურქეთი",
    turkish: "თურქული",
    turn_back: "დაბრუნება",
    type: "ტიპი",
    type_detail: "ტიპის დეტალი",
    type_of_delivery: "მიწოდების ტიპი",
    type_of_program_score: "პროგრამის ქულის ტიპი",
    type_of_program: "პროგრამის ტიპი",
    there_are_missing_responses: "არსებობს უპასუხო კითხვები",
    this_university_course: "უნივერსიტეტის საგანი",
    to: "ვის",
    top_menu:"ზედა მენიუ",
    two_copies: "მეორე ასლი",
    two_copies_wet_signature: "მეორე ასლი ხელმოწერით",
    two_copies_wet_signature_PDF: "მეორე-ასლი-ხელმოწერით",
    two_copiesPdf: "მეორე-ასლი",
    teaching_staff_faculty: "სასწავლო პერსონალის ფაკულტეტი",
    teaching_staff_department: "სასწავლო პერსონალის დეპარტამენტი",
    teaching_staff_program: "სასწავლო პერსონალის პროგრამა",
    taken_at: "აღების თარიღი",
    transfer_next_period: "გადამეტებული თანხის შემდეგ სემესტრში გადატანა",
    transfer_next_installments: "გადამეტებული თანხის შემდეგ განვადებებზე გადატანა",
    take_on_application: "განაცხადის საკუთარ თავზე აღება",
    tax_explanation: "ზემოაღნიშნულ სწავლის გადასახადებში KDV შედის. შესაძლოა ხელისუფლებამ შეცვალოს საგადასახადო განაკვეთი სწავლის პროცესის განმავლობაში. შესაბამისად, გადასახადის განაკვეთის ცვლილება აისახება სწავლის გადასახადზე. ამჟამად, KDV განაკვეთი 10%-ია.",
    tax_number: "საგადასახადო ნომერი",
    tyt_year: "TYT სეზონი",
    tyt_score: "TYT ქულა",
    tyt_info: "თქვენი TYT ქულა ავტომატურად გამოჩნდება გამოცდის შედეგების გამოცხადების შემდეგ.",
    turkish_music: "თურქული მუსიკის ინსტრუმენტული შესრულება",
    turkish_music_voice_education: "თურქული მუსიკის ვოკალური განათლება",
    tyc_right: "TYC უფლება",
    time_scholarship: "ხანგრძლივობა (0: უვადო)",
    total_vote: "სულ ხმა",
    tyyc_level_outcomes: "TYYC დონის აღწერები",
    tyyc_basic_field_type: "ძირითადი სფეროს ტიპი",
    tyyc_outcome: "დონის აღწერა",
    tyyc_basic_field: "ძირითადი სფერო",
    tyyc_basic_field_outcomes: "ძირითადი სფეროს კომპეტენცია",
    turkmer: "Türkmer",
    turkish_national_id_number: "TC პირადობის №",
    ticket_tracker: "ბილეთების გაყიდვის მონიტორინგის ეკრანი",
    ticket_type: "ბილეთის ტიპი",
    ticket_information: "ბილეთის ინფორმაცია",
    ticket_event_type: "ბილეთის ღონისძიების ტიპი",
    ticket_event: "ბილეთის ღონისძიება",
    ticket_count: "ბილეთების რაოდენობა",
    ticket_event_promotion_codes: "ღონისძიების ბილეთების პრომო კოდები",
    ticket_amount: "ბილეთის თანხა",
    ticket_no_enter: "ბილეთის ნომრის შეყვანა",
    type_of_acceptance:"მიღების ტიპი",
    type_of_agreement: "შეთანხმების ტიპი",
    ticket_no: "ბილეთის №",
    ticket_check: "შემოწმება",
    tyc_dates: "TYC თარიღები",
    transfer_graduate_application_scholarships:"სადოქტორო პროგრამებზე განაცხადების გადაცემა",
    timeout_amount: "დროის ამოწურვა",
    treatment:"მკურნალობა",
    ticket_count_individual_message: "შეიძლება შეძენილ იქნას 1-დან 4-მდე ბილეთი.",
    ticket_count_group_message: "შეიძლება შეძენილ იქნას 5-დან 10-მდე ღონისძიების სერტიფიკატი.",
    turkish_folk_music: "თურქული ფოლკლორული მუსიკა",


    // U
    unread: "წაუკითხავი",
    read: "წაკითხული",
    unihall_country_code: {
        TR: "თურქეთი",
        YU: "საზღვარგარეთ",
    },
    user: "მომხმარებელი",
    unihall_approvet_payment: "თქვენი გადახდა დამტკიცდა",
    unihall_applications_title: "ყაზარმის ოთახების განაცხადები",
    unihall_payment_note: "შენიშვნა: გადარიცხვისას „შენიშვნა“ ველში უნდა ჩაიწეროს სტუდენტის სახელი, გვარი / ოთახის ტიპი / პირადი ნომერი",
    unihall_payment_note1: "ძვირფასო სტუდენტებო, საშემოდგომო-გაზაფხულის საცხოვრებლის გადასახადები იხდება 9 თვის განმავლობაში (ოქტომბერი–ივნისი). არასრული გადახდები ჩაითვლება ბათილად და თანხა დაგიბრუნდებათ. თუ თქვენი გადარიცხვა 1 საათში (60 წუთი) არ აისახება სისტემაში, განაცხადი გაუქმდება.",
    unihall_remaining_quota: "დარჩენილი კვოტა",
    unihall_quota: "ყაზარმის ოთახები",
    unihall_quota_select: "ოთახის არჩევა",
    unihall_quota_type: "ოთახის ტიპი",
    unihall_quota_payment_type_select: "გადახდის ტიპი",
    unihall_cash_price: "ნაღდი ფასი",
    unihall_installment_price: "განვადების ფასი",
    unihall_quotas_title: "ოთახების მოცულობა",
    unihall_quotas_price_title: "ოთახების ფასები",
    unihall_make_order_info_text: "თქვენი განაცხადი გაგზავნილია დამტკიცებაზე. თუ თანხას გადაიხდით 1 საათში, თქვენი განაცხადი და გადახდა დამტკიცდება, წინააღმდეგ შემთხვევაში გაუქმდება.",
    unihall_approved_message: "თქვენი გადახდა და რეგისტრაცია წარმატებით დასრულდა. შემდეგი დოკუმენტებით 2025 წლის 3 ოქტომბრიდან შეძლებთ შესვლას:<br><br>1) თურქეთის მოქალაქეებისთვის პირადობის ასლი (უცხო ქვეყნის სტუდენტებისთვის პასპორტის ასლი),<br>2) უნივერსიტეტში ჩარიცხვის დამადასტურებელი დოკუმენტი (უცხო ქვეყნის სტუდენტებისთვის სწავლის ნებართვა),<br>3) 4 ცალი სურათი,<br>4) სამედიცინო ცნობა (ჯანმრთელობის ცენტრი, სახელმწიფო ან კერძო კლინიკა),<br>5) სისხლის სამართლის ჩანაწერის ცნობა,<br>6) უცხო ქვეყნის სტუდენტებისთვის – საცხოვრებლის ნებართვის დოკუმენტი პოლიციიდან.",
    unihall_quota_full: "ოთახების ადგილები შევსებულია. მადლობა ინტერესისთვის. სარეზერვო სიაში ჩასაწერად გამოგვიგზავნეთ ელფოსტა <a href='mailto:info@unihall.org'>info@unihall.org</a> მისამართზე სტუდენტის სახელი, გვარი, სასწავლებლის ნომერი, საკონტაქტო ინფორმაცია და საცხოვრებელი მისამართი.",
    unihall_room_info_update: "ოთახის ინფორმაციის განახლება",
    unauthorized_operation: "უფლებების გარეშე ოპერაცია",
    undergraduate_transfer: "ჰორიზონტალური გადასვლა",
    undergraduate_transfer_applications: "ჰორიზონტალური გადასვლის განაცხადები",
    undergraduate_transfer_quotas: "ჰორიზონტალური გადასვლის კვოტები",
    undergraduate_vertical: "ჰორიზონტალური/ვერტიკალური გადასვლა",
    undergraduate_vertical_transfer: "ჰორიზონტალური/ვერტიკალური გადასვლა",
    undergraduate_check_date_message: "განაცხადები ჯერ არ არის აქტიური, ამიტომ ვერ გააკეთებთ განაცხადს.",
    undergraduate_transfer_yok_report: "ჰორიზონტალური გადასვლის YÖK ანგარიში",
    unit: "ერთეული",
    unit_id: "ერთეულის ID",
    units: "ერთეულები",
    universities: "უნივერსიტეტები",
    university: "უნივერსიტეტი",
    university_not_list: "ჩემი უნივერსიტეტი სიაში არ არის",
    university_courses: "უნივერსიტეტის კურსები",
    university_grade_scale_matching: "უნივერსიტეტის შეფასების სკალის დამთხვევა",
    university_grades: "უნივერსიტეტის ნიშნები",
    university_informations: "უნივერსიტეტის ინფორმაცია",
    university_rank: "უნივერსიტეტის რეიტინგი",
    university_status: "შიდა/საზღვარგარეთ",
    university_type: "უნივერსიტეტის ტიპი",
    university_add: "უნივერსიტეტის დამატება",
    university_name: "უნივერსიტეტის სახელი",
    university_where_the_course_was_taken: "კურსის აღების უნივერსიტეტი",
    unpublished: "გამოუქვეყნებელი",
    unsuccessful: "წარუმატებელი",
    update: "განახლება",
    update_release_status: "გამოქვეყნების სტატუსის განახლება",
    update_classes_title: "კლასის წინსვლის ოპერაცია",
    update_document: "დოკუმენტის განახლება",
    update_draft: "მონახაზის განახლება",
    update_info_btn: "საკონტაქტო ინფორმაციის განახლება",
    update_register: "სტუდენტის რეგისტრაციის განახლება",
    updated: "განახლდა",
    updated_at: "განახლების დრო",
    upload: "ატვირთვა",
    upload_file: "ფაილის ატვირთვა",
    upload_your_documents: "ატვირთეთ თქვენი დოკუმენტები",
    uploaded_files: "ატვირთული ფაილები",
    url: "URL",
    used_drugs: "თუ გაქვთ, მუდმივად გამოყენებული მედიკამენტები",
    user_quide: "გამოყენების სახელმძღვანელო",
    user_quide_check: "გთხოვთ დაადასტუროთ, რომ წაიკითხეთ და გაიგეთ.",
    user_type: "მომხმარებლის ტიპი",
    username: "მომხმარებლის სახელი",
    user_filter: "მომხმარებლის ფილტრი",
    user_transfer: "მომხმარებლის გადატანა",
    unselect_all: "ყველას მოხსნა",
    user_model_filters: "მომხმარებლის მოდელის ფილტრები",
    user_model: "მოდელი",
    user_filter_type: "ფილტრის ტიპი",
    user_filter_value: "ფილტრის მნიშვნელობა",
    update_contact_info: "საკონტაქტო ინფორმაციის განახლება",
    update_mobile_tel: "მობილურის განახლება",
    update_email: "ელფოსტის განახლება",
    update_acceptance_letters: "მიღების წერილის განახლება",
    updating_credits_and_ects:"კრედიტებისა და ECTS-ის განახლება",
    university_id: "უნივერსიტეტის ID",
    unit_name: "ერთეულის სახელი",
    unit_long_name: "გრძელი სახელი",
    unit_type: "ერთეულის ტიპი",
    unit_teach_lang: "სასწავლო ენა",
    unit_teach_type: "სასწავლო ტიპი",
    update_units: "ერთეულების განახლება",
    username_info_update: "მომხმარებლის ინფორმაციის შეცვლა",
    username_update_manuel_switch: "მომხმარებლის სახელი ხელით",
    university_graduate_inquiry: "უნივერსიტეტის კურსდამთავრებულის ძიება",
    undergraduate_start_date: "საბაკალავრო სწავლების დაწყების თარიღი",
    undergraduate_leave_date: "საბაკალავრო სწავლების დასრულების თარიღი",
    upload_bank_receipt: "ბანკის ქვითრის ატვირთვა",
    update_summer_school_paid_status: "ზაფხულის სკოლის გადახდის სტატუსის განახლება",
    update_student_course_name: "სტუდენტის კურსის სახელის განახლება",
    update_student_bulk_course_name: "სტუდენტის კურსების ერთიანად განახლება",
    unihall_success_pay: "თქვენი გადახდა წარმატებით შესრულდა.",
    unihall_unsuccess_pay: "თქვენი გადახდა ვერ შესრულდა.",
    university_id_and_name: "უნივერსიტეტის ID - უნივერსიტეტის სახელი",

// V
    validity_dates: "ვარგისიანობის ვადები",
    valid_cart:"გთხოვთ, შეიყვანოთ მოქმედი ბარათის ნომერი.",
    variable_language:"GE",
    validity_season_end: "ვარგისიანობის პერიოდის დასასრული",
    validity_season_start: "ვარგისიანობის პერიოდის დასაწყისი",
    validity_date_start: "ვარგისიანობის დაწყების თარიღი",
    validity_date_end: "ვარგისიანობის დასრულების თარიღი",
    value: "მნიშვნელობა",
    verbal_score: "ვერბალური ქულა",
    verification: "დადასტურება",
    voluntary: "ნებაყოფლობითი",
    verification_code: "დადასტურების კოდი",
    verification_method: "დადასტურების მეთოდი",
    verification_method_not_found: "დადასტურების მეთოდი ვერ მოიძებნა.",
    verification_personal_info: "დადასტურება პირადი მონაცემებით",
    verification_sms_code: "დადასტურება SMS-ით",
    verification_email: "დადასტურება ელფოსტით",
    verified: "დადასტურებულია",
    verify: "დადასტურება",
    verify_code_again_not: "დადასტურების კოდი ხელახლა გაიგზავნა.",
    verify_code_error: "დადასტურების კოდი არასწორია",
    vertical_transfer: "ვერტიკალური გადასვლა",
    vertical_transition_and_vertical_transition_supplementary: "ვერტიკალური გადასვლა და დამატებითი",
    view: "ნახვა",
    view_and_edit: "ნახვა/რედაქტირება",
    village: "სოფელი",
    virman: "გადარიცხვა",
    vinov_installments: "Vinov განვადებები",
    virtual_pos: "ვირტუალური POS",
    vice_president: "პრეზიდენტის მოადგილე",
    video: "ვიდეოები",
    exam_request_message: "საგამოცდო მოთხოვნების შეგროვება არ არის აქტიური.",
    view_score_again: "არა, ქულების ნახვა",
    veteran_martyr_relatives: "ვეტერანი/შჰედის ნათესავი",
    vision_and_mission: "ვიზია და მისია",
    vote_count: "ხმის რაოდენობა",
    vote_count_with_members: "ხმის მიმცემ წევრთა რაოდენობა",
    vocational: "პროფესიული",
    visibility: "ხილვადობა",

// W
    waiting: "მოლოდინში",
    waiting_approve: "მოსალოდნელია დამტკიცება",
    waiting_documents: "მოსალოდნელია დოკუმენტები",
    waiting_program: "განაცხადი მოლოდინშია",
    waiting_payment: "მოსალოდნელია გადახდა",
    waiting_preference: "მოსალოდნელია არჩევანი",
    waiting_prep_school: "მოსალოდნელია მოსამზადებელი სკოლა",
    waiting_academic_unit_office: "მოსალოდნელია აკადემიური ერთეული",
    waiters_approved: "დამტკიცებულები",
    waiters_for_approve: "მოსალოდნელია დამტკიცება",
    waiters_rejected: "უარყოფილები",
    want_leave_of_absence: "გსურთ რეგისტრაციის შეჩერების მოთხოვნა?",
    want_leave_of_absence_missing: "გთხოვთ მიუთითოთ რეგისტრაციის შეჩერების მოთხოვნა",
    want_optional_prep: "გსურთ არჩევითი მოსამზადებელი კურსი?",
    want_optional_prep_missing: "გთხოვთ მიუთითოთ არჩევითი მოსამზადებელი კურსის მოთხოვნა",
    warning: "გაფრთხილება",
    wednesday: "ოთხშაბათი",
    week: "კვირა",
    weekend_in: "გამოსასვლელი დღეები",
    week1:"1 კვირა ",
    weekend_out: "სამუშაო დღეები",
    welcome: "მოგესალმებით",
    welcome_letter: "მისალმების წერილი",
    welcome_to: "კეთილი იყოს თქვენი მობრძანება",
    weight: "წონა",
    whole_price: "სრული ფასი",
    wire: "გადარიცხვა",
    wire_info: "გადარიცხვის ინფორმაცია შემდეგია",
    with_installment: "განვადებით",
    with_mobile_number: "მობილური ნომრით",
    with_personal_information: "პირადი მონაცემებით",
    with_thesis: "დიპლომური ნაშრომით",
    with_without_thesis: "დიპლომური/უპროცედენტო",
    withdraw_requests: "გაუქმების მოთხოვნები",
    without_thesis: "დიპლომურის გარეშე",
    witness_complainant_statement: "მოწმობის განცხადება",
    working_end_date: "სამუშაოს დასრულების თარიღი",
    working_start_date: "სამუშაოს დაწყების თარიღი",
    working_status: "დასაქმების სტატუსი",
    write_verify_code: "შეიყვანეთ SMS-ით მიღებული დადასტურების კოდი",
    write_verify_code_mail: "შეიყვანეთ ელფოსტით მიღებული დადასტურების კოდი",
    written_and_oral_defense_report: "წერილობითი და ზეპირი დაცვის ანგარიში",
    written_exam: "წერითი გამოცდა",
    write_reason_for_rejection: "გთხოვთ მიუთითოთ უარის მიზეზი",
    work_status: "სამუშაო სტატუსი",
    working: "მუშაობს",
    work_history: "სამუშაო ისტორია",
    work_start_date: "სამუშაოს დაწყების თარიღი",
    work_leave_date: "სამუშაოს დატოვების თარიღი",
    working_type: "სამუშაოს ტიპი",
    working_tract: "სფერო",
    web_address: "ვებ-მისამართი",
    weekly_course_plan: "კვირეული კურსის გეგმა",
    want_to_purchase: "მინდა ბილეთის შეძენა",
    weeks: "კვირები",



// Q
    qr_code_verify_stream: "ბილეთის QR კოდის შემოწმება",
    qr_code_read: "QR კოდის წაკითხვა",

// X
    x_field_is_required: " ველი სავალდებულოა!",

// Y
    you_will_directed: "მალე გადამისამართდებით",
    year: "წელი",
    year_code: "წლის კოდი",
    year_count: "წლების რაოდენობა",
    year_of_birth: "დაბადების წელი",
    yearly: "წლიური",
    yes: "კი",
    yl_payment_plan: "YL გადახდის გეგმა",
    yoksis: "Yöksis",
    yoksis_code: "Yöksis კოდი",
    yoksis_import_title: "Yöksis რეგისტრაციის ჩამოტანა",
    your_session_has_expired:"თქვენი სესია ამოიწურა." ,
    yoksis_information_cancel: "Yöksis ინფორმაციის წაშლა",
    yoksis_information_import: "Yöksis ინფორმაციის ატვირთვა",
    yoksis_information_update: "Yöksis ინფორმაციის განახლება",
    yoksis_number_of_semesters: "Yöksis სწავლილი სემესტრების რაოდენობა",
    yoksis_unit_id: "Yöksis ერთეულის ID",
    yoksis_units: "Yöksis ერთეულები",
    yoksis_preparatory: "Yöksis მოსამზადებელი",
    yok_registration_status_report: "YÖK რეგისტრაციის სტატუსის ანგარიში",
    you_can_combine_up_to_five_lessons: "ხუთზე მეტ საგანს ვერ გააერთიანებთ",
    you_are_not_authorized_for_this_operation: "ამ ოპერაციისთვის არ გაქვთ უფლებები.",
    you_can_try_again_after_1_minute: "1 წუთის შემდეგ კვლავ სცადეთ.",
    you_dont_have_a_payment_plan: "გადახდის გეგმა არ გაქვთ.",
    you_have_to_upload_the_files_first: "ჯერ უნდა ატვირთოთ ფაილები!",
    you_have_tried_too_many: "ძალიან ბევრი მცდელობა გააკეთეთ.",
    you_must_fill_in_the_fields_indicated_in_red: "გთხოვთ შეავსოთ წითლად მონიშნული ველები.",
    you_must_do_change: "ცვლილება არ გაგიკეთებიათ",
    your_chosen_courses: "არჩეული საგნები",
    your_payment_transaction_has_been_successfully_completed: "თქვენი გადახდა წარმატებით დასრულდა.",
    your_preferences: "თქვენი პრეფერენციები",
    your_preferences_waiting: "თქვენი პრეფერენციები მოლოდინშია",
    your_programs: "თქვენი პროგრამები",
    your_selected_permission: "არჩეული უფლებები",
    your_selected_program: "არჩეული პროგრამა",
    your_selected_classrooms: "არჩეული აუდიტორიების სია",
    yoksis_operations: "Yöksis ოპერაციები",
    yoksis_search_student: "Yöksis სტუდენტის ძიება",
    yoksis_undergraduate_transfer_list: "ჰორიზონტალური გადასვლის სია",
    yoksis_multiaction: "მასობრივი ოპერაცია",
    yoksis_student_questioning: "სტუდენტის გამოკითხვა",
    yoksis_meb_graduate_questioning: "MEB კურსდამთავრებულის გამოკითხვა",
    yoksis_lists: "სიები",
    yoksis_universities: "Yöksis უნივერსიტეტები",
    yok_notifications: "YÖK განცხადებები",
    yoksis_send_information: "Yöksis ინფორმაციის გაგზავნა",
    yoksis_student_id: "Yöksis სტუდენტის ID",
    yoksis_report_type: "Yöksis ანგარიშის ტიპი",
    yoksis_list: "Yöksis სია",
    yoksis_punish_list: "სასჯელების სია",
    yoksis_day_of_list: "ნებართვების სია",
    yoksis_prep_detail_list: "მოსამზადებელი დეტალების სია",
    yoksis_pedagogic_formation_list: "პედაგოგიური ფორმაციის სია",
    yoksis_other_universities_students_list: "სხვა უნივერსიტეტებში რეგისტრირებული სტუდენტები",
    yoksis_other_universities_active_register_students_list: "სხვა უნივერსიტეტებში აქტიური რეგისტრაციის მქონე სტუდენტები",
    yoksis_dgs_register_students_universities_list: "DGS რეგისტრირებული სტუდენტების ყველა უნივერსიტეტის ჩანაწერი",
    yoksis_graduated_and_continuing_student_list: "დამთავრებული და სწავლის გაგრძელებული სტუდენტები",
    yoksis_yok_references: "Yöksis მითითებები",
    yoksis_university_units: "Yöksis ერთეულები",
    you_dont_have_any_invoice: "ინვოისი არ გაქვთ",
    yks: "YKS",
    yoksis_results: "Yöksis შედეგები",
    yoksis_searching: "Yöksis-ში ძიება...",
    yoksis_permissions: "Yöksis ნებართვები",
    yoksis_parameter: "Yöksis პარამეტრი",
    all_permit_yok_report: "Yöksis რეგისტრაციის შეჩერების ანგარიში",

    exam_schedules_double_course_control: "ორმაგი კურსის კონტროლი",
    double_course_control: "ორმაგი კურსის კონტროლი",
    group_name: "ჯგუფის სახელი",
    group_name_en: "ჯგუფის სახელი (EN)",
    group_ticket_for: "პირიანი ჯგუფური ბილეთი",
    group_ticket_info: "ღონისძიებაში თქვენი მონაწილეობისთვის გაიცემა სპეციალური სერტიფიკატი თანამშრომლებისთვის.",
    exam_schedule_report: "გეგმაში არშემავალი საგნები",
    isThereExamSchedule: "გეგმაში არსებობს",
    bulk_approval: "მასობრივი დამტკიცება",
    bulk_message: "მასობრივი შეტყობინება",
    bulk_address_update: "მისამართების მასობრივი განახლება",
    bulk_import: "მასობრივი იმპორტი",
    bulk_delete_permit: "Yöksis მონაცემების მასობრივი წაშლა",
    bulk_note_entry: "მასობრივი ნიშნის შეყვანა",

// Z
    message_sent_student: "შეტყობინება გაიგზავნა {number} სტუდენტზე",
    application_information_is_awaited: "განაცხადის ინფორმაცია მოლოდინშია.",
    preference_information_is_awaited: "პრეფერენციის ინფორმაცია მოლოდინშია.",
    required_documents_is_awaited: "საჭირო დოკუმენტების გაგზავნა მოლოდინშია.",
    required_documents_approval_is_awaited: "საჭირო დოკუმენტების დამტკიცება მოლოდინშია.",
    your_application_has_been_accepted: "თქვენი განაცხადი მიღებულია.",
    your_application_has_been_rejected: "თქვენი განაცხადი უარყოფილია.",
    your_application_publish: "თქვენი განაცხადი დასრულდა.",
    your_application_has_been_evaluated: "თქვენი განაცხადი მიღებულია.",
    your_application_has_been_submitted: "თქვენი განაცხადი გაგზავნილია.",
    your_application_has_been_sent_successfully: "თქვენი განაცხადი წარმატებით გაიგზავნა",
    your_turkmer_application_has_been_sent_successfully: "თქვენი განაცხადი მიღებულია. პროცესის თვალყურის დევნისთვის გამოიყენეთ: https://umisapi.bau.edu.tr/turkmer/login",
    yoksis_status: "Yöksis სტატუსი",
    yok_full_scholarship_control_report: "YÖK სრული სტიპენდიის კონტროლის ანგარიში",
    undergraduate_transfer_start: "ჰორიზონტალური გადასვლის განაცხადის დასაწყებად დააჭირეთ ქვემოთ არსებულ ღილაკს",
    vinov_instructions: "Vinov მოთხოვნები",
    vinov_kvkk: "პერსონალური მონაცემების დამუშავების შესახებ ინფორმაციული ტექსტი (Vakıfbank Vinov განაცხადისთვის)",
    vinov_acik_riza: "პერსონალური მონაცემების გადაცემის თანხმობის ტექსტი (Vakıfbank Vinov განაცხადისთვის)",
    new_vinov_instruction: "ახალი Vinov მოთხოვნა",
    unidentified_payments: "უცნობი გადახდები",
    user_id: "მომხმარებლის ID",
    you_choose_courses_to_improve_your_grades_are_you_sure: "ქულების გასაუმჯობესებლად ირჩევთ საგნებს. დარწმუნებული ხართ?",

    minor_status_obj: {
        waiting: "განაცხადი მოლოდინშია",
        waiting_preference: "პრეფერენცია მოლოდინშია",
        waiting_prep_school: "მოსამზადებელი სკოლა მოლოდინშია",
        waiting_academic_unit_office: "აკადემიური ერთეული მოლოდინშია",
    },
    virman_date: "გადარიცხვის თარიღი",
    total_weekly_hours: "კვირის საათების ჯამი",
    undergraduate_hours: "ბაკალავრიატი/ასოცირებული ხარისხის საათები",
    graduate_hours: "მაგისტრატურის საათები",
    position: "პოზიცია",
    from_position: "პოზიციიდან",
    from_period: "პერიოდიდან",
    doctorate_thesis: "დოქტორის დისერტაცია",
    graduate_project: "მაგისტრატურის პროექტი",
    undergraduate_project: "ბაკალავრიატის პროექტი",
    overflow_expected_load: "მოსალოდნელ საგნების დატვირთვას გადამეტებული საათები",
    extra_course_load_to_pay: "გადახდად დამატებითი საათები",
    ktys: "ტიტულის მიხედვით კურსის საფასური",
    total_extra_course_fee: "დამატებითი კურსის ჯამური საფასური",
    to_period: "პერიოდამდე",
    monthly_fee: "ყოველთვიური გადასახადი",
    total_course_hours_load: "საგნების საერთო საათური დატვირთვა",
    uploaded_student_documents: "სტუდენტების ატვირთული დოკუმენტები",
    short_name_desc: "Z-A დალაგება",
    short_name_asc: "A-Z დალაგება",
    short_number_desc: "9-0 დალაგება",
    short_number_asc: "0-9 დალაგება",
    host_university: "მიმღები უნივერსიტეტი",
    your_reservation: "შენი რეზერვაცია",

    verification_via_sms: "SMS-ით დადასტურება",
    verification_with_authenticator_app: "Authenticator აპლიკაციით დადასტურება",
    two_factor_app_info: "Authenticator აპლიკაციით დაასკანერეთ QR კოდი, შემდეგ შეიყვანეთ მიღებული კოდი ქვემოთ მოცემულ ველში და დააჭირეთ 'დამტკიცებას'.",
    warnings: "გაფრთხილებები"

};

export default translations;
